<template>
    <div style="display: flex">
        <v-col :cols="array_selezionati.length != 0 ? 2 : 0">
            <v-card v-if="array_selezionati.length != 0" style="height: 90vh; overflow-y: auto;">
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text">
                        Selezionati: {{ array_selezionati.length }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small @click="clickResetSelezionati()">
                                <v-icon color="error">mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span>Elimina</span>
                    </v-tooltip>
                </v-toolbar>
                <v-container>
                    <v-row v-for="(item, index) in array_selezionati" :key="index">
                        <v-col cols="9">
                            {{ item.codice_ordine }}
                        </v-col>
                        <v-col cols="3">
                            <v-icon color="primary" @click="selezionaCodiceOrdine(item)">mdi-arrow-right</v-icon>
                        </v-col>

                    </v-row>
                </v-container>

            </v-card>
        </v-col>
        <v-col :cols="array_selezionati.length != 0 ? 10 : 12">

            <v-card>
                <!-- Tabella -->

                <v-data-table v-if="data_table === true" :headers="headers" fixed-header :items="servizi"
                    :items-per-page="items_per_page" :page="page_num" @update:page="pageChange" item-key="id_servizio"
                    class="elevation-1" calculate-widths height="74vh" :key="data_table_key">
                    <template #item="{ item }">
                        <tr >
                            <td>
                                <v-checkbox @change="selezionaServizi(item)" v-model="item.selected" />
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" small @click="
                                            tab = 1;
                                        carica_dettaglio = false;
                                        selectItem(item);
                                        data_table = false;
                                        ">
                                            <v-icon color="primary">mdi-pencil</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Dettagli</span>
                                </v-tooltip>
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn :disabled="item.id_viaggio == '0'" v-bind="attrs" v-on="on" small
                                            @click="getGruppoViaggi(item)">
                                            <v-icon
                                                :color="item.colore != null ? item.colore : '#cacaca'">mdi-map-check</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ item.id_gruppo_servizi }}</span>
                                </v-tooltip>
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-if="item.pianificato >= 0" v-bind="attrs" v-on="on"
                                            @click="clickIconPianificazione(item)" :color="item.pianificato == 1 ? 'success' : 'warning'
                                                ">
                                            mdi-order-bool-ascending
                                        </v-icon>
                                        <v-icon v-else-if="item.pianificato < 0" v-bind="attrs" v-on="on" color="error">
                                            {{
                                                item.pianificato == -1
                                                    ? "mdi-engine"
                                                    : item.pianificato == -2
                                                        ? "mdi-truck-cargo-container"
                                                        : "mdi-close"
                                            }}
                                        </v-icon>
                                    </template>
                                    <span>{{ item.pianificato_descrizione }}</span>
                                </v-tooltip>
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <span style="font-size: 14px;">{{ item.note }}</span>
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <span style="font-size: 15px;">{{ item.stato_documento }}</span>
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <span style="font-size: 15px;">{{ item.sigla_tipo_servizio }}</span>
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <div :style="{
                                    height: '50px',
                                    minWidth: '120px',
                                    background: item.colore_sfondo,
                                    position: 'relative',
                                    borderRadius: '6px',
                                }">
                                    <span :style="{
                                        position: 'relative',
                                        top: '28%',
                                        left: '0%',
                                        color: item.colore_testo,
                                    }">{{
                                        item.codice_ordine ? item.codice_ordine : "N/D"
                                    }}</span>
                                </div>
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <span style="font-size: 15px;">{{ item.des_azienda }}</span>
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <span style="font-size: 15px;">{{ item.riferimento }}</span>
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <span style="font-size: 14px;">{{ item.indirizzo_arrivo }}</span>
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <span style="font-size: 14px;">{{ item.localita_e_provincia }}</span>
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <span>{{
                                    item.data_minima != null ? item.data_minima : "N/D"
                                    }}</span>
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <span>{{
                                    formatData(item.ora_arrivo)
                                }}</span>
                            </td>
                            <td :class="selected_row === item.id_servizio ? 'selected-row' : ''" @click="selectRow(item)">
                                <v-select readonly class="pt-2" :items="autisti"
                                    v-model="item.id_conduttore" item-text="cognome" item-value="id_conduttore" dense
                                    label="Tecnico" @change="changeTecnico(item)" />
                            </td>
                            <td>
                                <v-select v-model="item.tempo_permanenza" :items="items_slot_attesa"
                                    style="min-width: 75px; margin-top: 15px" @change="salvaTempoPermanenza(item)" dense label="Permanenza" />
                            </td>
                            <td>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn :disabled="item.allegato == 0 || item.allegato == undefined"
                                            v-bind="attrs" v-on="on" small @click="showAllegato(item)">
                                            <v-icon color="primary">mdi-paperclip</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Allegato</span>
                                </v-tooltip>
                            </td>
                            <td>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" small @click="deleteItem(item)">
                                            <v-icon color="error">mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Elimina</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                    <!-- <template v-slot:[`item.select`]="{ item }">
                        <v-checkbox @change="selezionaServizi(item)" :disabled="item.pianificato == 1"
                            v-model="item.selected" />
                    </template>
                    <template v-slot:[`item.tecnico_assegnato`]="{ item }">
                        <v-select :readonly="item.pianificato == 1" class="pt-2" :items="autisti"
                            v-model="item.id_conduttore" item-text="cognome" item-value="id_conduttore" dense
                            label="Tecnico" @change="changeTecnico(item)" />
                    </template>
                    <template v-slot:[`item.codice_ordine`]="{ item }">
                        <div :style="{
                            height: '50px',
                            minWidth: '120px',
                            background: item.colore_sfondo,
                            position: 'relative',
                            borderRadius: '6px',
                        }">
                            <span :style="{
                                position: 'relative',
                                top: '28%',
                                left: '14%',
                                color: item.colore_testo,
                            }">{{
                                item.codice_ordine ? item.codice_ordine : "N/D"
                            }}</span>
                        </div>
                    </template>
                    <template v-slot:[`item.data_rilievo`]="{ item }">
                        <span>{{
                            item.data_inizio ? formatData(item.data_inizio) : "N/D"
                            }}</span>
                    </template>
                    <template v-slot:[`item.inizio_attivita`]="{ item }">
                        <span>{{
                            item.inizio_attivita != null
                                ? formatData(item.inizio_attivita)
                                : "N/D"
                        }}</span>
                    </template>
                    <template v-slot:[`item.elimina`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" small @click="deleteItem(item)">
                                    <v-icon color="error">mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <span>Elimina</span>
                        </v-tooltip>
                    </template> -->

                    <!-- Intestazione tabella -->
                    <template v-slot:top>
                        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                            <v-toolbar-title class="white--text">
                                Servizi Ferrara
                                <v-icon color="white"> mdi-face-agent </v-icon>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn @click="clickOttimizzaViaggi(1)" v-bind="attrs" v-on="on" small>
                                        <v-icon color="primary">
                                            mdi-expand-all-outline
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Pianifica tutto</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="array_selezionati.length != 0">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn :disabled="array_selezionati.length == 0" @click="clickOttimizzaViaggi(null)"
                                        class="mr-2 ml-2" v-bind="attrs" v-on="on" small>
                                        <v-icon color="primary">
                                            mdi-timeline-plus-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Pianifica selezionati</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="array_apri_viaggi.length != 0">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn @click="getGruppoViaggi()" class="mr-2 ml-2" v-bind="attrs" v-on="on" small>
                                        <v-icon color="primary">
                                            mdi-map-check</v-icon>
                                    </v-btn>
                                </template>
                                <span>Apri viaggi selezionati</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn @click="clickResetSelezionati" :disabled="array_selezionati.length == 0"
                                        class="mr-5" v-bind="attrs" v-on="on" small>
                                        <v-icon color="error">
                                            mdi-timeline-remove</v-icon>
                                    </v-btn>
                                </template>
                                <span>Reset selezionati</span>
                            </v-tooltip>

                            <!-- Visualizza/nascondi filtri -->
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ml-auto mr-5" v-bind="attrs" v-on="on" small @click="
                                        filters == true
                                            ? (filters = false)
                                            : (filters = true)
                                        ">
                                        <v-icon color="purple"> mdi-filter </v-icon>
                                    </v-btn>
                                </template>
                                <span v-if="filters == false">Visualizza filtri</span>
                                <span v-else>Nascondi Filtri</span>
                            </v-tooltip>
                            <!-- Reset filtri -->
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ml-auto mr-5" v-bind="attrs" v-on="on" small @click="resetFiltri">
                                        <v-icon color="error">
                                            mdi-filter-off
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Resetta Filtri</span>
                            </v-tooltip>
                            <!-- pulsante refresh -->
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ml-auto mr-5" v-bind="attrs" v-on="on" small @click="getServizi()">
                                        <v-icon color="primary"> mdi-refresh </v-icon>
                                    </v-btn>
                                </template>
                                <span>Refresh</span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                            <!-- Pulsante torna indietro -->
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn @click="goBack()" class="ml-15" v-bind="attrs" v-on="on" small>
                                        <v-icon color="error">
                                            mdi-keyboard-backspace
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Vai alla dashboard</span>
                            </v-tooltip>
                        </v-toolbar>

                        <!-- Row Filtri -->
                        <v-row v-if="filters === true" justify="center" class="ma-1">
                            <v-col cols="4">
                                <v-select class="mt-3" v-model="servizio_filter" hide-details outlined return-object
                                    :items="items_dettagli_tipo" item-text="descrizione"
                                    item-value="id_tipo_servizio_dettaglio" dense label="Seleziona il servizio"
                                    @change="filtra()" append-icon="mdi-close" @click:append="resetFilterServizio()"
                                    multiple />
                            </v-col>
                            <v-col cols="2">
                                <v-autocomplete @change="filtra" label="Stato Pianificazione"
                                    v-model="solo_non_pianificati" dense hide-details
                                    :items="items_stato_pianificazione" class="mt-5" item-text="stato_pianificato"
                                    item-value="pianificato" />
                            </v-col>
                            <v-col cols="3">
                                <v-autocomplete @change="filtra" label="Codice Ordine" v-model="codice_ordine_filter"
                                    dense hide-details :items="servizi_ori" class="mt-5" item-text="codice_ordine"
                                    item-value="codice_ordine" />
                            </v-col>
                            <v-col cols="3">
                                <v-autocomplete @change="filtra" label="Ragione Sociale" v-model="ragionesociale_filter"
                                    dense hide-details :items="servizi_ori" class="mt-5" item-text="des_azienda"
                                    item-value="des_azienda" />
                            </v-col>
                            <v-col cols="3">
                                <v-select @change="filtra" label="Sede Magazzino" v-model="sede_magazzino_filter" dense
                                    hide-details outlined multiple :items="items_sedi_magazzino" class="mt-3"
                                    item-text="descrizione" item-value="id_azienda_sede" return-object
                                    append-icon="mdi-close" @click:append="resetFilterSede()" />
                            </v-col>
                            <v-col cols="3">
                                <v-select @change="filtra" label="Tipo richiesta" v-model="richiesta_filter" dense
                                    hide-details outlined multiple :items="getTipoRichiesta()" class="mt-3"
                                    item-text="stato_documento" item-value="id_servizio" return-object
                                    append-icon="mdi-close" @click:append="resetFilterRichiesta()" />
                            </v-col>
                            <v-col cols="3">
                                <v-select @change="filtra" label="Area competenza" v-model="area_filter" dense
                                    hide-details outlined multiple :items="items_area_competenza" class="mt-3"
                                    item-text="descrizione" item-value="id_zona_master" return-object
                                    append-icon="mdi-close" @click:append="resetFilterArea()" />
                            </v-col>
                            <v-col cols="3">
                                <v-select :readonly="blocco_filtri" label="Regione" v-model="regione_sel" dense
                                    hide-details :items="items_regioni" class="mt-5" item-text="regione"
                                    item-value="id_regione" multiple />
                            </v-col>
                            <v-col cols="3">
                                <v-row>
                                    <v-select :readonly="blocco_filtri" @change="filtra" label="Provincia"
                                        v-model="provincia_sel" dense hide-details multiple :items="items_province"
                                        class="mt-8 ml-4" item-text="provincia" item-value="id_provincia" return-object
                                        append-icon="mdi-close" @click:append="provincia_sel = []" />
                                </v-row>
                            </v-col>
                            <v-col cols="2">
                                <v-autocomplete :readonly="blocco_filtri" @change="filtra" label="Comune"
                                    v-model="comune_sel" dense hide-details :items="items_comuni" class="mt-5"
                                    item-text="comune" item-value="id_comune" />
                            </v-col>
                            <v-col cols="2">
                                <v-autocomplete @change="filtra" label="Tecnico" v-model="tecnico_sel" dense
                                    hide-details :items="autisti" class="mt-5" item-text="cognome"
                                    item-value="id_conduttore" />
                            </v-col>
                            <v-col cols="1">
                                <v-btn :disabled="tecnico_sel == null" @click="openViaggioConduttore" class="mt-5"
                                    small><v-icon color="primary">mdi-map-check</v-icon></v-btn>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field v-model="data_minima_da_filter" label="Data minima dal" type="date"
                                    outlined dense :append-icon="data_minima_da_filter ? 'mdi-close-circle' : ''"
                                    @click:append="data_minima_da_filter = null" />

                            </v-col>
                            <v-col cols="2">
                                <v-text-field v-model="data_minima_a_filter" label="Data minima al" type="date" outlined
                                    dense :append-icon="data_minima_a_filter ? 'mdi-close-circle' : ''"
                                    @click:append="data_minima_a_filter = null" />
                            </v-col>

                        </v-row>
                    </template>
                    <!-- Pulsante Modifica -->
                    <template v-slot:[`item.edit`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" small @click="
                                    tab = 1;
                                carica_dettaglio = false;
                                selectItem(item);
                                data_table = false;
                                ">
                                    <v-icon color="primary">mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <span>Dettagli</span>
                        </v-tooltip>
                    </template>
                    <!-- Pulsante Report -->
                    <template v-slot:[`item.report`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" small @click="getReport(item)">
                                    <v-icon color="primary">mdi-file-document-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>Report</span>
                        </v-tooltip>
                    </template>
                    <!-- Pulsante Viaggio Panificato -->
                    <template v-slot:[`item.viaggio`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn :disabled="item.id_viaggio == '0'" v-bind="attrs" v-on="on" small
                                    @click="getGruppoViaggi(item)">
                                    <v-icon
                                        :color="item.colore != null ? item.colore : '#cacaca'">mdi-map-check</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ item.id_gruppo_servizi }}</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:[`item.scala_mobile`]="{ item }">
                        {{ item.opzioni != null ? item.opzioni[0].valore : "" }}
                    </template>
                    <template v-slot:[`item.piano`]="{ item }">
                        {{ item.opzioni != null ? item.opzioni[1].valore : "" }}
                    </template>
                    <template v-slot:[`item.allegato`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn :disabled="item.allegato == 0 || item.allegato == undefined" v-bind="attrs"
                                    v-on="on" small @click="showAllegato(item)">
                                    <v-icon color="primary">mdi-paperclip</v-icon>
                                </v-btn>
                            </template>
                            <span>Allegato</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:[`item.note`]="{ item }">
                        <span style="font-size: 14px;">{{ item.note }}</span>
                    </template>
                    <template v-slot:[`item.riferimento`]="{ item }">
                        <span style="font-size: 12px;">{{ item.riferimento }}</span>
                    </template>
                    <template v-slot:[`item.pianificato`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-if="item.pianificato >= 0" v-bind="attrs" v-on="on"
                                    @click="clickIconPianificazione(item)" :color="item.pianificato == 1 ? 'success' : 'warning'
                                        ">
                                    mdi-order-bool-ascending
                                </v-icon>
                                <v-icon v-else-if="item.pianificato < 0" v-bind="attrs" v-on="on" color="error">
                                    {{
                                        item.pianificato == -1
                                            ? "mdi-engine"
                                            : item.pianificato == -2
                                                ? "mdi-truck-cargo-container"
                                                : "mdi-close"
                                    }}
                                </v-icon>
                            </template>
                            <span>{{ item.pianificato_descrizione }}</span>
                        </v-tooltip>
                    </template>
                    <!-- TAG GOOGLE -->
                    <template v-slot:[`item.google`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" :color="item.distanza != null &&
                                    item.tempo_percorrenza != null
                                    ? 'success'
                                    : 'warning'
                                    ">mdi-google-maps</v-icon>
                            </template>
                            <span v-if="
                                item.distanza != null &&
                                item.tempo_percorrenza != null
                            ">Calcolo del percorso riuscito</span>
                            <span v-else>Calcolo del percorso fallito</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:[`item.data_imballo`]="{ item }">
                        <span style="font-style: italic;">{{ formatData(item.data_imballo) }}</span>
                    </template>
                    <template v-slot:[`item.data_minima`]="{ item }">
                        <span>{{
                            item.data_minima != "" && item.data_minima != null
                                ? item.data_minima
                                : "n.d."
                        }}</span>
                    </template>
                    <template v-slot:[`item.data_inizio`]="{ item }">
                        <span v-if="item.data_inizio != null">{{
                            formatData(item.data_inizio)
                            }}</span>
                    </template>
                    <template v-slot:[`item.inizio_attivita`]="{ item }">
                        <span>{{
                            item.inizio_attivita != "0001-01-01T00:00:00"
                                ? formatDataOra(item.inizio_attivita)
                                : "N/D"
                        }}</span>
                    </template>
                    <template v-slot:[`item.data_fine`]="{ item }">
                        <span v-if="item.data_fine != null">{{
                            formatData(item.data_fine)
                            }}</span>
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" small @click="
                                    selectItem(item);
                                delete_dialog = true;
                                ">
                                    <v-icon color="error">mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <span>Elimina</span>
                        </v-tooltip>
                    </template>
                </v-data-table>

                <template v-if="data_table === false">
                    <v-card min-height="70vh">
                        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                            <v-toolbar-title class="white--text">
                                Servizi
                                <v-icon color="white"> mdi-face-agent </v-icon>
                            </v-toolbar-title>
                            <v-spacer />
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ml-5" @click="salvaServizio()" v-bind="attrs" v-on="on" small>
                                        <v-icon color="success"> mdi-floppy </v-icon>
                                    </v-btn>
                                </template>
                                <span>Salva modifiche</span>
                            </v-tooltip>

                            <v-spacer />
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ml-auto" @click="resetTab()" v-bind="attrs" v-on="on" small>
                                        <v-icon color="error">
                                            mdi-keyboard-backspace
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Indietro</span>
                            </v-tooltip>
                        </v-toolbar>

                        <v-tabs v-model="tab" align-with-title>
                            <v-tabs-slider color="transparent"></v-tabs-slider>
                            <v-tab active-class="sfondoStandard" class="py-0 my-0">
                                Generale
                            </v-tab>
                            <v-tab active-class="sfondoStandard" class="py-0 my-0">
                                Opzioni
                            </v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab">
                            <v-tab-item>
                                <QLGeneraleSFQ @aggiornaTipoPagamento="
                                    aggiornaTipoPagamentoOpzioni
                                " ref="createEdit" :selected_item="selected_item" />
                                <!--:items_azienda="items_azienda"-->
                            </v-tab-item>
                            <v-tab-item>
                                <QLOpzioniSFQ ref="createDettaglio" @GetDettagliServizio="
                                    getDettagliServizio();
                                getServizi();
                                " @dettaglio_caricato="
                                    tab = !carica_dettaglio ? 0 : tab;
                                carica_dettaglio = true;
                                " :servizio="selected_item" :id_pagamento_default="id_pagamento_default"
                                    :id_azienda="selected_item.id_azienda" />
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card>
                </template>

                <!-- Dialog Delete -->
                <v-dialog persistent v-model="delete_dialog" width="550px">
                    <v-card>
                        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                            <v-toolbar-title class="white--text">
                                Elimina Servizio
                            </v-toolbar-title>
                            <v-spacer />
                            <!-- Pulsante di conferma eliminazione -->
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ml-auto mr-5"
                                        @click="selected_item.id_servizio != 0 ? eliminaServizioDef() : deletePausa()"
                                        v-bind="attrs" v-on="on" small>
                                        <v-icon color="success"> mdi-floppy </v-icon>
                                    </v-btn>
                                </template>
                                <span>Conferma</span>
                            </v-tooltip>
                            <v-spacer />
                            <!-- Pulsante annulla eliminazione -->
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" small @click="delete_dialog = false">
                                        <v-icon color="error">mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Annulla</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-card-text class="pa-10">
                            <h2>
                                {{
                                    selected_item.id_servizio != 0 ?
                                        "Sei sicuro di voler eliminare il servizio?"
                                        : "Sei sicuro di voler eliminare la pausa?"
                                }}
                            </h2>
                        </v-card-text>
                    </v-card>
                    <v-overlay :value="overlay3">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-dialog>


                <!-- Dialog Note -->
                <v-dialog persistent v-model="dialog_note" width="600px">
                    <v-card>
                        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                            <v-toolbar-title class="white--text">
                                Note Servizio
                            </v-toolbar-title>
                            <v-spacer />
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" small @click="dialog_note = false; note_sel = '';">
                                        <v-icon color="error">mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-card-text class="pa-10">
                            <h4>{{ nota_sel != null ? nota_sel : "Nessuna nota per il servizio selezionato." }}</h4>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <!-- Dialog CONFERMA -->
                <v-dialog persistent v-model="dialog_conferma_ott" width="600px">
                    <v-card>
                        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                            <v-toolbar-title class="white--text">
                                Conferma Salvataggio
                            </v-toolbar-title>
                            <v-spacer />
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" small @click="ottimizzaGruppoViaggi()">
                                        <v-icon color="success">mdi-floppy</v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                            <v-spacer />
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" small @click="dialog_conferma_ott = false;">
                                        <v-icon color="error">mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-card-text class="pa-10">
                            <h2>Confermi il salvataggio del viaggio?</h2>
                        </v-card-text>
                    </v-card>
                    <v-overlay :value="overlay2">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-dialog>

                <!-- Dialog ripianifica -->
                <v-dialog persistent v-model="ripianifica_dialog" width="550px">
                    <v-card min-height="25vh">
                        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                            <v-toolbar-title class="white--text">
                                Ripianifica
                            </v-toolbar-title>
                            <v-spacer />
                            <!-- Pulsante di conferma ripianificazione -->
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ml-auto mr-5" @click="setRipianificaServiziMultipli()" v-bind="attrs"
                                        v-on="on" small>
                                        <v-icon color="success"> mdi-floppy </v-icon>
                                    </v-btn>
                                </template>
                                <span>Conferma</span>
                            </v-tooltip>
                            <v-spacer />
                            <!-- Pulsante annulla eliminazione -->
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" small @click="ripianifica_dialog = false">
                                        <v-icon color="error">mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Annulla</span>
                            </v-tooltip>
                        </v-toolbar>
                        <br />
                        <v-card-text class="mt-10">
                            <h2>
                                Sei sicuro di voler ripianificare i servizi selezionati?
                            </h2>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <!-- Dialog gestione aziende -->
                <v-dialog persistent class="ma-0 pa-0" v-model="dialog_gestione_aziende">
                    <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                        <v-toolbar-title class="white--text">
                            Gestione Aziende
                        </v-toolbar-title>
                        <v-spacer />
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="dialog_gestione_aziende = false" class="ml-auto" v-bind="attrs" v-on="on"
                                    small>
                                    <v-icon color="error"> mdi-close </v-icon>
                                </v-btn>
                            </template>
                            <span>Chiudi</span>
                        </v-tooltip>
                    </v-toolbar>
                    <v-card class="ma-0 pa-0" height="85vh" style="overflow: hidden">
                        <div style="position: relative; height: 100%" class="ma-0 pa-0">
                            <WindowFrame class="ma-n3 pa-0" :component="componenteWF" ref="windowframe"
                                :input_args="inputArgs" />
                        </div>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialog_pdf" width="1030">
                    <v-card>
                        <v-toolbar class="indigo white--text" dense>
                            <v-toolbar-title class="white--text">
                                Report Servizi</v-toolbar-title>
                            <v-spacer></v-spacer>

                            <v-tooltip bottom v-if="multi_page">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="
                                        current_page > 0
                                            ? current_page--
                                            : (current_page = current_page)
                                        " small class="mr-10">
                                        <v-icon color="primary">
                                            mdi-arrow-left
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Pagina precedente</span>
                            </v-tooltip>

                            <v-tooltip bottom v-if="multi_page">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="
                                        current_page < pdfs.length - 1
                                            ? current_page++
                                            : (current_page = current_page)
                                        " small>
                                        <v-icon color="primary">
                                            mdi-arrow-right
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Prossima pagina</span>
                            </v-tooltip>

                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="dialog_pdf = false" small>
                                        <v-icon class="error--text"> mdi-close </v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-progress-linear indeterminate color="cyan" v-if="loading" id="progress">
                        </v-progress-linear>
                        <v-col cols="12">
                            <iframe :src="multi_page ? pdfs[current_page] : iframeUrl" frameborder="0" style="
                            height: 70vh !important;
                            width: 1000px !important;
                        ">
                            </iframe>
                        </v-col>
                    </v-card>
                </v-dialog>

                <!-- DIALOG GESTIONE PIANIFICAZIONE-->
                <v-dialog v-model="dialog_elimina_sched" width="500px">
                    <v-card>
                        <v-toolbar class="indigo white--text" dense>
                            <v-toolbar-title class="white--text">Gestisci Pianificazione</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn class="mr-2" v-on="on" small @click="eliminaServizio">
                                        <v-icon color="success"> mdi-floppy </v-icon>
                                    </v-btn>
                                </template>
                                <span>Salva</span>
                            </v-tooltip>

                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="
                                        dialog_elimina_sched = false;
                                    servizio_sel = null;
                                    " small>
                                        <v-icon class="error--text"> mdi-close </v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-container>
                            <v-row class="ma-4">
                                Vuoi eliminare la schedulazione del servizio
                                {{ servizio_sel?.codice }}?
                            </v-row>
                        </v-container>
                    </v-card>
                </v-dialog>

                <!-- DIALOG GESTIONE partenza ott.-->
                <v-dialog persistent v-model="dialog_gestione_partenza" width="70%">
                    <v-card>
                        <v-toolbar class="indigo white--text" dense>
                            <v-toolbar-title class="white--text">Partenza</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn :disabled="partenza_sel.latitudine_partenza != null && partenza_sel.longitudine_partenza != null"
                class="mr-2" v-on="on" small @click="getCoordinate">
                <v-icon color="primary"> mdi-map-check </v-icon>
              </v-btn>
            </template>
            <span>Ottieni Coordinate</span>
          </v-tooltip> -->
                            <v-spacer></v-spacer>
                            <v-text-field class="mt-7" outlined dark dense v-model="partenza_sel.data_inizio"
                                label="Data Inizio" type="date" />
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn class="mr-2" v-on="on" small
                                        @click="!mode_pianificazione ? ottimizzaServiziSelezionati() : btn_ottimizzazione != null ? ottimizzaGruppoViaggi(2) : pianificaOttimizzati(null)">
                                        <v-icon color="success"> mdi-floppy </v-icon>
                                    </v-btn>
                                </template>
                                <span>Salva</span>
                            </v-tooltip>

                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="closePartenza" small>
                                        <v-icon class="error--text"> mdi-close </v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-container>
                            <v-row class="mt-2">
                                <v-col cols="4">
                                    <v-select v-model="azione_sel.id_azione" :items="items_azioni" dense
                                        item-text="des_azione" item-value="id_azione"
                                        label="Modalità di ottimizzazione" />
                                </v-col>
                                <v-col cols="4">
                                    <v-select v-model="azione_sel.id_distribuzione" :items="items_distribuzione" dense
                                        item-text="des_azione" item-value="id_azione"
                                        label="Modalità di distribuzione" />
                                </v-col>
                                <v-col cols="4">
                                    <v-select v-model="azione_sel.id_equiparazione" :items="items_equiparazione" dense
                                        item-text="des_azione" item-value="id_azione"
                                        label="Modalità di equiparazione" />
                                </v-col>
                            </v-row>
                            <v-row>
                            </v-row>
                            <v-row v-for="(item, index) in items_sedi_conduttore_vis" :key="index">
                                <v-col cols="1">
                                    <v-checkbox dense v-model="item.selected" />
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field dense v-model="item.cognome" readonly label="Conduttore">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-select v-model="item.default_partenza" :items="item.sedi" item-text="sede"
                                        return-object dense label="Seleziona la sede partenza"
                                        @change="changeSedeConduttore(item)" />
                                </v-col>
                                <v-col cols="3">
                                    <v-select v-model="item.default_arrivo" :items="item.sedi" item-text="sede"
                                        return-object dense label="Seleziona la sede arrivo"
                                        @change="changeSedeConduttore(item)" />
                                </v-col>
                                <v-col cols="2">
                                    <v-select v-model="item.ora_primo_arrivo" :items="item.default_partenza?.slot_orari_primo_appuntamento
                                        " dense label="Ora arrivo" />
                                </v-col>
                            </v-row>
                            <!-- <v-row>
            <v-col>
              <v-menu ref="menu-a" v-model="menu_a" :close-on-content-click="false" transition="scale-transition"
                offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field append-icon="mdi-close" @click:append="partenza_sel.data_inizio = ''" dense
                    v-model="data_sel" label="Data Inizio" autocomplete="off" persistent-hint
                    prepend-icon="mdi-calendar" v-bind="attrs" v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker @change="formatDataInizio" v-model="partenza_sel.data_inizio" no-title locale="it">
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-text-field @change="changeSedeIndirizzo" label="Indirizzo" v-model="partenza_sel.indirizzo_partenza"
                dense hide-details />
            </v-col>
            <v-col cols="2">
              <v-text-field label="Civico" v-model="partenza_sel.civico_partenza" dense hide-details />
            </v-col>
            <v-col cols="8">
              <v-text-field label="Località" v-model="partenza_sel.localita_partenza" dense hide-details />
            </v-col>
            <v-col cols="2">
              <v-text-field label="CAP" v-model="partenza_sel.cap_partenza" dense hide-details />
            </v-col>
            <v-col cols="2">
              <v-text-field label="Provincia" v-model="partenza_sel.provincia_partenza" dense hide-details />
            </v-col>
            <v-col cols="6">
              <v-text-field label="Latitudine" v-model="partenza_sel.latitudine_partenza" dense hide-details />
            </v-col>
            <v-col cols="6">
              <v-text-field label="Longitudine" v-model="partenza_sel.longitudine_partenza" dense hide-details />
            </v-col>
          </v-row> -->
                        </v-container>
                    </v-card>
                    <v-overlay :value="overlay2">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-dialog>



                <!-- DIALOG GESTIONE ottimizzati-->
                <v-dialog persistent v-model="dialog_ottimizzati">
                    <v-card>
                        <v-toolbar class="indigo white--text" dense>
                            <v-toolbar-title class="white--text">
                                Viaggio -
                                {{autisti?.filter(e => e.id_conduttore ==
                                    items_ottimizzati[0]?.id_conduttore)[0]?.cognome !=
                                    undefined
                                    ?
                                    " " + autisti?.filter(e => e.id_conduttore ==
                                        items_ottimizzati[0]?.id_conduttore)[0]?.cognome :
                                    " " + autisti?.filter(e => e.id_conduttore == servizi.filter(s =>
                                        s.selected)[0]?.id_conduttore)[0]?.cognome
                                }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn :disabled="conduttore_filter == null ||
                                        data_da_filter_ott == null ||
                                        data_a_filter_ott == null
                                        " @click="stampaReport()" class="mr-4" v-on="on" small>
                                        <v-icon color="error">
                                            mdi-file-pdf-box
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Report</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn :disabled="servizi_gruppo_viaggio == false" @click="openDialogAggServizi"
                                        class="mr-1" v-on="on" small>
                                        <v-icon color="primary">
                                            mdi-timeline-plus
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Agg. Servizio</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn :disabled="servizi_gruppo_viaggio == false" @click="dialog_agg_tappa = true"
                                        class="mr-1" v-on="on" small>
                                        <v-icon color="primary"> mdi-plus </v-icon>
                                    </v-btn>
                                </template>
                                <span>Agg. Tappa</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn :disabled="servizi_gruppo_viaggio == false" @click="addPauseBreak"
                                        class="mr-4" v-on="on" small>
                                        <v-icon color="primary">
                                            mdi-timer-pause
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Agg. Pausa</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <!-- devo modificare la logica delle chiamate -->
                                    <v-btn :disabled="servizi_gruppo_viaggio == false"
                                        @click="conduttoriPianificaOttimizzati(3)" class="mr-1" v-on="on" small>
                                        <v-icon color="primary">
                                            mdi-progress-check
                                        </v-icon>
                                    </v-btn>
                                    <!-- <v-btn @click="
                                id_conduttore_sel
                                    ? ottimizzaGruppoViaggi(null)
                                    : ottimizzaViaggi(null, 2)
                                " class="mr-1" v-on="on" small>
                                <v-icon color="primary">
                                    mdi-progress-check
                                </v-icon>
                            </v-btn> -->
                                </template>
                                <span>Salva ordinamento</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn :disabled="servizi_gruppo_viaggio == false"
                                        @click="conduttoriPianificaOttimizzati(4)" class="mr-1" v-on="on" small>
                                        <v-icon color="primary"> mdi-history </v-icon>
                                    </v-btn>
                                    <!-- <v-btn @click="
                                id_conduttore_sel
                                    ? ottimizzaGruppoViaggi(1)
                                    : ottimizzaViaggi(1)
                                " class="mr-1" v-on="on" small>
                                <v-icon color="primary"> mdi-history </v-icon>
                            </v-btn> -->
                                </template>
                                <span>Salva ordinamento ottimizzato</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn class="mr-1" v-on="on" small
                                        @click="servizi_gruppo_viaggio ? conduttoriPianificaOttimizzati(null) : pianificaOttimizzati(null)">
                                        <v-icon color="success"> mdi-floppy </v-icon>
                                    </v-btn>
                                </template>
                                <span>Salva pianificazione</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn :disabled="servizi_gruppo_viaggio == false"
                                        @click="conduttoriPianificaOttimizzati(1)" class="mr-4" v-on="on" small>
                                        <v-icon color="success">
                                            mdi-cog-counterclockwise
                                        </v-icon>
                                    </v-btn>
                                    <!-- <v-btn :disabled="servizi_gruppo_viaggio == false" @click="
                                id_conduttore_sel
                                    ? ottimizzaGruppoViaggi(2)
                                    : ottimizzaViaggi(2)
                                " class="mr-2" v-on="on" small>
                                <v-icon color="success">
                                    mdi-cog-counterclockwise
                                </v-icon>
                            </v-btn> -->
                                </template>
                                <span>Salva e pianifica ordinamento manuale</span>
                            </v-tooltip>

                            <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn :disabled="ordine_cambiato" class="mr-2" v-on="on" small @click="pianificaOttimizzati(1)">
                <v-icon color="primary"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Simula pianificazione</span>
          </v-tooltip> -->
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn class="mr-4" v-on="on" @click="openMapsOttimizzati" small>
                                        <v-icon color="primary">
                                            mdi-google-maps
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Visualizza mappa</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn :disabled="servizi_gruppo_viaggio == false" class="mr-4" v-on="on"
                                        @click="openAzioneGiornata" small>
                                        <v-icon color="primary">
                                            mdi-timetable
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Azione giornata</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn :disabled="servizi_gruppo_viaggio == false" class="mr-4" v-on="on"
                                        @click="getGruppoViaggi()" small>
                                        <v-icon color="primary">
                                            mdi-sync
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Aggiorna</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn :disabled="servizi_gruppo_viaggio == false" class="mr-4" v-on="on" small
                                        @click="dialogEliminaViaggio">
                                        <v-icon color="error"> mdi-delete </v-icon>
                                    </v-btn>
                                </template>
                                <span>Elimina viaggio</span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn :disabled="servizi_gruppo_viaggio" v-on="on" class="mr-4" small
                                        @click="indietro">
                                        <v-icon color="error">
                                            mdi-arrow-left-thin
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Indietro</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="closeOttimizzati" small>
                                        <v-icon class="error--text"> mdi-close </v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-container>
                            <v-row justify="center" align="center">
                                <v-col cols="3">
                                    <v-select v-model="conduttore_filter" outlined :items="getConduttoriSelect()"
                                        item-text="cognome" item-value="id_conduttore" dense label="Conduttore"
                                        @change="changeConduttoreFilter()" style="min-width: 100px">
                                        <template v-slot:append>
                                            <v-icon v-if="conduttore_filter" small class="mr-2 mt-1"
                                                @click="resetConduttoreFilter">
                                                mdi-close
                                            </v-icon>
                                        </template>
                                    </v-select>

                                </v-col>

                                <v-col cols="2">
                                    <v-text-field outlined dense v-model="data_da_filter_ott" label="Dal" type="date" />

                                </v-col>
                                <v-col cols="2">
                                    <v-text-field outlined dense v-model="data_a_filter_ott" label="al" type="date" />
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field outlined dense v-model="dataminima_da_filter" label="Data minima dal"
                                        type="date" />

                                </v-col>
                                <v-col cols="2">
                                    <v-text-field outlined dense v-model="dataminima_a_filter" label="Data minima al"
                                        type="date" />
                                </v-col>
                                <v-col cols="1">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" style="margin-top: -25px" @click="resetFiltriOtt()" small>
                                                <v-icon color="primary">
                                                    mdi-filter-off
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Reset filtri</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </v-container>


                        <div class="table-container">
                            <v-data-table :headers="headers_ott" fixed-header height="75vh" :items="items_ottimizzati"
                                :items-per-page="per_pagina" @update:page="onPageChange" :page.sync="pagina_corrente"
                                :key="key_table" class="fixed-column-table">
                                <template v-slot:body="{ items }">
                                    <!-- Involucro draggable -->
                                    <draggable tag="tbody" :list="items" handle=".drag-handle"
                                        :options="draggableOptions" @end="onDragEnd" :move="checkMove">
                                        <tr v-for="(item, index) in items"
                                            :class="selected_row === item.id_servizio ? 'selected-row' : item.spostato === 1 ? 'riga-spostata' : ''"
                                            :key="item.id_servizio || item.id || index" @click="selectRow(item)">
                                            <!-- Colonna per drag -->
                                            <td class="sticky-col">
                                                <v-icon class="drag-handle" style="cursor: grab;">mdi-drag</v-icon>
                                            </td>
                                            <td>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn @click="showNote(item)" v-bind="attrs" v-on="on" small>
                                                            <v-icon color="primary">mdi-notebook-multiple</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Note</span>
                                                </v-tooltip>
                                            </td>

                                            <td>
                                                <span> {{ item.stato_documento }}</span>
                                            </td>

                                            <td>
                                                <v-select style="min-width: 120px" class="pt-2" :items="autisti"
                                                    @change="changeConduttore(item)" v-model="item.id_conduttore"
                                                    item-text="cognome" item-value="id_conduttore" dense
                                                    label="Tecnico" />
                                            </td>
                                            <td>
                                                <span> {{ item.des_azienda }}</span>
                                            </td>
                                            <td>
                                                <span> {{ item.sigla_tipo_servizio }}</span>
                                            </td>
                                            <td>
                                                <div style="display: flex">
                                                    <v-icon @click="changeSedePause(item)"
                                                        v-if="item.codice_ordine == 'FINE GIORNATA' || item.codice_ordine == 'FINE VIAGGIO'"
                                                        :style="{
                                                            position: 'relative',
                                                            cursor: 'pointer',
                                                        }" color="primary">
                                                        mdi-refresh
                                                    </v-icon>
                                                    <div :style="{
                                                        padding: '10px',
                                                        background: item.colore_sfondo,
                                                        borderRadius: '6px',
                                                    }">
                                                        <span :style="{
                                                            position: 'relative',
                                                            color: item.colore_testo,
                                                        }">{{ item.codice_ordine
                                                            ? item.codice_ordine
                                                            : "N/D"
                                                        }}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span> {{ item.numero_marker }}</span>
                                            </td>


                                            <td>
                                                <span> {{ item.riferimento }}</span>
                                            </td>
                                            <td>
                                                <span> {{ item.indirizzo_arrivo }}</span>
                                            </td>
                                            <td>
                                                <span> {{ item.localita_arrivo }}</span>
                                            </td>
                                            <td>
                                                <span> {{ item.provincia_arrivo }}</span>
                                            </td>
                                            <td>
                                                {{ item.opzioni != null ? item.opzioni[0].valore : "" }}
                                            </td>
                                            <td>
                                                {{ item.opzioni != null ? item.opzioni[1].valore : "" }}
                                            </td>
                                            <!-- <td>
                                                <span style="font-style: italic;">{{
                                                    item.data_imballo != "0001-01-01T00:00:00" && item.data_imballo !=
                                                        null
                                                        ? formatDataOra(item.data_imballo)
                                                        : "n.d."
                                                }}</span>
                                            </td> -->
                                            <td>
                                                <span>{{ formatData(item.data_minima) }}</span>
                                            </td>
                                            <td>
                                                <v-text-field readonly v-model="item.data_manuale" label="Data"
                                                    type="datetime-local" />
                                            </td>
                                            <td>
                                                <v-text-field @change="cambioOraArrivo(item)" v-model="item.ora_arrivo"
                                                    label="Data e ora" type="datetime-local" />
                                            </td>
                                            <td>
                                                <span> {{ formatDataOra(item.ora_ripartenza) }}</span>
                                            </td>
                                            <td>
                                                <v-select v-model="item.tempo_permanenza" :items="items_slot_attesa"
                                                    style="min-width: 75px; margin-top: 15px" @change="item" dense
                                                    label="Permanenza" />
                                            </td>

                                            <td>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            :disabled="item.allegato == 0 || item.allegato == undefined"
                                                            v-bind="attrs" v-on="on" small @click="showAllegato(item)">
                                                            <v-icon color="primary">mdi-paperclip</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Allegato</span>
                                                </v-tooltip>
                                            </td>
                                            <td>
                                                <v-btn @click="eliminaOttimizzati(item, index)" small>
                                                    <v-icon color="error">mdi-close</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </draggable>
                                </template>
                            </v-data-table>

                            <!-- <v-data-table :headers="headers_ott" :items="items_ottimizzati" fixed-header height="75vh"
                                class="fixed-column-table" :items-per-page="per_pagina" @update:page="onPageChange"
                                :page.sync="pagina_corrente" :key="key_table">
                                <template v-slot:body="{ items }">
                                    <draggable v-model="items_ottimizzati" tag="tbody" handle=".drag-handle" :options="{
                                        animation: 200,
                                        scroll: true,
                                        scrollSensitivity: 60,
                                        scrollSpeed: 15,
                                        ghostClass: 'drag-ghost',
                                        chosenClass: 'drag-chosen',
                                    }" @end="onDragEnd">
                                        <tr v-for="(item, index) in items" :key="item.id">
                                            <td class="sticky-col">
                                                <v-btn class="mr-2" @click="moveUp(item)" x-small>
                                                    <v-icon>mdi-menu-up</v-icon>
                                                </v-btn>
                                                <v-btn @click="moveDown(item)" x-small>
                                                    <v-icon>mdi-menu-down</v-icon>
                                                </v-btn>
                                            </td>
                                            <td>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn @click="showNote(item)" v-bind="attrs" v-on="on" small>
                                                            <v-icon color="primary">mdi-notebook-multiple</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Note</span>
                                                </v-tooltip>
                                            </td>

                                            <td>
                                                <span> {{ item.stato_documento }}</span>
                                            </td>

                                            <td>
                                                <v-select style="min-width: 120px" class="pt-2" :items="autisti"
                                                    @change="changeConduttore(item)" v-model="item.id_conduttore"
                                                    item-text="cognome" item-value="id_conduttore" dense
                                                    label="Tecnico" />
                                            </td>
                                            <td>
                                                <span> {{ item.des_azienda }}</span>
                                            </td>
                                            <td>
                                                <span> {{ item.sigla_tipo_servizio }}</span>
                                            </td>
                                            <td>
                                                <div style="display: flex">
                                                    <v-icon @click="changeSedePause(item)"
                                                        v-if="item.codice_ordine == 'FINE GIORNATA' || item.codice_ordine == 'FINE VIAGGIO'"
                                                        :style="{
                                                            position: 'relative',
                                                            cursor: 'pointer',
                                                        }" color="primary">
                                                        mdi-refresh
                                                    </v-icon>
                                                    <div :style="{
                                                        padding: '10px',
                                                        background: item.colore_sfondo,
                                                        borderRadius: '6px',
                                                    }">
                                                        <span :style="{
                                                            position: 'relative',
                                                            color: item.colore_testo,
                                                        }">{{ item.codice_ordine
                                                            ? item.codice_ordine
                                                            : "N/D"
                                                        }}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span> {{ item.numero_marker }}</span>
                                            </td>


                                            <td>
                                                <span> {{ item.riferimento }}</span>
                                            </td>
                                            <td>
                                                <span> {{ item.indirizzo_arrivo }}</span>
                                            </td>
                                            <td>
                                                <span> {{ item.localita_arrivo }}</span>
                                            </td>
                                            <td>
                                                <span> {{ item.provincia_arrivo }}</span>
                                            </td>
                                            <td>
                                                {{ item.opzioni != null ? item.opzioni[0].valore : "" }}
                                            </td>
                                            <td>
                                                {{ item.opzioni != null ? item.opzioni[1].valore : "" }}
                                            </td>
                                            <td>
                                                <span style="font-style: italic;">{{
                                                    item.data_imballo != "0001-01-01T00:00:00" && item.data_imballo !=
                                                        null
                                                        ? formatDataOra(item.data_imballo)
                                                        : "n.d."
                                                }}</span>
                                            </td>
                                            <td>
                                                <span>{{
                                                    item.data_minima != "0001-01-01T00:00:00" && item.data_minima !=
                                                        null
                                                        ? formatData(item.data_minima)
                                                        : "n.d."
                                                }}</span>
                                            </td>
                                            <td>
                                                <v-text-field readonly v-model="item.data_manuale" label="Data"
                                                    type="datetime-local" />
                                            </td>
                                            <td>
                                                <v-text-field @change="cambioOraArrivo(item)" v-model="item.ora_arrivo"
                                                    label="Data e ora" type="datetime-local" />
                                            </td>
                                            <td>
                                                <span> {{ formatDataOra(item.ora_ripartenza) }}</span>
                                            </td>
                                            <td>
                                                <v-select v-model="item.tempo_permanenza" :items="items_slot_attesa"
                                                    style="min-width: 75px; margin-top: 15px" @change="item" dense
                                                    label="Permanenza" />
                                            </td>

                                            <td>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            :disabled="item.allegato == 0 || item.allegato == undefined"
                                                            v-bind="attrs" v-on="on" small @click="showAllegato(item)">
                                                            <v-icon color="primary">mdi-paperclip</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Allegato</span>
                                                </v-tooltip>
                                            </td>
                                            <td>
                                                <v-btn @click="eliminaOttimizzati(item, index)" small>
                                                    <v-icon color="error">mdi-close</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </draggable>
                                </template>
                            </v-data-table> -->
                            <!-- <v-data-table :headers="headers_ott" :items="items_ottimizzati" fixed-header height="75vh"
                                class="fixed-column-table" :items-per-page="per_pagina" @update:page="onPageChange"
                                :page.sync="pagina_corrente" :key="key_table">
                                <template v-slot:body="{ items }">
                                    <tbody>
                                        <tr v-for="(item, index) in items" :key="item.id">
                                            <td class="sticky-col">
                                                <v-btn class="mr-2" @click="moveUp(item)" x-small>
                                                    <v-icon>mdi-menu-up</v-icon>
                                                </v-btn>
                                                <v-btn @click="moveDown(item)" x-small>
                                                    <v-icon>mdi-menu-down</v-icon>
                                                </v-btn>
                                            </td>
                                            <td>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn @click="showNote(item)" v-bind="attrs" v-on="on" small>
                                                            <v-icon color="primary">mdi-notebook-multiple</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Note</span>
                                                </v-tooltip>
                                            </td>

                                            <td>
                                                <span> {{ item.stato_documento }}</span>
                                            </td>

                                            <td>
                                                <v-select style="min-width: 120px" class="pt-2" :items="autisti"
                                                    @change="changeConduttore(item)" v-model="item.id_conduttore"
                                                    item-text="cognome" item-value="id_conduttore" dense
                                                    label="Tecnico" />
                                            </td>
                                            <td>
                                                <span> {{ item.des_azienda }}</span>
                                            </td>
                                            <td>
                                                <span> {{ item.sigla_tipo_servizio }}</span>
                                            </td>
                                            <td>
                                                <div style="display: flex">
                                                    <v-icon @click="changeSedePause(item)"
                                                        v-if="item.codice_ordine == 'FINE GIORNATA' || item.codice_ordine == 'FINE VIAGGIO'"
                                                        :style="{
                                                            position: 'relative',
                                                            cursor: 'pointer',
                                                        }" color="primary">
                                                        mdi-refresh
                                                    </v-icon>
                                                    <div :style="{
                                                        padding: '10px',
                                                        background: item.colore_sfondo,
                                                        borderRadius: '6px',
                                                    }">
                                                        <span :style="{
                                                            position: 'relative',
                                                            color: item.colore_testo,
                                                        }">{{ item.codice_ordine
                                                    ? item.codice_ordine
                                                    : "N/D"
                                                            }}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span> {{ item.numero_marker }}</span>
                                            </td>


                                            <td>
                                                <span> {{ item.riferimento }}</span>
                                            </td>
                                            <td>
                                                <span> {{ item.indirizzo_arrivo }}</span>
                                            </td>
                                            <td>
                                                <span> {{ item.localita_arrivo }}</span>
                                            </td>
                                            <td>
                                                <span> {{ item.provincia_arrivo }}</span>
                                            </td>
                                            <td>
                                                {{ item.opzioni != null ? item.opzioni[0].valore : "" }}
                                            </td>
                                            <td>
                                                {{ item.opzioni != null ? item.opzioni[1].valore : "" }}
                                            </td>
                                            <td>
                                                <span style="font-style: italic;">{{
                                                    item.data_imballo != "0001-01-01T00:00:00" && item.data_imballo !=
                                                        null
                                                        ? formatDataOra(item.data_imballo)
                                                    : "n.d."
                                                    }}</span>
                                            </td>
                                            <td>
                                                <span>{{
                                                    item.data_minima != "0001-01-01T00:00:00" && item.data_minima !=
                                                        null
                                                        ? formatData(item.data_minima)
                                                    : "n.d."
                                                    }}</span>
                                            </td>
                                            <td>
                                                <v-text-field readonly v-model="item.data_manuale" label="Data"
                                                    type="datetime-local" />
                                            </td>
                                            <td>
                                                <v-text-field @change="cambioOraArrivo(item)" v-model="item.ora_arrivo"
                                                    label="Data e ora" type="datetime-local" />
                                            </td>
                                            <td>
                                                <span> {{ formatDataOra(item.ora_ripartenza) }}</span>
                                            </td>
                                            <td>
                                                <v-select v-model="item.tempo_permanenza" :items="items_slot_attesa"
                                                    style="min-width: 75px; margin-top: 15px" @change="item" dense
                                                    label="Permanenza" />
                                            </td>

                                            <td>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            :disabled="item.allegato == 0 || item.allegato == undefined"
                                                            v-bind="attrs" v-on="on" small @click="showAllegato(item)">
                                                            <v-icon color="primary">mdi-paperclip</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Allegato</span>
                                                </v-tooltip>
                                            </td>
                                            <td>
                                                <v-btn @click="eliminaOttimizzati(item, index)" small>
                                                    <v-icon color="error">mdi-close</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-data-table> -->
                            <!-- <v-data-table :headers="headers_ott" fixed-header height="75vh" :items="items_ottimizzati"
                        :items-per-page="per_pagina" @update:page="onPageChange" :page.sync="pagina_corrente"
                        :key="key_table" class="fixed-column-table">
                        <template v-slot:[`item.ordina`]="{ item }">
                            <div style="width: 100px">
                                <v-btn class="mr-2" @click="moveUp(item)" x-small>
                                    <v-icon> mdi-menu-up </v-icon>
                                </v-btn>
                                <v-btn @click="moveDown(item)" x-small>
                                    <v-icon> mdi-menu-down </v-icon>
                                </v-btn>
                            </div>
                        </template>
                        <template v-slot:[`item.allegato`]="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn :disabled="item.allegato == 0 || item.allegato == undefined" v-bind="attrs"
                                        v-on="on" small @click="showAllegato(item)">
                                        <v-icon color="primary">mdi-paperclip</v-icon>
                                    </v-btn>
                                </template>
                                <span>Allegato</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:[`item.note`]="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn @click="apriNote(item)" v-bind="attrs" v-on="on" small>
                                        <v-icon color="primary">mdi-notebook-multiple</v-icon>
                                    </v-btn>
                                </template>
                                <span>Note</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:[`item.tecnico_assegnato`]="{ item }">
                            <v-select style="min-width: 120px" class="pt-2" :items="item.conduttoriSedi"
                                @change="changeConduttore(item)" v-model="item.id_conduttore" item-text="conduttore"
                                item-value="id_conduttore" dense label="Tecnico" />
                        </template>
                        <template v-slot:[`item.codice_ordine`]="{ item }">
                            <div style="display: flex">
                                <v-icon @click="changeSedePause(item)"
                                    v-if="item.codice_ordine == 'FINE GIORNATA' || item.codice_ordine == 'FINE VIAGGIO'"
                                    :style="{
                                        position: 'relative',
                                        cursor: 'pointer',
                                    }" color="primary">
                                    mdi-refresh
                                </v-icon>
                                <div :style="{
                                    padding: '10px',
                                    background: item.colore_sfondo,
                                    borderRadius: '6px',
                                }">
                                    <span :style="{
                                        position: 'relative',
                                        color: item.colore_testo,
                                    }">{{
                                        item.tipo_tappa
                                            ? item.tipo_tappa
                                            : item.codice_ordine
                                                ? item.codice_ordine
                                                : "N/D"
                                    }}</span>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`item.numero_marker`]="{ item }">
                            <span> {{ item.numero_marker }}</span>
                        </template>
                        <template v-slot:[`item.scala_mobile`]="{ item }">
                            {{ item.opzioni != null ? item.opzioni[0].valore : "" }}
                        </template>
                        <template v-slot:[`item.piano`]="{ item }">
                            {{ item.opzioni != null ? item.opzioni[1].valore : "" }}
                        </template>
                        <template v-slot:[`item.data_minima`]="{ item }">
                            <v-text-field v-if="item.data_minima != null" readonly v-model="item.data_minima"
                                label="Data" type="date" />
                        </template>
                        <template v-slot:[`item.data_partenza`]="{ item }">
                            <v-text-field readonly v-model="item.data_manuale" label="Data" type="datetime-local" />
                        </template>
                        <template v-slot:[`item.ora_arrivo`]="{ item }">
                            <v-text-field @change="cambioOraArrivo(item)" v-model="item.ora_arrivo" label="Data e ora"
                                type="datetime-local" />
                        </template>
                        <template v-slot:[`item.ora_ripartenza`]="{ item }">
                            <span> {{ formatDataOra(item.ora_ripartenza) }}</span>
                        </template>
                        <template v-slot:[`item.slot_permanenza`]="{ item }">
                            <v-select v-model="item.tempo_permanenza" :items="items_slot_attesa"
                                style="min-width: 75px; margin-top: 15px" @change="item" dense label="Permanenza" />
                        </template>
                        <template v-slot:[`item.elimina`]="{ item }">
                            <v-btn @click="eliminaOttimizzati(item)" small>
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                    </v-data-table> -->
                        </div>
                        <v-overlay :value="overlay2">
                            <v-progress-circular indeterminate size="64"></v-progress-circular>
                        </v-overlay>
                    </v-card>


                </v-dialog>

                <!-- DIALOG rimozione servizi-->
                <v-dialog persistent v-model="dialog_servizi_romossi" width="700px">
                    <v-card>
                        <v-toolbar class="indigo white--text" dense>
                            <v-toolbar-title class="white--text">Servizi senza località o provincia</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="dialog_servizi_romossi = false; arr_remove = [];" small>
                                        <v-icon class="error--text"> mdi-close </v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-container>
                            <v-row class="mt-2">
                                <span class="ma-3"> Codice ordine: {{ arr_remove.toString() }} </span>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-dialog>

                <!-- DIALOG AGG. Tappa -->
                <v-dialog persistent v-model="dialog_agg_tappa" width="80%">
                    <v-card>
                        <v-toolbar class="indigo white--text" dense>
                            <v-toolbar-title class="white--text">Seleziona una tappa</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn class="mr-2" v-on="on" small>
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Crea Tappa</span>
          </v-tooltip> -->
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn @click="aggTappa" class="mr-2" v-on="on" small>
                                        <v-icon color="success"> mdi-floppy </v-icon>
                                    </v-btn>
                                </template>
                                <span>Salva</span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="chiudiDialogTappa" small>
                                        <v-icon class="error--text"> mdi-close </v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-container>
                            <v-data-table :headers="headers_tappe" fixed-header :items="items_sedi" class="elevation-1"
                                calculate-widths>
                                <template v-slot:[`item.seleziona`]="{ item }">
                                    <v-checkbox @change="clickSede(item)" v-model="item.selected" />
                                </template>
                                <!-- <template v-slot:[`item.vincolata`]="{ item }">
              <v-checkbox v-model="item.vincolata" />
            </template> -->
                                <template v-slot:[`item.partenza_default`]="{ item }">
                                    <v-icon :color="item.partenza_default ? 'success' : 'error'
                                        ">{{
                                            item.partenza_default
                                                ? "mdi-check"
                                                : "mdi-close-circle"
                                        }}</v-icon>
                                </template>
                                <template v-slot:[`item.abilita_marker`]="{ item }">
                                    <v-icon :color="item.abilita_marker ? 'success' : 'error'
                                        ">{{
                                            item.abilita_marker
                                                ? "mdi-check"
                                                : "mdi-close-circle"
                                        }}</v-icon>
                                </template>
                            </v-data-table>
                        </v-container>
                    </v-card>
                </v-dialog>

                <!-- DIALOG AGG. SERVIZIO -->
                <v-dialog persistent v-model="dialog_agg_servizi" width="80%">
                    <v-card>
                        <v-toolbar class="indigo white--text" dense>
                            <v-toolbar-title class="white--text">Seleziona un Servizio</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-autocomplete dark outlined dense @change="filtra2" label="Conduttore"
                                v-model="tecnico_filter" hide-details :items="autisti" class="mt-2 mr-2"
                                item-text="cognome" append-icon="mdi-close"
                                @click:append="tecnico_filter = null; filtra2();" item-value="id_conduttore" />

                            <v-autocomplete dark outlined dense @change="filtra2" label="Codice Ordine"
                                v-model="codice_filter" hide-details :items="items_agg_servizio" class="mt-2 mr-2"
                                item-text="codice_ordine" append-icon="mdi-close"
                                @click:append="codice_filter = null; filtra2();" item-value="codice_ordine" />

                            <v-select multiple class="mt-2" dark outlined dense @change="filtra2" label="Competenza"
                                v-model="competenza_filter" hide-details :items="items_dettagli_tipo"
                                item-text="descrizione" item-value="id_tipo_servizio_dettaglio" append-icon="mdi-close"
                                @click:append="competenza_filter = []; filtra2();" return-object />
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn @click="aggServizio" class="mr-2" v-on="on" small>
                                        <v-icon color="success"> mdi-floppy </v-icon>
                                    </v-btn>
                                </template>
                                <span>Salva</span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="closeDialogAggServizi" small>
                                        <v-icon class="error--text"> mdi-close </v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-container>
                            <v-row justify="center" class="ma-1">
                                <!-- <v-col cols="3">
              <v-autocomplete @change="filtra2" label="Codice Servizio" v-model="codice_filter" dense hide-details
                :items="items_agg_servizio" class="mt-5" item-text="codice" item-value="codice" />
            </v-col> -->
                                <!-- <v-col cols="3">
              <v-autocomplete @change="filtra2" label="Località" v-model="localita_filter" dense hide-details
                :items="items_agg_servizio" class="mt-5" item-text="localita_arrivo" item-value="localita_arrivo" />
            </v-col> -->
                                <!-- <v-col cols="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mt-5" v-bind="attrs" v-on="on" small @click="resetFiltri">
                    <v-icon color="error"> mdi-filter-off </v-icon>
                  </v-btn>
                </template>
                <span>Resetta Filtri</span>
              </v-tooltip>
            </v-col> -->
                                <v-col cols="1"> </v-col>
                            </v-row>
                            <v-data-table :headers="headers_servizi" fixed-header :items="items_agg_servizio_vis"
                                class="elevation-1" calculate-widths>
                                <template v-slot:[`item.select`]="{ item }">
                                    <v-checkbox v-model="item.selected" />
                                </template>
                                <template v-slot:[`item.tecnico_assegnato`]="{ item }">
                                    <v-select class="pt-2" :items="autisti" v-model="item.id_conduttore"
                                        item-text="cognome" item-value="id_conduttore" dense label="Tecnico"
                                        @change="changeTecnico(item)" />
                                </template>
                            </v-data-table>
                        </v-container>
                    </v-card>
                </v-dialog>

                <!-- Dialog del Window Frame degli allegati -->
                <v-dialog class="ma-0 pa-0" v-model="window_frame_allegati_visible">
                    <v-card class="ma-0 pa-0" height="calc(100vh - 100px)" style="overflow: hidden">
                        <div style="position: relative; height: 100%">
                            <WindowFrame class="ma-0 pa-0"
                                @click_chiudi="window_frame_allegati_visible = false; input_args = {}"
                                :component="'allegati'" :input_args="input_args" ref="windowframe_allegati" />
                        </div>
                    </v-card>
                </v-dialog>
                <!-- DIALOG CONF. ELIMINAZIONE VIAGGIO -->
                <v-dialog persistent v-model="dialog_elimina_viaggio" width="60%">
                    <v-card>
                        <v-toolbar class="indigo white--text" dense>
                            <v-toolbar-title class="white--text">Eliminazione Viaggio</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn @click="eliminaGruppoViaggio" class="mr-2" v-on="on" small>
                                        <v-icon color="success"> mdi-floppy </v-icon>
                                    </v-btn>
                                </template>
                                <span>Conferma</span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="dialog_elimina_viaggio = false" small>
                                        <v-icon class="error--text"> mdi-close </v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-container style="padding: 30px">
                            <h3>
                                Sei veramente sicuro di voler eliminare tutti i viaggi?
                            </h3>
                        </v-container>
                    </v-card>
                </v-dialog>


                <!-- DIALOG CONF. ELIMINAZIONE PIANIFICAZIONE -->
                <v-dialog persistent v-model="dialog_elimina_pianificazione" width="50%">
                    <v-card>
                        <v-toolbar class="indigo white--text" dense>
                            <v-toolbar-title class="white--text">Eliminazione</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn @click="eliminaServizio" class="mr-2" v-on="on" small>
                                        <v-icon color="success"> mdi-floppy </v-icon>
                                    </v-btn>
                                </template>
                                <span>Conferma</span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="
                                        dialog_elimina_pianificazione = false;
                                    selected_item = null;
                                    " small>
                                        <v-icon class="error--text"> mdi-close </v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-container>
                            <h3 class="ma-5">
                                Conferma eliminazione
                                {{
                                    selected_item?.codice_ordine
                                        ? selected_item?.codice_ordine
                                        : selected_item?.id_sede
                                            ? "tappa"
                                            : selected_item?.id_temp
                                                ? "pausa"
                                                : "servizio aggiunto " +
                                                selected_item?.codice_ordine
                                }}.
                            </h3>
                        </v-container>
                    </v-card>
                    <v-overlay :value="overlay3">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-dialog>

                <!-- DIALOG CAMBIO TECNICO -->
                <v-dialog persistent v-model="dialog_change_tecnico" width="900px">
                    <v-card>
                        <v-toolbar class="indigo white--text" dense>
                            <v-toolbar-title class="white--text">Cambia Tecnico</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn @click="confermaCambioTecnico()" class="mr-2" v-on="on" small>
                                        <v-icon color="success"> mdi-floppy </v-icon>
                                    </v-btn>
                                </template>
                                <span>Conferma</span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="
                                        dialog_change_tecnico = false;
                                    new_conduttore = null;
                                    " small>
                                        <v-icon class="error--text"> mdi-close </v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-container>
                            <v-row>
                                <v-col>
                                    <h3 class="ma-5">
                                        Stai cambiando il conduttore
                                        {{ conduttore_da_cambiare?.nome }}
                                        {{ conduttore_da_cambiare?.cognome }}
                                        con
                                    </h3>
                                </v-col>
                                <v-col>
                                    <v-select class="mt-5" v-model="new_conduttore" :items="autisti" item-text="cognome"
                                        item-value="id_conduttore" dense label="Filtra per Tecnico"
                                        append-icon="mdi-close" style="max-width: 300px" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-dialog>

                <!-- DIALOG cambia giornata -->
                <v-dialog persistent v-model="dialog_azione" width="70%">
                    <v-card>
                        <v-toolbar class="indigo white--text" dense>
                            <v-toolbar-title class="white--text">Cambia Azione Giornata</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn @click="saveCambiaAzione()" class="mr-2" v-on="on" small>
                                        <v-icon color="success"> mdi-floppy </v-icon>
                                    </v-btn>
                                </template>
                                <span>Salva</span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="
                                        dialog_azione = false
                                        " small>
                                        <v-icon class="error--text"> mdi-close </v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-container fluid>
                            <v-row class="mt-1">
                                <v-col cols="4">
                                    <v-select v-model="azione_sel.data" :items="getDateOttimizzati()"
                                        @change="changeDataAzione()" dense label="Seleziona la data" />
                                </v-col>
                                <!-- <v-col cols="2">
                                    <v-text-field v-model="azione_sel.ora" dense label="Ora" type="time" />
                                </v-col> -->
                            </v-row>
                            <v-row class="mt-1">
                                <v-col cols="4">
                                    <v-select v-model="azione_sel.id_azione" :items="items_azioni" dense
                                        item-text="des_azione" item-value="id_azione"
                                        label="Modalità di ottimizzazione" />
                                </v-col>
                                <v-col cols="4">
                                    <v-select v-model="azione_sel.id_distribuzione" :items="items_distribuzione" dense
                                        item-text="des_azione" item-value="id_azione"
                                        label="Modalità di distribuzione" />
                                </v-col>
                                <v-col cols="4">
                                    <v-select v-model="azione_sel.id_equiparazione" :items="items_equiparazione" dense
                                        item-text="des_azione" item-value="id_azione"
                                        label="Modalità di equiparazione" />
                                </v-col>
                                <!-- <v-col cols="6">
                            <v-select readonly v-model="azione_sel.id_sede_partenza" :items="items_sedi" dense
                                item-text="indirizzo" item-value="id_azienda_sede" label="Seleziona partenza" />
                        </v-col>
                        <v-col cols="6">
                            <v-select readonly v-model="azione_sel.id_sede_arrivo" :items="items_sedi" dense
                                item-text="indirizzo" item-value="id_azienda_sede" label="Seleziona arrivo" />
                        </v-col> -->
                            </v-row>
                            <v-row v-for="(item, index) in items_sedi_conduttore_vis" :key="index">
                                <v-col cols="1">
                                    <v-checkbox dense v-model="item.selected" />
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field dense v-model="item.cognome" readonly label="Conduttore">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-select v-model="item.default_partenza" :items="item.sedi" item-text="sede"
                                        return-object dense label="Seleziona la sede partenza"
                                        @change="changeSedeConduttore(item)" />
                                </v-col>
                                <v-col cols="3">
                                    <v-select v-model="item.default_arrivo" :items="item.sedi" item-text="sede"
                                        return-object dense label="Seleziona la sede arrivo"
                                        @change="changeSedeConduttore(item)" />
                                </v-col>
                                <v-col cols="2">
                                    <v-select v-model="item.ora_primo_arrivo" :items="item.default_partenza?.slot_orari_primo_appuntamento
                                        " dense label="Ora arrivo" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                    <v-overlay :value="overlay3">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-dialog>

                <!-- DIALOG errore -->
                <v-dialog persistent v-model="dialog_error" width="80%">
                    <v-card>
                        <v-toolbar class="indigo white--text" dense>
                            <v-toolbar-title class="white--text">Log Operazioni</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click="
                                        dialog_error = false; errore_sel = '';
                                    " small>
                                        <v-icon class="error--text"> mdi-close </v-icon>
                                    </v-btn>
                                </template>
                                <span>Chiudi</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-container fluid class="mt-2">
                            <v-row justify="center" align="center" v-for="(item, index) in errore_sel" :key="index">
                                <v-col cols="3">{{ item.data }}</v-col>
                                <v-col cols="9">{{ item.descrizioneAttivita }}</v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-dialog>


                <!-- Dialog maps -->
                <v-dialog v-model="dialog_maps" width="90%">
                    <v-card class="ma-0 pa-0" height="calc(100vh - 100px)" style="overflow: hidden">
                        <div style="position: relative; height: 100%">
                            <WindowFrame class="ma-0 pa-0" @chiudi_maps="chiudiMaps" :component="'geolocation'"
                                :key="key_geo" ref="windowframe_geo" :input_args="input_args" />
                        </div>
                    </v-card>
                </v-dialog>

                <!-- Dialog pdf -->
                <v-dialog v-model="pdf_dialog_ott" width="unset">
                    <v-card>
                        <v-toolbar class="white--text" color="blue" dense
                            style="position: sticky; top: 0px; z-index: 1">
                            <v-toolbar-title> Stampa Pdf </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn class="red--text" @click="pdf_dialog_ott = false" color="blue-grey lighten-5" small>
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-row>
                            <v-col cols="12" sm="6" md="12">
                                <iframe :src="selected_pdf" frameborder="0" style="
                                height: 90vh !important;
                                width: 90vw !important;
                            ">
                                </iframe>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-dialog>
                <!-- Dialog gestione aziende -->

                <!-- <v-dialog persistent v-model="dialog_gestione_aziende2">
              <QLDialog2Aziende
                  @aggiornaItemsAzienda="aggiornaAutocomplete()"
                  @chiudiDialog="dialog_gestione_aziende2 = false"
              />
          </v-dialog> -->
                <!-- Snackbar -->
                <SnackbarQV ref="SnackbarQV" />
                <!-- Overlay di caricamento -->
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-overlay :value="overlay_servizi">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
            </v-card>
        </v-col>
    </div>
</template>
<script>
import QLGeneraleSFQ from "./QLCOMPONENTS/QLServizi/QLGeneraleSFQ.vue";
import QLOpzioniSFQ from "./QLCOMPONENTS/QLServizi/QLOpzioniSFQ.vue";
//import QLDialogAziende from "./QLCOMPONENTS/QLServizi/QLDialogAziende.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
// import QLDialog2Aziende from "./QLCOMPONENTS/QLServizi/QLDialog2Aziende.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import moment from "moment/moment";
import draggable from "vuedraggable";

class Servizio {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }
    // Metodo per resettare tutti i campi
    reset() {
        const campi = this.setCampi();

        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "id_servizio", default_val: null },
            { nome: "id_azienda", default_val: null },
            { nome: "codice", default_val: "" },
            { nome: "data_richiesta", default_val: "" },
            {
                nome: "data_inizio",
                default_val: moment().add(1, "d").format("yyyy-MM-DD"),
            },
            {
                nome: "data_fine",
                default_val: moment().add(1, "d").format("yyyy-MM-DD"),
            },
            { nome: "localita_partenza", default_val: "" },
            { nome: "provincia_partenza", default_val: "" },
            { nome: "cap_partenza", default_val: null },
            { nome: "indirizzo_partenza", default_val: "" },
            { nome: "civico_partenza", default_val: null },

            { nome: "id_azienda_dest", default_val: null },
            { nome: "id_sede_dest_senza_deposito", default_val: "" },
            { nome: "localita_dest_senza_deposito", default_val: "" },
            { nome: "provincia_dest_senza_deposito", default_val: "" },
            { nome: "cap_dest_senza_deposito", default_val: null },
            { nome: "indirizzo_dest_senza_deposito", default_val: "" },
            { nome: "civico_dest_senza_deposito", default_val: null },

            { nome: "id_fascia_oraria", default_val: "" },
            { nome: "id_tipo_formulario", default_val: "" },
            { nome: "id_causale_formulario", default_val: "" },

            { nome: "localita_arrivo", default_val: "" },
            { nome: "provincia_arrivo", default_val: "" },
            { nome: "cap_arrivo", default_val: null },
            { nome: "indirizzo_arrivo", default_val: "" },
            { nome: "distanza", default_val: null },
            { nome: "tempo_percorrenza", default_val: null },
            { nome: "id_sede_arrivo", default_val: "" },
            { nome: "id_zona", default_val: "" },
            { nome: "riferimento", default_val: "" },
            { nome: "id_dashboard", default_val: -1 },
            { nome: "ora_inizio", default_val: "" },
            { nome: "ora_fine", default_val: "" },
            { nome: "attesa_carico", default_val: 0 },
            { nome: "attesa_carico_valore", default_val: 0 },
            { nome: "attesa_carico_um", default_val: 0 },
            { nome: "civico_arrivo", default_val: null },
            { nome: "referente", default_val: null },
            { nome: "cellulare", default_val: "" },
            { nome: "descrizione", default_val: "" },
            { nome: "festivo_compreso", default_val: 0 },
            { nome: "sabato_compreso", default_val: 0 },
            { nome: "domenica_compreso", default_val: 0 },
            { nome: "tempo_setup_partenza", default_val: 30 },
            { nome: "tempo_setup_arrivo", default_val: 30 },
            { nome: "pianificato", default_val: 0 },
            { nome: "latitudine_arrivo", default_val: 0 },
            { nome: "longitudine_arrivo", default_val: 0 },
            { nome: "nuovo", default_val: 0 },
            { nome: "errori", default_val: {} },
            { nome: "validita", default_val: 1 },
        ];

        return campi;
    }
}

class Partenza {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }
    // Metodo per resettare tutti i campi
    reset() {
        const campi = this.setCampi();

        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "id_sede", default_val: moment().format("YYYY-MM-DD") },
            // { nome: "data_inizio", default_val: this.getNextWeekday() },
            { nome: "data_inizio", default_val: moment().format("YYYY-MM-DD") },
            { nome: "indirizzo_partenza", default_val: "" },
            { nome: "civico_partenza", default_val: "" },
            { nome: "localita_partenza", default_val: "" },
            { nome: "cap_partenza", default_val: "" },
            { nome: "provincia_partenza", default_val: "" },
            { nome: "latitudine_partenza", default_val: "" },
            { nome: "longitudine_partenza", default_val: "" },
        ];
        return campi;
    }
}

class Azione {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }
    // Metodo per resettare tutti i campi
    reset() {
        const campi = this.setCampi();

        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "id_azione", default_val: 2 },
            { nome: "id_distribuzione", default_val: 1 },
            { nome: "id_equiparazione", default_val: 1 },
            { nome: "id_sede_partenza", default_val: null },
            { nome: "id_sede_arrivo", default_val: null },
            { nome: "data", default_val: "" },
            { nome: "ora", default_val: "" },
        ];
        return campi;
    }
}
export default {
    name: "QLServizi",

    components: {
        QLGeneraleSFQ,
        QLOpzioniSFQ,
        SnackbarQV,
        WindowFrame,
        draggable,
    },

    props: {},

    data() {
        return {
            draggableOptions: {
                animation: 200,
                ghostClass: "drag-ghost",
                chosenClass: "drag-chosen",
                scroll: true,
                scrollSensitivity: 60,
                scrollSpeed: 10,
            },
            // Variabili d'appoggio
            data_dal: "",
            data_al: "",
            ordine_cambiato: false,
            current_page: 0,
            dettaglio_sel: null,
            change_state: false,
            //DettaglioDialog: false,
            inputArgs: { landing_page: "/" },
            componenteWF: "",
            tab: 0,
            data_inizio_menu: "",
            data_fine_menu: "",
            id_pagamento_default: null,
            iframeUrl: null,
            azienda_detail: {},
            overlay: false,
            overlay2: false,
            overlay3: false,
            dettaglio: null,
            carica_dettaglio: false,
            page_num: 1,
            items_per_page: 10,
            is_selez_multipla: false,
            blocco_filtri: false,
            regione_sel: [],
            provincia_sel: [],
            comune_sel: null,
            tecnico_sel: null,
            servizi_gruppo_viaggio: false,
            viaggio_sel: null,
            overlay_servizi: false,
            solo_non_pianificati: 2,
            visualizza_mappa: false,
            from_viaggio_servizio: false,
            pdf_dialog_ott: null,
            selected_pdf: null,
            image_for_viewer: null,
            area_filter: [],
            richiesta_filter: [],
            sede_magazzino_filter: [],
            index_pausa: null,
            nota_sel: null,
            selected_row: null,

            // servizio selezionato
            selected_item: new Servizio(),
            servizio_ass_sel: null,
            servizio_sel: null,
            servizio_pianificato_sel: null,
            servizio_pianificato_dettaglio_sel: null,
            sede_sel: null,
            partenza_sel: new Partenza(),
            data_sel: moment().format('DD/MM/YYYY'),
            id_conduttore_sel: null,
            change_sede_pausa: false,
            sede_pausa_sel: null,
            sede_conduttore_sel: null,
            dialog_azione: false,
            mode_pianificazione: false,
            errore_sel: '',


            // Filtri
            azienda_filter: "",
            codice_filter: null,
            competenza_filter: [],
            codice_ordine_filter: null,
            ragionesociale_filter: null,
            localita_arrivo_filter: "",
            descrizione_filter: "",
            data_inizio_filter: "",
            data_fine_filter: "",
            interval: null,
            localita_filter: null,
            tecnico_filter: null,
            servizio_filter: [],


            // Variabili tabella/filtri
            data_table: true,
            filters: true,
            multi_page: false,
            data_table_key: false,
            key_geo: 1,



            // Modal
            dialog_servizi_romossi: false,
            dialog_agg_tappa: false,
            dialog_gestione_partenza: false,
            dialog_elimina_sched: false,
            dialog_elimina_viaggio: false,
            dialog_elimina_pianificazione: false,
            dialog_gestione_aziende: false,
            dialog_gestione_aziende2: false,
            dialog_gestione_pianificazione: false,
            dialog_maps: false,
            dialog_servizi_suggeriti: false,
            dialog_agg_servizi: false,
            dialog_ottimizzati: false,
            dialog_note: false,
            dialog_conferma_ott: false,



            delete_dialog: false,
            ripianifica_dialog: false,
            dialog_extra: false,
            dialog_pdf: false,
            loading: false,
            menu_a: false,
            send_all: false,
            pagina_corrente: 1,
            per_pagina: 10,
            conduttore_filter: null,
            conduttore_da_cambiare: null,
            new_conduttore: null,
            data_da_filter_ott: null,
            data_a_filter_ott: null,
            dataminima_da_filter: null,
            dataminima_a_filter: null,
            data_minima_da_filter: null,
            data_minima_a_filter: null,
            key_table: true,
            dialog_change_tecnico: null,
            window_frame_allegati_visible: false,
            azione_sel: new Azione(),
            note_sel: null,
            dialog_error: false,


            // Array
            array_selezionati: [],
            array_apri_viaggi: [],
            arr_remove: [],
            autisti: [],
            dashboards: [],
            dettagli_servizio: [],
            items_azienda: [],
            items_sedi_conduttore: [],
            items_sedi_conduttore_vis: [],
            items_dettagli_tipo: [],
            items_area_competenza: [],
            items_sedi_magazzino: [],
            pdfs: [],
            selected_options: [],
            servizi: [],
            servizi_ori: [],
            // servizi_viaggio: [],
            input_args: {},
            items_azioni: [
                {
                    id_azione: 1,
                    des_azione: "Dal più vicino",
                },
                {
                    id_azione: 2,
                    des_azione: "Dal più lontano",
                }
            ],
            items_distribuzione: [
                {
                    id_azione: 1,
                    des_azione: "Per area di competenza",
                },
                {
                    id_azione: 2,
                    des_azione: "Uniforme per distanza",
                }
            ],
            items_equiparazione: [
                {
                    id_azione: 1,
                    des_azione: "Per distanza",
                },
                {
                    id_azione: 2,
                    des_azione: "Per tempo di impiego",
                }
            ],
            headers: [
                {
                    text: "Seleziona",
                    value: "select",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Modifica",
                    value: "edit",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Viaggio",
                    value: "viaggio",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Pianificato",
                    value: "pianificato",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Note",
                    value: "note",
                    filterable: false,
                    sortable: false,
                    width: '350px'
                },

                {
                    text: "Tipo Richiesta",
                    value: "stato_documento",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Tipo Servizio",
                    value: "sigla_tipo_servizio",
                    filterable: false,
                    sortable: false,
                },
                // {
                //   text: "Codice Servizio",
                //   value: "codice",
                //   filterable: false,
                //   sortable: false,
                // },
                {
                    text: "Codice Ordine",
                    value: "codice_ordine",
                    filterable: false,
                    sortable: false,
                },

                {
                    text: "Ragione Sociale",
                    value: "des_azienda",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Riferimento",
                    value: "riferimento",
                    filterable: false,
                    sortable: false,
                    width: '300px',
                },
                {
                    text: "Destinazione",
                    value: "indirizzo_arrivo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Località",
                    value: "localita_e_provincia",
                    filterable: false,
                    sortable: false,
                },
                // {
                //     text: "Data Imballo",
                //     value: "data_imballo",
                //     filterable: false,
                //     sort: function (a, b) {
                //         // implement custom compare function here
                //         // Trasforma le stringhe in oggetti Date
                //         const date_a = new Date(a);
                //         const date_b = new Date(b);

                //         // Confronto delle date
                //         if (date_a < date_b) return -1;
                //         if (date_a > date_b) return 1;
                //         return 0;
                //     },
                // },
                {
                    text: "Data Minima",
                    value: "data_minima",
                    filterable: false,
                    sort: function (a, b) {
                        // implement custom compare function here
                        // Trasforma le stringhe in oggetti Date
                        const date_a = new Date(a);
                        const date_b = new Date(b);

                        // Confronto delle date
                        if (date_a < date_b) return -1;
                        if (date_a > date_b) return 1;
                        return 0;
                    },
                },
                {
                    text: "Data Pianificata",
                    value: "ora_arrivo",
                    filterable: false,
                    sort: function (a, b) {
                        // implement custom compare function here
                        // Trasforma le stringhe in oggetti Date
                        const date_a = new Date(a);
                        const date_b = new Date(b);

                        // Confronto delle date
                        if (date_a < date_b) return -1;
                        if (date_a > date_b) return 1;
                        return 0;
                    },
                },
                {
                    text: "Tecnico Assegnato",
                    value: "tecnico_assegnato",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Tempo permanenza",
                    value: "tempo_permanenza",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Allegato",
                    value: "allegato",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Elimina Servizio",
                    value: "elimina",
                    filterable: false,
                    sortable: false,
                },
            ],
            headers_servizi: [
                {
                    text: "Seleziona",
                    value: "select",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Codice Ordine",
                    value: "codice_ordine",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Destinazione",
                    value: "indirizzo_arrivo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Località",
                    value: "localita_arrivo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Provincia",
                    value: "provincia_arrivo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Data Consegna",
                    value: "data_inizio",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Tecnico Assegnato",
                    value: "tecnico_assegnato",
                    filterable: false,
                    sortable: false,
                },
            ],
            headers_ott: [
                {
                    text: "Ordina",
                    value: "ordina",
                    filterable: false,
                    sortable: false,
                },

                {
                    text: "Note",
                    value: "note",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Tipo Richiesta",
                    value: "stato_documento",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Tecnico Assegnato",
                    value: "tecnico_assegnato",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Mobiliere",
                    value: "des_azienda",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Tipo Servizio",
                    value: "sigla_tipo_servizio",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Codice Ordine",
                    value: "codice_ordine",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Numero Marker",
                    value: "numero_marker",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Riferimento",
                    value: "riferimento",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Destinazione",
                    value: "indirizzo_arrivo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Località",
                    value: "localita_arrivo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Provincia",
                    value: "provincia_arrivo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Scala Mobile",
                    value: "scala_mobile",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Piano",
                    value: "piano",
                    filterable: false,
                    sortable: false,
                },
                // {
                //     text: "Data Imballo",
                //     value: "data_imballo",
                //     filterable: false,
                // },
                {
                    text: "Data minima",
                    value: "data_minima",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Data partenza",
                    value: "data_partenza",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Ora arrivo",
                    value: "ora_arrivo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Ora ripartenza",
                    value: "ora_ripartenza",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Tempo Permanenza",
                    value: "slot_permanenza",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Allegato",
                    value: "allegato",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Elimina",
                    value: "elimina",
                    filterable: false,
                    sortable: false,
                },
            ],
            headers_tappe: [
                {
                    text: "Seleziona",
                    value: "seleziona",
                    filterable: false,
                    sortable: false,
                },
                // {
                //   text: "Vincolata",
                //   value: "vincolata",
                //   filterable: false,
                //   sortable: false,
                // },
                {
                    text: "Default Partenza",
                    value: "partenza_default",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Default Mappa",
                    value: "abilita_marker",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Descrizione",
                    value: "descrizione",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Localita",
                    value: "localita",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Indirizzo",
                    value: "indirizzo",
                    filterable: false,
                    sortable: false,
                },
            ],
            items_stato: [],
            items_ottimizzati: [],
            items_ottimizzati_ori: [],
            items_sedi: [],
            items_comuni: [],
            items_province: [],
            items_regioni: [],
            items_slot_attesa: [],
            items_agg_servizio: [],
            items_agg_servizio_vis: [],
            items_stato_pianificazione: [
                {
                    stato_pianificato: "Da pianificare",
                    pianificato: 0,
                },
                {
                    stato_pianificato: "Pianificati",
                    pianificato: 1,
                },
                {
                    stato_pianificato: "Tutti",
                    pianificato: 2,
                },
            ]
        };
    },

    watch: {
        pagina_corrente(new_page) {
            console.log(new_page);
        },
        data_da_filter_ott: {
            immediate: true,
            handler() {
                this.filtraServOttimizzati()
            },
        },
        conduttore_filter: {
            immediate: true,
            handler() {
                // if (this.conduttore_filter != null) {
                //      if (this.items_ottimizzati[0]?.id_gruppo_servizi != 0) {
                //     console.log("entra getviaggi conduttore", );

                //     this.getViaggiConduttore();
                // } else {
                //     this.filtraServOttimizzati()
                // }
                // }

            },
        },
        data_a_filter_ott: {
            immediate: true,
            handler() {
                this.filtraServOttimizzati()
            },
        },
        dataminima_da_filter: {
            immediate: true,
            handler() {
                this.filtraServOttimizzati()
            },
        },
        dataminima_a_filter: {
            immediate: true,
            handler() {
                this.filtraServOttimizzati()
            },
        },
        data_minima_da_filter: {
            immediate: true,
            handler() {
                this.filtra()
            },
        },
        data_minima_a_filter: {
            immediate: true,
            handler() {
                this.filtra()
            },
        },
        regione_sel: {
            immediate: true,
            handler() {
                if (this.regione_sel.length != 0) this.getProvince()
            },
        },
        provincia_sel: {
            immediate: true,
            handler() {
                if (this.provincia_sel.length != 0) {
                    this.provincia_sel.forEach(e => {
                        this.getComuni(e.id_provincia)
                    })
                }
            },
        },
        data_table: {
            immediate: true,
            handler() {
                if (sessionStorage.getItem("page_servizi"))
                    this.page_num = parseInt(sessionStorage.getItem("page_servizi"));

                this.servizi.forEach((e) => {
                    this.$set(e, "selected", false);
                });
            },
        },
    },
    methods: {
        checkMove(evt) {
            const dragged = evt.draggedContext.element; // elemento spostato
            const related = evt.relatedContext.element; // elemento destinazione (quello su cui sto passando sopra)

            if (related && related.codice_ordine === "FINE VIAGGIO" || dragged.codice_ordine == "FINE VIAGGIO" || dragged.codice_ordine == "FINE GIORNATA") {
                this.$refs.SnackbarQV.print(
                    "orange",
                    `Hai spostato un FINE VIAGGIO o un FINE GIORNATA.`
                );
                return false; // annulla lo spostamento
            }

            if (dragged.bloccato) {
                return false;
            }

            return true; // altrimenti permetto
        },
        onDragEnd(evt) {
            const { oldIndex, newIndex } = evt;
            if (oldIndex === newIndex || oldIndex == null || newIndex == null) return;

            this.ordine_cambiato = true;
            this.items_ottimizzati[newIndex].spostato = 1;
            this.items_ottimizzati[oldIndex].spostato = 1;

            /* let ora_arrivo_new = this.items_ottimizzati[newIndex].ora_arrivo.replace(" ", "T");
            ora_arrivo_new = ora_arrivo_new.replaceAll("/", "-");
            let ora_arrivo_old = this.items_ottimizzati[oldIndex].ora_arrivo.replace(" ", "T");
            ora_arrivo_old = ora_arrivo_old.replaceAll("/", "-");

            console.log(ora_arrivo_new);
            const data = new Date(ora_arrivo_new);
            const data2 = new Date(ora_arrivo_old);

            // data.setHours(0, 0, 0, 0);
            // data2.setHours(0, 0, 0, 0);

            console.log("Data: ", data);
            console.log("data1 data2", data.toISOString());
            this.items_ottimizzati[newIndex].ora_arrivo = data.toISOString().slice(0, 10) + " 00:00";
            this.items_ottimizzati[oldIndex].ora_arrivo = data2.toISOString().slice(0, 10) + " 00:00"; */


            // Riordino l’array master in base agli indici
            const moved = this.items_ottimizzati.splice(oldIndex, 1)[0];
            this.items_ottimizzati.splice(newIndex, 0, moved);
            console.log("items dopo il drag", this.items_ottimizzati);
            // this.key_table++;
        },
        aggServizio() {
            // Calcola l'indice di inizio per la pagina corrente

            const start = (this.pagina_corrente - 1) * this.per_pagina;

            // Aggiungi il nuovo record all'inizio della pagina corrente
            // Ottieni la pagina corrente e inserisci il nuovo record
            const primo_elemento = this.items_ottimizzati[start];

            const indice_primo_elemento =
                this.items_ottimizzati.indexOf(primo_elemento);
            if (this.servizi_gruppo_viaggio) {
                this.items_agg_servizio.forEach((e) => {
                    let trovato = false;

                    this.items_ottimizzati.forEach((o) => {
                        if (e.id_servizio == o.id_servizio) {
                            trovato = true;
                        }
                    });

                    if (e.selected && trovato == false) {
                        console.log("servizio aggiunto", e);
                        let obj = JSON.parse(JSON.stringify(e));

                        obj.data_manuale = moment(this.items_ottimizzati[0].ora_ripartenza).format("yyyy-MM-DD HH:mm");
                        obj.ora_arrivo = moment(this.items_ottimizzati[0].ora_ripartenza).format("yyyy-MM-DD HH:mm");
                        // obj.data_minima = moment(this.items_ottimizzati[0].ora_ripartenza).format("yyyy-MM-DD HH:mm");

                        // let [giorno, mese, anno] = e.data_minima.split("/");
                        // obj.data_minima = new Date(anno, mese - 1, giorno);
                        obj.nuovo = 1;
                        obj.ora_ripartenza = this.sommaTempo(
                            this.items_ottimizzati[0].ora_ripartenza,
                            this.items_slot_attesa[2],
                            0
                        );



                        this.items_ottimizzati.splice(
                            indice_primo_elemento + 1,
                            0,
                            obj
                        );

                        // Aggiornamento della data_manuale per l'oggetto successivo
                        let prec_ora_ripartenza =
                            this.items_ottimizzati[1].ora_ripartenza;

                        for (
                            let i = 2;
                            i < this.items_ottimizzati.length;
                            i++
                        ) {
                            // Imposta la data_manuale in base alla data_ripartenza dell'oggetto precedente
                            this.items_ottimizzati[i].data_manuale =
                                moment(prec_ora_ripartenza).format(
                                    "yyyy-MM-DD HH:mm"
                                );

                            // Calcola ora_arrivo e ora_ripartenza per l'oggetto corrente
                            this.items_ottimizzati[i].ora_arrivo =
                                this.sommaTempo(
                                    this.items_ottimizzati[i].data_manuale,
                                    "00:00",
                                    this.items_ottimizzati[i].tempo_percorrenza
                                );
                            this.items_ottimizzati[i].ora_ripartenza =
                                this.sommaTempo(
                                    this.items_ottimizzati[i].data_manuale,
                                    this.items_ottimizzati[i].tempo_permanenza,
                                    this.items_ottimizzati[i].tempo_percorrenza
                                );

                            // Aggiorna la variabile prec_ora_ripartenza per il prossimo ciclo
                            prec_ora_ripartenza =
                                this.items_ottimizzati[i].ora_ripartenza;
                            if (
                                this.items_ottimizzati[i].codice_ordine ===
                                "FINE GIORNATA"
                            ) {
                                break; // Esce dal ciclo
                            }
                        }

                        e.selected = false;
                        this.ordine_cambiato = true;
                    }
                });
            } else {
                console.log(
                    " non servizi_gruppo_viaggio",
                    this.servizi_gruppo_viaggio
                );
                this.servizi.forEach((e) => {
                    let trovato = false;

                    this.items_ottimizzati.forEach((o) => {
                        if (e.id_servizio == o.id_servizio) {
                            trovato = true;
                        }
                    });

                    if (e.selected && trovato == false) {

                        console.log("servizio aggiunto", e);
                        let obj = JSON.parse(JSON.stringify(e));

                        obj.data_manuale = moment(this.items_ottimizzati[0].ora_ripartenza).format("yyyy-MM-DD HH:mm");
                        obj.ora_arrivo = moment(this.items_ottimizzati[0].ora_ripartenza).format("yyyy-MM-DD HH:mm");

                        let [giorno, mese, anno] = e.data_minima.split("/");
                        obj.data_minima = new Date(anno, mese - 1, giorno);
                        obj.nuovo = 1;
                        obj.ora_ripartenza = this.sommaTempo(
                            this.items_ottimizzati[0].ora_ripartenza,
                            this.items_slot_attesa[2],
                            0
                        );
                        this.items_ottimizzati.splice(
                            indice_primo_elemento,
                            0,
                            obj
                        );
                        e.selected = false;
                        this.ordine_cambiato = true;
                    }
                });
            }

            this.dialog_agg_servizi = false;
            this.localita_filter = null;
            this.codice_filter = null;
            this.competenza_filter = [];
            this.codice_ordine_filter = null;
            this.solo_non_pianificati = 2;
            this.ragionesociale_filter = null;
            this.tecnico_filter = null;
            this.dataminima_da_filter = null;
            this.dataminima_a_filter = null;
        },
        dialogEliminaViaggio() {
            this.dialog_elimina_viaggio = true;
        },
        openDialogAggServizi() {
            this.dialog_agg_servizi = true;
            console.log("apro dialog servizi agg.", this.servizi_ori, this.items_dettagli_tipo);

            this.items_agg_servizio = this.servizi_ori.filter(
                (e) => e.selected == undefined && e.pianificato != 1
            );
            this.items_agg_servizio_vis = this.servizi_ori.filter(
                (e) => e.selected == undefined && e.pianificato != 1
            );
            // this.items_dettagli_tipo.forEach(e => {
            //     const ids_competenza = e.ids_competenze
            //         .split(',')
            //         .map(x => Number(x.trim()));

            //     if (ids_competenza.includes(Number(this.items_ottimizzati[0].id_tipo_abilitazioni))) {
            //         this.competenza_filter.push(e);
            //     }
            // })

            console.log("apro dialog ======>", this.items_agg_servizio_vis);
            this.filtra2();


        },
        eliminaOttimizzati(arg, index) {
            console.log("elimina", arg);

            if (arg.id_servizio == 0 && arg.id_temp == undefined) {
                console.log("index", index);

                this.delete_dialog = true;
                this.index_pausa = index;
                this.selected_item = new Servizio(arg);
            }

            if (arg.id_temp) {
                this.items_ottimizzati = this.items_ottimizzati.filter(
                    (e) => e.id_temp != arg.id_temp
                );
            }
            if (arg.id_sede) {
                this.items_ottimizzati = this.items_ottimizzati.filter(
                    (e) => e.id_sede != arg.id_sede
                );
            }
            if (arg.id_servizio && this.servizi_gruppo_viaggio == true) {
                this.dialog_elimina_pianificazione = true;
                this.selected_item = arg;
            }
            if (arg.id_servizio && this.servizi_gruppo_viaggio == false) {
                this.items_ottimizzati = this.items_ottimizzati.filter(
                    (e) => e.id_servizio != arg.id_servizio
                );
                this.items_agg_servizio.forEach((e) => {
                    if (e.id_servizio == arg.id_servizio) {
                        delete e.selected;
                    }
                });

                this.servizi.forEach((e) => {
                    if (e.id_servizio == arg.id_servizio) {
                        delete e.selected;
                    }
                });
            }
        },
        deletePausa() {
            this.overlay3 = true;

            const request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "deletepausa",
                    id_servizio: this.items_ottimizzati[this.index_pausa - 1].id_servizio,
                },
            };
            this.$store.dispatch("api", request).then((res) => {

                if (res.status == 200 && res.data.result != false) {
                    this.items_ottimizzati.splice(this.index + 1, 1);
                    this.$refs.SnackbarQV.print(
                        "success",
                        "Ottimizzazione avvenuta con successo."
                    );
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Nessun dato presente, non è stato possibile caricare i dati."
                    );
                }

                this.overlay3 = false;
                this.delete_dialog = false;
                this.selected_item = new Servizio()
            }).catch((err) => {
                this.overlay3 = false;
                this.delete_dialog = false;
                this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server." + err);
            });
        },
        getNextWeekday() {
            const today = new Date();
            let nextDay = new Date(today);

            do {
                nextDay.setDate(nextDay.getDate() + 1);
            } while (nextDay.getDay() === 6 || nextDay.getDay() === 0);

            return moment(nextDay).format("YYYY-MM-DD");
        },
        onPageChange(page) {
            console.log("cambio pagina", page);

            this.pagina_corrente = page; // aggiorna la pagina corrente manualmente
        },
        addPauseBreak() {
            this.ordine_cambiato = true;

            // Calcola l'indice di inizio per la pagina corrente
            console.log(
                "pagina corrente, per pagina",
                this.pagina_corrente,
                this.per_pagina
            );

            const start = (this.pagina_corrente - 1) * this.per_pagina;
            console.log("start", start);

            // Aggiungi il nuovo record all'inizio della pagina corrente
            // Ottieni la pagina corrente e inserisci il nuovo record
            const primo_elemento = this.items_ottimizzati[start];
            console.log("primo_elemento", primo_elemento);

            const indice_primo_elemento =
                this.items_ottimizzati.indexOf(primo_elemento);
            console.log("indice_primo_elemento", indice_primo_elemento);

            let obj_pause = {
                id_temp: moment().valueOf(),
                codice_servizio: "PAUSA",
                codice_ordine: "PAUSA",
                slot: 0,
                nuovo: 1,
                tempo_permanenza: this.items_slot_attesa[3],
                id_conduttore: primo_elemento.id_conduttore,
                conduttoriSedi: primo_elemento.conduttoriSedi,
                data_manuale: this.items_ottimizzati[0].ora_ripartenza,
                ora_arrivo: this.items_ottimizzati[0].ora_ripartenza,
                ora_ripartenza: this.sommaTempo(
                    this.items_ottimizzati[0].ora_ripartenza,
                    this.items_slot_attesa[3],
                    0
                ),
            };
            this.items_ottimizzati.splice(
                indice_primo_elemento + 1,
                0,
                obj_pause
            );

            // Aggiornamento della data_manuale per l'oggetto successivo
            let prec_ora_ripartenza = this.items_ottimizzati[1].ora_ripartenza;

            for (let i = 2; i < this.items_ottimizzati.length; i++) {
                // Imposta la data_manuale in base alla data_ripartenza dell'oggetto precedente
                this.items_ottimizzati[i].data_manuale =
                    moment(prec_ora_ripartenza).format("yyyy-MM-DD HH:mm");

                // Calcola ora_arrivo e ora_ripartenza per l'oggetto corrente
                this.items_ottimizzati[i].ora_arrivo = this.sommaTempo(
                    this.items_ottimizzati[i].data_manuale,
                    "00:00",
                    this.items_ottimizzati[i].tempo_percorrenza
                );
                this.items_ottimizzati[i].ora_ripartenza = this.sommaTempo(
                    this.items_ottimizzati[i].data_manuale,
                    this.items_ottimizzati[i].tempo_permanenza,
                    this.items_ottimizzati[i].tempo_percorrenza
                );

                // Aggiorna la variabile prec_ora_ripartenza per il prossimo ciclo
                prec_ora_ripartenza = this.items_ottimizzati[i].ora_ripartenza;
                if (
                    this.items_ottimizzati[i].codice_ordine === "FINE GIORNATA"
                ) {
                    break; // Esce dal ciclo
                }
            }
        },
        aggTappa() {
            if (this.change_sede_pausa) {
                // this.items_ottimizzati.forEach((e) => {
                //   if (e.id_servizio == this.sede_pausa_sel.id_servizio) {
                //     this.items_ottimizzati = [];
                //   }
                // })

                // this.items_ottimizzati.forEach(e => {
                //   if (e.id_servizio == this.sede_pausa_sel.id_servizio) {
                //     const sede_selected = this.items_sedi.filter(e => e.selected)[0];

                //     console.log("sede pausa sel", this.sede_pausa_sel);
                //     console.log("sede_selected", sede_selected);
                //     this.$set(e, 'indirizzo_partenza', sede_selected.indirizzo);
                //     this.$set(e, 'localita_partenza', sede_selected.localita);
                //     this.$set(e, 'provincia_partenza', sede_selected.provincia);
                //     this.$set(e, 'id_azienda_sede', sede_selected.id_azienda_sede);

                //     console.log("e cambiato?", e);

                //     this.items_ottimizzati = [...this.items_ottimizzati];
                //     this.$forceUpdate();
                //   }
                // })

                this.items_ottimizzati.forEach((e, index) => {
                    if (e.id_servizio == this.sede_pausa_sel.id_servizio) {
                        // const sede_selected = this.items_sedi.filter(e => e.selected)[0];
                        const sede_selected = this.items_sedi.find(
                            (e) => e.selected
                        );

                        console.log("sede pausa sel", this.sede_pausa_sel);
                        console.log("sede_selected", sede_selected);
                        const item_rimosso = this.items_ottimizzati.splice(
                            index,
                            1
                        )[0];

                        const obj = {
                            ...item_rimosso,
                            indirizzo_arrivo: sede_selected.indirizzo,
                            localita_arrivo: sede_selected.localita,
                            provincia_arrivo: sede_selected.provincia,
                            id_azienda_sede: sede_selected.id_azienda_sede,
                            nuovo: 1,
                        };

                        this.items_ottimizzati.splice(index, 0, obj);
                        console.log("Oggetto aggiornato:", obj);
                    }
                });
                this.key_table = !this.key_table;
            } else {
                this.items_sedi.forEach((e) => {
                    // Calcola l'indice di inizio per la pagina corrente
                    console.log(
                        "pagina corrente, per pagina",
                        this.pagina_corrente,
                        this.per_pagina
                    );

                    const start = (this.pagina_corrente - 1) * this.per_pagina;
                    console.log("start", start);

                    // Aggiungi il nuovo record all'inizio della pagina corrente
                    // Ottieni la pagina corrente e inserisci il nuovo record
                    const primo_elemento = this.items_ottimizzati[start];
                    console.log("primo_elemento", primo_elemento);

                    const indice_primo_elemento =
                        this.items_ottimizzati.indexOf(primo_elemento);
                    console.log("indice_primo_elemento", indice_primo_elemento);

                    if (e.selected) {
                        let obj = {
                            localita_arrivo: e.localita,
                            cap_arrivo: e.cap,
                            latitudine_arrivo: e.latitudine,
                            longitudine_arrivo: e.longitudine,
                            provincia_arrivo: e.provincia,
                            codice_servizio: e.descrizione,
                            id_sede: e.id_azienda_sede,
                            destinazione: e.indirizzo,
                            nuovo: 1,
                            tempo_permanenza: this.items_slot_attesa[2],
                            id_conduttore: primo_elemento.id_conduttore,
                            conduttoriSedi: primo_elemento.conduttoriSedi,
                            data_manuale:
                                this.items_ottimizzati[0].ora_ripartenza,
                            ora_arrivo:
                                this.items_ottimizzati[0].ora_ripartenza,
                            ora_ripartenza: this.sommaTempo(
                                this.items_ottimizzati[0].ora_ripartenza,
                                this.items_slot_attesa[2],
                                0
                            ),
                        };

                        this.items_ottimizzati.splice(
                            indice_primo_elemento + 1,
                            0,
                            obj
                        );

                        // Aggiornamento della data_manuale per l'oggetto successivo
                        let prec_ora_ripartenza =
                            this.items_ottimizzati[1].ora_ripartenza;

                        for (
                            let i = 2;
                            i < this.items_ottimizzati.length;
                            i++
                        ) {
                            // Imposta la data_manuale in base alla data_ripartenza dell'oggetto precedente
                            this.items_ottimizzati[i].data_manuale =
                                moment(prec_ora_ripartenza).format(
                                    "yyyy-MM-DD HH:mm"
                                );

                            // Calcola ora_arrivo e ora_ripartenza per l'oggetto corrente
                            this.items_ottimizzati[i].ora_arrivo =
                                this.sommaTempo(
                                    this.items_ottimizzati[i].data_manuale,
                                    "00:00",
                                    this.items_ottimizzati[i].tempo_percorrenza
                                );
                            this.items_ottimizzati[i].ora_ripartenza =
                                this.sommaTempo(
                                    this.items_ottimizzati[i].data_manuale,
                                    this.items_ottimizzati[i].tempo_permanenza,
                                    this.items_ottimizzati[i].tempo_percorrenza
                                );

                            // Aggiorna la variabile prec_ora_ripartenza per il prossimo ciclo
                            prec_ora_ripartenza =
                                this.items_ottimizzati[i].ora_ripartenza;
                            if (
                                this.items_ottimizzati[i].codice_ordine ===
                                "FINE GIORNATA"
                            ) {
                                break; // Esce dal ciclo
                            }
                        }
                    }

                    // e.selected = false;
                });
            }

            console.log("ott dopo tappa", this.items_ottimizzati);
            this.dialog_agg_tappa = false;
            this.change_sede_pausa = false;
            this.items_sedi.forEach((e) => {
                delete e.selected;
            });
            this.ordine_cambiato = true;
        },
        eliminaEPianifica(item) {
            let obj_sel = null;
            this.servizi.forEach((e) => {
                if (e.id_servizio == item.id_servizio) {
                    obj_sel = e;
                }
            });
            this.eliminaServizio();

            const getserviziodettagli = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getserviziodettagli",
                    id_servizio: obj_sel.id_servizio,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", getserviziodettagli).then((res) => {
                this.overlay = false;
                if (res.status === 200) {
                    this.servizio_pianificato_dettaglio_sel =
                        res.data.result[0];
                    const pianificazione = {
                        controller: "logistic",
                        method: "POST",
                        richiesta: {
                            token: localStorage.getItem("user_token"),
                            action: "saveserviziopianifica",
                            servizio: obj_sel,
                            dettagli: [this.servizio_pianificato_dettaglio_sel],
                        },
                    };

                    this.overlay = true;
                    this.data_table = true;
                    this.$store.dispatch("api", pianificazione).then((res) => {
                        this.overlay = false;
                        if (res.status === 200) {
                            this.$refs.SnackbarQV.print(
                                "success",
                                "Servizio salvato e pianificato correttamente."
                            );
                        } else {
                            // snackbar errore
                            this.$refs.SnackbarQV.print(
                                "orange",
                                "Errore di comunicazione col server, non è stato possibile caricare i dati."
                            );
                        }

                        this.getServizi();
                    });
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });

            this.dialog_gestione_pianificazione = false;
            this.dialog_servizi_suggeriti = false;
            this.servizio_pianificato_dettaglio_sel = null;
            this.servizio_ass_sel = null;
            this.servizio_associato_da_pianificare = null;
            this.servizio_pianificato_sel = null;
        },
        closeDialogAggServizi() {
            this.dialog_agg_servizi = false;
            this.localita_filter = null;
            this.codice_filter = null;
            this.competenza_filter = null;
            this.codice_ordine_filter = null;
            this.data_minima_da_filter = null;
            this.data_minima_a_filter = null;
            this.solo_non_pianificati = 2;
            this.ragionesociale_filter = null;
            this.tecnico_filter = null;
            this.items_agg_servizio_vis = Array.from(this.items_agg_servizio);
        },
        ripianificaEServiziSuggeriti() {
            this.servizi.forEach((e) => {
                if (
                    e.id_servizio ==
                    this.servizio_pianificato_sel.servizio_successivo
                        ?.id_servizio ||
                    e.id_servizio ==
                    this.servizio_pianificato_sel.servizio_precedente
                        ?.id_servizio
                ) {
                    this.servizio_associato_da_pianificare = e;
                }
            });

            const getserviziodettagli = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getserviziodettagli",
                    id_servizio:
                        this.servizio_associato_da_pianificare.id_servizio,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", getserviziodettagli).then((res) => {
                this.overlay = false;
                if (res.status === 200) {
                    this.servizio_pianificato_dettaglio_sel =
                        res.data.result[0];
                    console.log(
                        "servizio per la chiamata dei servizi suggeriti",
                        this.servizio_pianificato_dettaglio_sel
                    );
                    this.serviziSuggeritiFromPianificazione();
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
        },
        clickResetSelezionati() {
            this.array_selezionati = [];
            this.servizi.forEach(e => {
                e.selected = false;
            })
            // this.getServizi()
        },
        clickOttimizzaViaggi(arg) {
            console.log("entra dialog partenza");

            this.send_all = arg == 1 ? true : false;
            this.partenza_sel.data_inizio = this.getNextWeekday();
            this.dialog_gestione_partenza = true;
            this.servizi_gruppo_viaggio = false;

            this.items_sedi_conduttore_vis = [];

            // trovo gli autisti per area competenza
            this.items_sedi_conduttore.forEach(t => {
                let trovato = false;
                t.zone_di_competenza.forEach(c => {
                    if (c.predefinito == 1) {
                        if (this.send_all) {

                            this.servizi.forEach(s => {
                                if (c.provincia == s.provincia_arrivo) {
                                    console.log("entra pianifica tutto");
                                    trovato = true;
                                }
                            })
                        } else {
                            this.array_selezionati.forEach(s => {
                                if (c.provincia == s.provincia_arrivo) {
                                    console.log("entra manda selezionati match provincie", c, s);
                                    trovato = true;
                                }
                            })
                        }
                    }

                })
                // se lo trovo controllo le competenze 
                if (trovato) {

                    t.selected = true;
                    let arr_ids_abilitazioni = [];
                    let servizi_selezionati = [];

                    // controllo se c'è almeno una competenza selezionata
                    if (this.servizio_filter.length != 0) {

                        this.servizio_filter.forEach(e => {
                            if (!this.send_all) {
                                this.array_selezionati.forEach(ser => {
                                    const ids_competenza = e.ids_competenze
                                        .split(',')
                                        .map(x => Number(x.trim()));

                                    if (ids_competenza.includes(Number(ser.id_tipo_abilitazioni))) {
                                        servizi_selezionati.push(e)
                                    }
                                })
                            }

                        })

                        if (servizi_selezionati.length != 0) {
                            servizi_selezionati.forEach(s => {

                                const ids = s.ids_competenze
                                    .split(',')
                                    .map(x => Number(x.trim()));

                                arr_ids_abilitazioni.push(...ids);
                            })

                            if (arr_ids_abilitazioni.length != 0) {

                                if (t.abilitazioni.some(ab => arr_ids_abilitazioni.includes(ab.id_tipo_abilitazione))) {
                                    this.items_sedi_conduttore_vis.push(t);
                                    console.log("conduttori selezionati dal sistema", this.items_sedi_conduttore_vis);

                                }
                            }
                        } else {
                            console.log("entra else, quindi pusho il conduttore per tipologia servizio", this.items_sedi_conduttore_vis);
                            this.servizi.forEach(s => {
                                if (s.id_tipo_abilitazioni != null) {
                                    const ids = s.id_tipo_abilitazioni
                                        .split(',')
                                        .map(x => Number(x.trim()));

                                    arr_ids_abilitazioni.push(...ids);
                                }

                            })

                            if (arr_ids_abilitazioni.length != 0) {
                                console.log("trove le abilitazioni dai servizi", arr_ids_abilitazioni);


                                if (t.abilitazioni.some(ab => arr_ids_abilitazioni.includes(ab.id_tipo_abilitazione))) {
                                    this.items_sedi_conduttore_vis.push(t);
                                }
                            }
                        }

                    } else {

                        t.zone_di_competenza.forEach(c => {
                            if (c.predefinito == 1) {
                                if (!this.send_all) {

                                    this.array_selezionati.forEach(s => {
                                        if (c.provincia == s.provincia_arrivo && s.id_tipo_abilitazioni != null) {
                                            const ids = s.id_tipo_abilitazioni
                                                .split(',')
                                                .map(x => Number(x.trim()));

                                            ids.push(...ids);

                                            if (
                                                t.abilitazioni.some(ab => ids.includes(ab.id_tipo_abilitazione)) &&
                                                !this.items_sedi_conduttore_vis.some(item => item.id_conduttore == t.id_conduttore)
                                            ) {
                                                this.items_sedi_conduttore_vis.push(t);
                                            }
                                        }
                                    })

                                } else {
                                    console.log("entra dove dovrebbe pushare", this.servizi);

                                    this.servizi.forEach(s => {
                                        if (c.provincia == s.provincia_arrivo && s.id_tipo_abilitazioni != null) {
                                            const ids = s.id_tipo_abilitazioni
                                                .split(',')
                                                .map(x => Number(x.trim()));

                                            ids.push(...ids);

                                            if (
                                                t.abilitazioni.some(ab => ids.includes(ab.id_tipo_abilitazione)) &&
                                                !this.items_sedi_conduttore_vis.some(item => item.id_conduttore == t.id_conduttore)
                                            ) {
                                                this.items_sedi_conduttore_vis.push(t);
                                            }
                                        }
                                    });
                                }
                            }
                        })

                    }
                }
            })
        },
        // clickOttimizzaViaggi(arg) {
        //     let procedi = false;
        //     this.servizi.forEach(e => {
        //         if (e.pianificato == 0) {
        //             procedi = true;
        //         }
        //     })
        //     if (procedi) {
        //         this.send_all = arg == 1 ? true : false;
        //         this.partenza_sel.data_inizio = this.getNextWeekday();
        //         this.dialog_gestione_partenza = true;
        //         this.servizi_gruppo_viaggio = false;

        //         this.items_sedi_conduttore_vis = [];


        //         this.items_sedi_conduttore.forEach(t => {
        //             let trovato = false;
        //             t.zone_di_competenza.forEach(c => {
        //                 if (c.predefinito == 1) {
        //                     if (this.send_all) {
        //                         this.servizi.forEach(s => {
        //                             console.log("c.provincia == s.provincia_arrivo", c.provincia, s.provincia_arrivo);

        //                             if (c.provincia == s.provincia_arrivo) {
        //                                 trovato = true;
        //                             }
        //                         })

        //                         console.log("entra manda tutto", trovato);
        //                     } else {
        //                         console.log("entra manda selezionati");
        //                         this.servizi.filter(e => e.selected).forEach(s => {
        //                             if (c.provincia == s.provincia_arrivo) {
        //                                 trovato = true;
        //                             }
        //                         })
        //                     }
        //                 }

        //             })

        //             if (trovato) {
        //                 t.selected = true;
        //                 let arr_ids_abilitazioni = [];
        //                 let servizi_selezionati = [];
        //                 this.items_dettagli_tipo.forEach(e => {
        //                     if (!this.send_all) {
        //                         this.servizi.forEach(ser => {
        //                             if (ser.selected == e.id_tipo_servizio_dettaglio) {
        //                                 servizi_selezionati.push(e)
        //                             }
        //                         })
        //                     }

        //                 })
        //                 console.log("new arr servizi sel", servizi_selezionati);

        //                 if (servizi_selezionati.length != 0) {
        //                     servizi_selezionati.forEach(s => {
        //                         const ids = s.ids_competenze
        //                             .split(',')
        //                             .map(x => Number(x.trim()));

        //                         arr_ids_abilitazioni.push(...ids);
        //                         console.log("new arr_ids_abilitazioni", arr_ids_abilitazioni);
        //                     })

        //                     if (arr_ids_abilitazioni.length != 0) {

        //                         if (t.abilitazioni.some(ab => arr_ids_abilitazioni.includes(ab.id_tipo_abilitazione))) {
        //                             this.items_sedi_conduttore_vis.push(t);
        //                         }
        //                     }
        //                 } else {
        //                     console.log("pusho ogni conduttore?", this.items_sedi_conduttore_vis);
        //                     this.servizi.forEach(s => {
        //                         const ids = s.id_tipo_abilitazioni
        //                             .split(',')
        //                             .map(x => Number(x.trim()));

        //                         arr_ids_abilitazioni.push(...ids);
        //                         console.log("new arr_ids_abilitazioni", arr_ids_abilitazioni);
        //                     })

        //                     if (arr_ids_abilitazioni.length != 0) {

        //                         if (t.abilitazioni.some(ab => arr_ids_abilitazioni.includes(ab.id_tipo_abilitazione))) {
        //                             this.items_sedi_conduttore_vis.push(t);
        //                         }
        //                     }
        //                 }
        //             }
        //         })
        //     } else {
        //         this.$refs.SnackbarQV.print(
        //             "orange",
        //             "Non ci sono servizi da pianificare disponibili."
        //         );
        //     }
        // },
        clickIconPianificazione(item) {
            console.log("click pianificazione");
            this.servizio_sel = item;
            if (
                item.id_servizio_successivo != null ||
                item.id_servizio_precedente != null
            ) {
                this.servizio_pianificato_sel = item;
                this.dialog_gestione_pianificazione = true;
                console.log(
                    "click pianificazione dialog",
                    this.servizio_pianificato_sel
                );
            } else if (item.pianificato == 1) {
                this.dialog_elimina_sched = true;
            } else {
                return;
            }
        },
        salvaAssociazione() {
            if (this.servizi_suggeriti.length != 0) {
                this.servizio_ass_sel = this.servizi_suggeriti.filter(
                    (e) => e.selezionato == true
                )[0]
                    ? this.servizi_suggeriti.filter(
                        (e) => e.selezionato == true
                    )[0].id_servizio
                    : null;
                console.log("salva associazione", this.servizio_ass_sel);
            }

            if (this.servizio_ass_sel != null) {
                this.salvaPianificazione();
                this.dialog_servizi_suggeriti = false;
                this.servizi_suggeriti = [];
            } else {
                this.$refs.SnackbarQV.print(
                    "error",
                    "Selezionare un servizio per l'associazione."
                );
            }
        },
        allReport() {
            this.overlay = true;
            let arr_ids = [];
            if (this.servizi.length != 0) {
                this.servizi.forEach((e) => {
                    arr_ids.push(e.id_servizio);
                });
            }

            let request = {
                controller: "report",
                method: "POST",
                richiesta: {
                    action: "getreportpdf",
                    token: localStorage.user_token,
                    cod_report: "scheda_servizio",
                    parametri: [
                        {
                            parametro: "@id_servizio",
                            valore: arr_ids.toString(),
                        },
                    ],
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        if (
                            "tipo_messaggio" in res.data &&
                            "query_messaggio" in res.data &&
                            res.data.tipo_messaggio == 1
                        ) {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                res.data.query_messaggio
                            );
                        }
                        const response = res.data.result;
                        const byteCharacters = atob(response);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], {
                            type: "application/pdf",
                        });
                        const blobUrl = URL.createObjectURL(blob);
                        this.iframeUrl = blobUrl;
                        this.dialog_pdf = true;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Impossibile generare il report"
                        );
                    }
                    this.overlay = false;
                })
                .catch((err) => {
                    this.overlay = false;
                    if (
                        "tipo_messaggio" in err.response.data &&
                        "query_messaggio" in err.response.data &&
                        err.response.data.tipo_messaggio == 2
                    ) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            err.response.data.query_messaggio
                        );
                    } else {
                        this.$refs.SnackbarQV.print("error", err.toString());
                    }
                });
        },
        async cambiaTecnico() {
            await this.getDettagliServizio();

            console.log("this.selected_item saveservizio", this.selected_item);

            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "saveservizio",
                    token: localStorage.getItem("user_token"),
                    servizio: this.selected_item,
                    dettagli: this.dettagli_servizio,
                },
            };

            // Overlay di caricamento
            this.overlay = true;
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200) {
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Servizio salvato correttamente."
                        );
                        this.getServizi();
                        this.selected_item = {};
                        this.dettagli_servizio = [];
                    }
                })
                .catch((e) => {
                    // stampo l'errore
                    console.error(e);
                    // snackbar avvertimento
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    // tolgo l'overlay
                    this.overlay = false;
                });
        },
        changeConduttore(arg) {
            arg.id_conduttore_sede = arg.conduttoriSedi.filter(
                (e) => e.id_conduttore == arg.id_conduttore
            )[0].id_conduttore_sede;
            this.ordine_cambiato = true;
        },
        changeTecnico(arg) {
            console.log("change state arg", arg);
            this.selected_item = arg;
            this.cambiaTecnico();
        },
        changeSede(arg) {
            this.sede_sel = arg;
            console.log("sede sel", this.sede_sel);
            if (arg) {
                this.partenza_sel.id_sede = arg.id_azienda_sede;
                this.partenza_sel.cap_partenza = arg.cap;
                this.partenza_sel.civico_partenza = arg.civico;
                this.partenza_sel.indirizzo_partenza = arg.indirizzo;
                this.partenza_sel.latitudine_partenza = arg.latitudine;
                this.partenza_sel.localita_partenza = arg.localita;
                this.partenza_sel.longitudine_partenza = arg.longitudine;
                this.partenza_sel.provincia_partenza = arg.provincia;
            }
            this.items_sedi.forEach((e) => {
                if (e.id_azienda_sede == this.sede_sel) {
                    console.log("partenza sel changed", this.partenza_sel);
                    this.partenza_sel.id_sede = e.id_azienda_sede;
                    this.partenza_sel.cap_partenza = e.cap;
                    this.partenza_sel.civico_partenza = e.civico;
                    this.partenza_sel.indirizzo_partenza = e.indirizzo;
                    this.partenza_sel.latitudine_partenza = e.latitudine;
                    this.partenza_sel.localita_partenza = e.localita;
                    this.partenza_sel.longitudine_partenza = e.longitudine;
                    this.partenza_sel.provincia_partenza = e.provincia;
                }
            });
        },
        changeSedeIndirizzo() {
            this.partenza_sel.latitudine_partenza = null;
            this.partenza_sel.longitudine_partenza = null;
        },
        closePartenza() {
            this.dialog_gestione_partenza = false;
            this.partenza_sel = new Partenza();
        },
        closeOttimizzati() {
            this.dialog_ottimizzati = false;
            this.from_viaggio_servizio = false;
            this.pagina_corrente = 1;
            this.data_da_filter_ott = null;
            this.data_a_filter_ott = null;
            this.conduttore_filter = null;
            this.dialog_gestione_partenza = false;
            // this.servizi_viaggio = [];
            this.ordine_cambiato = false;
            this.servizi_gruppo_viaggio = false;
            this.mode_pianificazione = false;
            this.resetFiltriOtt();
            this.getServizi();
            console.log("chiudo", this.servizi_gruppo_viaggio);
        },
        chiudiDialogTappa() {
            this.dialog_agg_tappa = false;
            this.change_sede_pausa = false;
            this.items_sedi.forEach((e) => {
                delete e.selected;
            });
        },
        // formatDataOra(arg) {
        //   let date = moment(arg).format(
        //     "DD/MM/YYYY");
        //   let hours = moment(arg).format(
        //     "HH:mm");

        //     return date + " " + hours;
        // },
        changeSedeConduttore(item) {
            console.log("cambio sede", item);
            item.ora_primo_arrivo = item.default_partenza.orario_primo_appuntamento;
        },
        formatDataOra(arg) {
            if (arg != null) {
                let date = moment(arg);

                // Verifica se la data è valida
                if (!date.isValid()) {
                    if (arg == null) {
                        return "";
                    } else {
                        return arg.slice(0, -3);
                    }
                }

                let formatted_date = date.format("DD/MM/YYYY");

                let hours = date.format("HH:mm");

                return formatted_date + " " + hours;
            } else {
                return "";
            }
        },
        formatData(arg) {

            if (!arg) return "";

            const date = new Date(arg);

            if (isNaN(date.getTime())) {
                console.warn("Data non valida:", arg);
                return "";
            }

            const giorno = String(date.getDate()).padStart(2, "0");
            const mese = String(date.getMonth() + 1).padStart(2, "0");
            const anno = date.getFullYear();

            return `${giorno}/${mese}/${anno}`;
        },
        getReport(item) {
            this.overlay = true;
            this.pdfs = [];
            let request = {
                controller: "report",
                method: "POST",
                richiesta: {
                    action: "getreportpdf",
                    token: localStorage.user_token,
                    cod_report: "scheda_servizio",
                    parametri: [
                        {
                            parametro: "@id_servizio",
                            valore: item.id_servizio,
                        },
                    ],
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        if (
                            "tipo_messaggio" in res.data &&
                            "query_messaggio" in res.data &&
                            res.data.tipo_messaggio == 1
                        ) {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                res.data.query_messaggio
                            );
                        }
                        const response = res.data.result;
                        const byteCharacters = atob(response);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], {
                            type: "application/pdf",
                        });
                        const blobUrl = URL.createObjectURL(blob);
                        this.iframeUrl = blobUrl;
                        this.dialog_pdf = true;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Impossibile generare il report"
                        );
                    }
                    this.overlay = false;
                })
                .catch((err) => {
                    this.overlay = false;
                    if (
                        "tipo_messaggio" in err.response.data &&
                        "query_messaggio" in err.response.data &&
                        err.response.data.tipo_messaggio == 2
                    ) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            err.response.data.query_messaggio
                        );
                    } else {
                        this.$refs.SnackbarQV.print("error", err.toString());
                    }
                });
        },
        getAutisti() {
            const getconduttori = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "getconduttori",
                    token: localStorage.getItem("user_token"),
                    id_conduttore: null,
                },
            };
            //GET CONDUTTORI
            this.overlay = true;
            this.$store.dispatch("api", getconduttori).then((res) => {
                this.overlay = false;
                if (res.status === 200) {
                    this.autisti = [];
                    this.autisti = res.data.result;
                    this.items_sedi_conduttore = [];
                    this.items_sedi_conduttore = res.data.result;
                    this.items_sedi_conduttore.forEach((e) => {
                        if (e.sedi.length != 0) {
                            e.sedi.forEach((s) => {
                                if (s.predefinito == 1) {
                                    e.default_partenza = s;
                                    e.default_arrivo = s;
                                    e.ora_primo_arrivo =
                                        s.orario_primo_appuntamento;
                                }
                            });
                        }
                    });
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
        },
        // async getConduttoreSedi() {
        //   const getconduttori = {
        //     controller: "logistic",
        //     method: "POST",
        //     richiesta: {
        //       action: "getconduttoresedi",
        //       token: localStorage.getItem("user_token"),
        //     },
        //   };
        //   //GET CONDUTTORI
        //   this.overlay = true;
        //   this.$store.dispatch("api", getconduttori).then((res) => {
        //     this.overlay = false;
        //     if (res.status === 200) {
        //       res.data.result.forEach(item => {
        //         let conduttore = this.items_sedi_conduttore.find(r => r.id_conduttore === item.id_conduttore);

        //         if (!conduttore) {
        //           console.log("entra if conduttore");
        //           // Se non esiste ancora l'id_conduttore, lo aggiungo come nuovo oggetto
        //           conduttore = {
        //             id_conduttore: item.id_conduttore,
        //             conduttore: item.conduttore,
        //             sedi: [],
        //             slot_orari_primo_appuntamento: item.slot_orari_primo_appuntamento,
        //             orario_primo_appuntamento: item.orario_primo_appuntamento,
        //           };

        //           // Aggiungo il campo sedi all'oggetto esistente
        //           conduttore.sedi.push({
        //             id_conduttore_sede: item.id_conduttore_sede,
        //             predefinito: item.predefinito,
        //             id_comune: item.id_comune,
        //             localita: item.localita,
        //             id_provincia: item.id_provincia,
        //             provincia: item.provincia,
        //             civico: item.civico,
        //             cap: item.cap,
        //             latitudine: item.latitudine,
        //             longitudine: item.longitudine
        //           });
        //           this.items_sedi_conduttore.push(conduttore);
        //         }

        //       });

        //       console.log("array conduttori e sedi", this.items_sedi_conduttore);
        //       // this.items_sedi_conduttore.forEach(c => {
        //       //   c.selected = c.sedi.filter(e => e.predefinito == 1)[0].id_conduttore_sede;
        //       //   console.log("id conduttore sede", c.selected);

        //       // })

        //     } else {
        //       this.$refs.SnackbarQV.print(
        //         "orange",
        //         `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
        //       );
        //     }
        //   });
        // },
        getTecnicoAbilitato(item) {
            let arr = [];

            if (item.tecnici_ids) {
                this.autisti.forEach((a) => {
                    if (item.tecnici_ids.includes(a.id_conduttore)) {
                        arr.push(a);
                    }
                });
                if (arr.length == 1) item.id_conduttore = arr[0].id_conduttore;
                return arr;
            } else {
                return this.servizi_gruppo_viaggio
                    ? this.autisti.filter(
                        (e) => e.id_conduttore == item.id_conduttore
                    )
                    : this.autisti;
            }
        },
        openAzioneGiornata() {
            if (this.items_ottimizzati.length == 0) {
                this.$refs.SnackbarQV.print(
                    "orange",
                    `Nessun elemento visualizzato.`
                );
                return;
            } else {
                this.azione_sel = new Azione();
                this.azione_sel.id_azione = this.items_azioni[1].id_azione;
                this.azione_sel.data = moment(this.items_ottimizzati[0].ora_partenza).format("DD/MM/YYYY");

                let giornata = this.getIndirizziByData(this.azione_sel.data)

                this.azione_sel.ora = giornata.ora;
                this.azione_sel.id_sede_partenza = giornata.id_sede_partenza;
                this.azione_sel.id_sede_arrivo = giornata.id_sede_arrivo;

                // this.items_sedi_conduttore_vis = [];

                // this.items_sedi_conduttore.forEach(t => {
                //     t.zone_di_competenza.forEach(c => {
                //         this.items_ottimizzati.forEach(s => {
                //             if (c.provincia == s.provincia_arrivo && s.id_tipo_abilitazioni != null) {
                //                 const ids = s.id_tipo_abilitazioni
                //                     .split(',')
                //                     .map(x => Number(x.trim()));

                //                 ids.push(...ids);

                //                 if (
                //                     t.abilitazioni.some(ab => ids.includes(ab.id_tipo_abilitazione)) &&
                //                     !this.items_sedi_conduttore_vis.some(item => item.id_conduttore == t.id_conduttore)
                //                 ) {
                //                     this.items_sedi_conduttore_vis.push(t);
                //                 }
                //             }
                //         });
                //     })
                // })

                this.getConduttoriPerAreaECompetenze();

                this.dialog_azione = true;
            }

        },
        changeDataAzione() {
            console.log("azione_sel", this.azione_sel, this.items_sedi);
            let giornata = this.getIndirizziByData(this.azione_sel.data)

            this.azione_sel.ora = giornata.ora;
            this.azione_sel.id_sede_partenza = giornata.id_sede_partenza;
            this.azione_sel.id_sede_arrivo = giornata.id_sede_arrivo;

        },
        openMapsOttimizzati() {
            let arr = [];
            if (
                this.partenza_sel.latitudine_partenza != "" &&
                this.partenza_sel.longitudine_partenza != ""
            ) {
                console.log("partenza??", this.partenza_sel);

                arr.push(this.partenza_sel);
            }
            console.log("PARTENZA: ", this.partenza_sel);
            this.items_ottimizzati.forEach((e) => {
                arr.push(e);
            });

            // let arr_tappe = [];
            // arr.forEach((e) => {
            //     this.items_sedi.forEach((s) => {
            //         if (
            //             s.abilita_marker == 1 &&
            //             this.partenza_sel.id_sede != s.id_azienda_sede &&
            //             s.id_azienda_sede != e.id_servizio
            //         ) {
            //             arr_tappe.push(s);
            //         }
            //     });
            // });
            // arr.push(...new Set(arr_tappe));

            // if (this.servizi_viaggio.length != 0) {
            //   this.servizi_viaggio.forEach(e => {
            //     if (e.id_servizio) {
            //       arr.push(e)
            //     }

            //   })

            //   let arr_tappe = [];
            //   arr.forEach(e => {

            //     this.items_sedi.forEach(s => {
            //       if (s.abilita_marker == 1 && this.partenza_sel.id_sede != s.id_azienda_sede && s.id_azienda_sede != e.id_servizio) {
            //         arr_tappe.push(s);
            //       }
            //     })

            //   })
            //   arr.push(...new Set(arr_tappe));
            // } else {
            //   this.items_ottimizzati.forEach(e => {
            //     if (e.id_servizio) {
            //       arr.push(e)
            //     }
            //   })
            // }
            // let invalid = false;
            // arr.forEach(a => {
            //   if (a.latitudine_arrivo != null || a.latitudine_partenza != null || a.latitudine != null) {
            //     console.log("tutto ok");
            //   } else {
            //     this.$refs.SnackbarQV.print(
            //       "orange",
            //       `Coordinate invalide per il servizio ${a.codice_ordine}. Non è stato possibile aprire la mappa.`
            //     );

            //     invalid = true;
            //     console.log("no ok", invalid);
            //   }
            // })

            // if (this.items_sedi_conduttore.length != 0) {
            //   let arr_conduttori = [];
            //   this.items_sedi_conduttore.forEach(c => {
            //     let obj_con = {
            //       id_conduttore: c.id_conduttore,
            //       id_conduttore_sede: c.default.id_conduttore_sede,
            //       orario_primo_appuntamento: c.ora_primo_arrivo,
            //     }
            //     arr_conduttori.push(obj_con)
            //   })
            //   console.log("arr_conduttori", arr_conduttori);

            //   // this.$store.state.basic_parameters.conduttori = arr_conduttori;
            // }

            // if (invalid == false) {
            //   this.$store.state.basic_parameters = {};
            //   this.$store.state.basic_parameters.servizi_ottimizzati = arr;

            //   this.key_geo = this.key_geo == 1 ? 0 : 1;
            //   this.dialog_maps = true;
            // }

            this.$store.state.basic_parameters = {};
            this.$store.state.basic_parameters.servizi_ottimizzati = arr;
            this.$store.state.basic_parameters.conduttori = this.items_sedi_conduttore_vis.filter(e => e.selected);
            this.$store.state.basic_parameters.azione = this.azione_sel;
            this.$store.state.basic_parameters.partenza = this.partenza_sel;

            this.key_geo = this.key_geo == 1 ? 0 : 1;
            this.dialog_maps = true;
        },
        cambioOraArrivo(arg) {
            console.log("cambioOraArrivo", arg);
            arg.modificato = 1

        },
        getZone() {
            const getconfig = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getzone",
                    id_regione: null,
                    id_provincia: null,
                    id_comune: null
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", getconfig).then((res) => {
                this.overlay = false;
                this.items_area_competenza = [];
                if (res.status === 200) {
                    this.items_area_competenza = res.data.result;
                    console.log("items_zone", this.items_area_competenza);
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            }).catch((err) => {
                this.overlay = false;
                this.$refs.SnackbarQV.print("error", err.toString());
            });
        },
        selezionaServiziPagina() {
            var start = this.items_per_page * (this.page_num - 1);
            var end =
                start + this.items_per_page < this.servizi.length
                    ? start + this.items_per_page
                    : this.servizi.length;
            var select = false;

            for (var i = start; i < end; i++) {
                if (!this.servizi[i].selected) {
                    select = true;
                    break;
                }
            }

            for (i = start; i < end; i++) {
                if (this.servizi[i].pianificato == 0) {
                    this.$set(this.servizi[i], "selected", select);
                }
            }

            //this.data_table_key = !this.data_table_key;
        },
        SelectDettaglio() {
            this.DettaglioDialog = false;
            this.graphArgs.payload.params.push({
                simbolo: "$id_servizio_dettaglio",
                valore: this.dettaglio_sel,
            });
            this.graphKey = !this.graphKey;
            this.graphDialog = true;
        },
        async ApriAnagrafica() {
            var menuItem;
            let request = {
                controller: "Global",
                method: "POST",
                richiesta: {
                    action: "getmenuparametri",
                    token: localStorage.getItem("user_token"),
                    cod_modulo: "quickproject",
                },
            };

            await this.$store
                .dispatch("api", request)
                .then((res) => {
                    menuItem = res.data.result.moduli[0].moduli_menu.filter(
                        (e) => e.path == "/clienti/anagrafiche"
                    )[0];
                })
                .catch((err) => {
                    console.log(err);
                });

            this.inputArgs.landing_page =
                menuItem.path + "/" + menuItem.id_modulo_menu;
            this.componenteWF = "contabilita";
            this.dialog_gestione_aziende = true;
        },
        // filtroDaPianificare() {
        //   this.servizi = [];
        //   this.servizio_filter = [];
        //   if (this.solo_non_pianificati) {
        //     console.log("solo pianificati", this.solo_non_pianificati);

        //     this.servizi = this.servizi_ori.filter(e => e.pianificato == 0);
        //     console.log("servizi", this.servizi);

        //   } else {
        //     console.log("tutti", this.solo_non_pianificati);
        //     this.servizi = this.servizi_ori;
        //     console.log("servizi", this.servizi);
        //   }

        // },
        // formatDataInizio() {
        //   this.data_sel = moment(this.partenza_sel.data_inizio).format("DD/MM/YYYY");
        // },
        // metodo per rimettere la tab Generale quando
        // l'utente torna alla tabella dei servizi
        resetTab() {
            this.data_table = true;
            this.tab = 0;
        },
        // Servizio selezionato

        pageChange(page) {
            this.page_num = page;
            sessionStorage.setItem("page_servizi", page);
        },

        deleteItem(item) {
            console.log("dettaglio", item);
            this.selected_item = new Servizio(JSON.parse(JSON.stringify(item)));
            this.delete_dialog = true;
        },
        selectItem(item) {
            console.log("dettaglio", item);
            this.selected_item = new Servizio(JSON.parse(JSON.stringify(item)));
        },
        async getDettagliServizio() {
            if (this.selected_item.id_servizio != null) {
                const getserviziodettagli = {
                    controller: "logistic",
                    method: "POST",
                    richiesta: {
                        token: localStorage.getItem("user_token"),
                        action: "getserviziodettagli",
                        id_servizio: this.selected_item.id_servizio,
                    },
                };
                this.overlay = true;
                await this.$store
                    .dispatch("api", getserviziodettagli)
                    .then((res) => {
                        this.overlay = false;
                        if (res.status === 200 || res.status === 204) {
                            this.dettagli_servizio = [];
                            res.data.result.forEach((e) => {
                                if (e.validita === 1) {
                                    this.dettagli_servizio.push(e);
                                }
                            });
                            return true;
                        } else {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                            );
                            return false;
                        }
                    });
            }
        },
        // Nuovo Servizio
        nuovoServizio() {
            this.dettagli_servizio = [];
            this.data_table = false;
            this.tab = 1;
            this.carica_dettaglio = false;

            this.selected_item = new Servizio();
            this.selected_item.colore_sfondo = { hex: "#1976D2" };
            this.selected_item.colore_testo = { hex: "#000000" };
            this.getConfig();
        },
        // metodo per riempire gli array che danno
        // gli items agli autocomplete
        // aggiornaAutocomplete() {
        //   this.items_azienda = [];
        //   this.servizi.forEach((e) => {
        //     this.items_azienda.push({
        //       ragione_sociale: e.des_azienda,
        //       id_anagrafica: e.id_azienda,
        //     });
        //   });
        // },
        saveCambiaAzione() {
            this.overlay3 = true;
            let arr = [];
            let arr_conduttori = [];

            this.items_sedi_conduttore_vis.forEach((c) => {
                if (c.selected) {
                    let obj_con = {
                        id_conduttore: c.id_conduttore,
                        id_conduttore_sede_partenza: c.default_partenza.id_conduttore_sede,
                        id_conduttore_sede_arrivo: c.default_arrivo.id_conduttore_sede,
                        orario_primo_appuntamento: c.ora_primo_arrivo,
                    };
                    arr_conduttori.push(obj_con);
                }
            });
            this.items_ottimizzati.forEach((e) => {
                if (moment(e.ora_arrivo).format("DD/MM/YYYY") == this.azione_sel.data) {

                    let obj = {
                        id_servizio: e.id_servizio ? e.id_servizio : null,
                        id_conduttore_sede: e.id_conduttore_sede,
                        id_sede: e.id_sede
                            ? e.id_sede
                            : e.id_azienda_sede
                                ? e.id_azienda_sede
                                : null,
                        tempo_permanenza: e.tempo_permanenza
                            ? e.tempo_permanenza
                            : null,
                        tempo_attesa: null,
                        inizio_attivita:
                            moment(e.data_manuale).format("yyyy-MM-DD") +
                            " " +
                            moment(e.data_manuale).format("HH:mm"),
                        ora_arrivo:
                            moment(e.ora_arrivo).format("yyyy-MM-DD"),
                        // ora_arrivo:
                        //     moment(e.ora_arrivo).format("yyyy-MM-DD") +
                        //     " " +
                        //     moment(e.ora_arrivo).format("HH:mm"),
                        spostato: e.spostato ? 1 : 0,
                        modificato: e.modificato == 1 ? 1 : 0,
                        nuovo: e.nuovo,
                    };
                    console.log(e.tempo_permanenza);
                    arr.push(obj);
                }
            });


            const richiesta = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "ottimizzaviaggiselezionati",
                    tappe: arr,
                    conduttori: arr_conduttori,
                    data_viaggio: moment(this.azione_sel.data, "DD/MM/YYYY").format("YYYY-MM-DD"),
                    ottimizzazione: 1,
                    ottimizzazione_manuale: 1,
                    id_sede_partenza: this.azione_sel.id_sede_partenza,
                    id_sede_arrivo: this.azione_sel.id_sede_arrivo,
                    id_splitting_mode: this.azione_sel.id_distribuzione,
                    equiparazione: this.azione_sel.id_equiparazione,
                    id_funzione: this.azione_sel.id_azione,
                },
            };

            this.$store
                .dispatch("api", richiesta)
                .then((res) => {
                    this.overlay3 = false;
                    console.log("res cambio azione", res);
                    this.items_ottimizzati = [];
                    this.items_ottimizzati_ori = [];

                    if (res.status == 200 && res.data.result.length != 0) {
                        this.ordine_cambiato = false;
                        this.items_ottimizzati = res.data.result;
                        this.items_ottimizzati_ori = res.data.result;
                        this.items_ottimizzati.forEach((e, index) => {
                            console.log("e.codice_ordine", e);

                            e.numero_marker = index + 1;
                            e.data_manuale = moment(e.ora_partenza).format(
                                "yyyy-MM-DD HH:mm"
                            );
                            e.ora_arrivo = moment(e.ora_arrivo).format(
                                "yyyy-MM-DD HH:mm"
                            );
                            e.data_minima = e.data_minima != null ? moment(e.data_minima).format("yyyy-MM-DD") : null;
                            e.data_imballo = e.data_imballo != null ? moment(e.data_imballo).format("yyyy-MM-DD") : null;

                            if (e.tempo_permanenza) {
                                e.tempo_permanenza =
                                    e.tempo_permanenza.split(":")[0] +
                                    ":" +
                                    e.tempo_permanenza.split(":")[1];
                            }

                            e.ora_partenza =
                                e.ora_partenza == null
                                    ? moment(
                                        this.partenza_sel.data_inizio
                                    ).format("yyyy-MM-DD")
                                    : e.ora_partenza;


                        });



                        this.$refs.SnackbarQV.print(
                            "success",
                            "Ottimizzazione avvenuta con successo."
                        );
                        // this.filtraServOttimizzati();
                        this.dialog_azione = false;
                        //  this.dialog_gestione_partenza = false;
                    } else {
                        this.overlay3 = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Nessun dato presente, non è stato possibile caricare i dati."
                        );
                    }
                    this.errore_sel = res.data.logAttivita || null;
                    if (this.errore_sel.length != 0) this.dialog_error = true;
                    this.dialog_conferma_ott = false;
                })
                .catch((e) => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print("error", "Errore: " + e);
                    if (this.errore_sel.length != 0) this.dialog_error = true;
                    this.dialog_conferma_ott = false;
                });
        },
        getDateOttimizzati() {
            console.log("getDateOttimizzati");

            const date = new Set()
            return this.items_ottimizzati
                .map(e => moment(e.ora_arrivo).format("DD/MM/YYYY"))
                .filter(data => {
                    if (date.has(data)) return false
                    date.add(data)
                    return true
                })
        },
        getIndirizziByData(data) {
            // Filtra gli elementi con la stessa data (formattata come DD/MM/YYYY)
            const items_filtrati = this.items_ottimizzati.filter(item =>
                moment(item.ora_partenza).format("DD/MM/YYYY") === data
            );

            if (items_filtrati.length === 0) {
                return null; // Nessun elemento trovato per la data
            }

            console.log("items_filtrati", items_filtrati);

            return {
                id_sede_partenza: items_filtrati[0].id_sede_partenza,
                ora: moment(items_filtrati[0].ora_partenza).format("HH:mm"),
                id_sede_arrivo: items_filtrati[items_filtrati.length - 1].id_sede_arrivo
            };
        },
        async getAziende() {
            const getragionesociale = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getaziende",
                    id_anagrafica: this.selected_item.id_azienda,
                },
            };
            this.overlay = true;
            return this.$store
                .dispatch("api", getragionesociale)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200) {
                        if (res.data.result.length > 0)
                            this.azienda_detail = res.data.result[0];
                        return true;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                        return false;
                    }
                });
        },
        getTipoRichiesta() {
            const seen = new Set();
            return this.servizi_ori.filter(s => {
                if (!s.stato_documento) return false; // esclude null, undefined e stringhe vuote
                if (seen.has(s.stato_documento)) return false;
                seen.add(s.stato_documento);
                return true;
            });
        },
        chiudiMaps(arg) {
            console.log("servizi che passo dalla mappa", arg);

            this.dialog_maps = false;
            if (arg.length != 0) {
                if (arg[0].id_gruppo_servizi != 0) {
                    this.servizi_gruppo_viaggio = true;
                }


                this.items_ottimizzati = [];
                this.items_ottimizzati_ori = [];

                arg.forEach((e, index) => {
                    e.numero_marker = index + 1;
                    // e.tempo_permanenza =
                    //     e.tempo_permanenza != "00:00"
                    //         ? e.tempo_permanenza
                    //         : this.items_slot_attesa[2];
                    e.ora_partenza =
                        e.ora_partenza == null
                            ? moment(this.partenza_sel.data_inizio).format(
                                "yyyy-MM-DD"
                            )
                            : e.ora_partenza;
                    e.data_manuale = moment(e.ora_partenza).format(
                        "yyyy-MM-DD HH:mm"
                    );
                    e.ora_arrivo = moment(e.ora_arrivo).format(
                        "yyyy-MM-DD HH:mm"
                    );
                    e.data_minima = e.data_minima != null ? moment(e.data_minima).format("yyyy-MM-DD") : null;
                    e.data_imballo = e.data_imballo != null ? moment(e.data_imballo).format("yyyy-MM-DD") : null;
                    if (e.id_servizio == 0) {
                        e.id_servizio = null;
                    }

                    this.items_ottimizzati.push(e);
                    this.items_ottimizzati_ori.push(e);

                    // DATA FILTRO RANGE OTT.
                    this.data_da_filter_ott = new Date();
                    this.data_a_filter_ott = new Date();
                    this.items_ottimizzati_ori.forEach(e => {
                        let data = new Date(e.ora_partenza);
                        if (data < this.data_da_filter_ott) {
                            this.data_da_filter_ott = data;
                        }
                        if (data > this.data_a_filter_ott) {
                            console.log("entra data max");
                            this.data_a_filter_ott = data;
                        }
                    });
                    this.data_da_filter_ott = moment(this.data_da_filter_ott).format("yyyy-MM-DD");
                    this.data_a_filter_ott = moment(this.data_a_filter_ott).format("yyyy-MM-DD");
                });

                this.conduttore_filter = this.items_ottimizzati[0].id_gruppo_servizi != 0 ? arg[0].id_conduttore : null;
            }

        },
        eliminaServizio() {
            this.overlay3 = true;
            if (this.selected_item.id_temp || this.selected_item.id_sede) {
                this.ordine_cambiato = true;
                this.items_ottimizzati = this.items_ottimizzati.filter(
                    (e) =>
                        e.id_temp != this.selected_item.id_temp ||
                        e.id_sede != this.selected_item.id_sede
                );
                return;
            }

            this.items_ottimizzati = this.items_ottimizzati.filter(
                (e) => e.id_servizio != this.selected_item.id_servizio
            );

            const request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "delete",
                    id_servizio: this.selected_item.id_servizio,
                    delete_associazioni: 0,
                },
            };
            this.$store.dispatch("api", request).then((res) => {
                if (res.status === 200) {
                    this.delete_dialog = false;
                    this.selected_item = new Servizio();
                    this.$refs.SnackbarQV.print("success", `Dati salvati`);
                    this.dialog_gestione_pianificazione = false;
                    this.dialog_elimina_sched = false;
                    this.dialog_elimina_pianificazione = false;
                    this.servizio_pianificato_sel = null;
                    this.servizio_pianificato_dettaglio_sel = null;
                    this.servizio_sel = null;
                    this.servizio_ass_sel = null;
                    this.ordine_cambiato = true;
                    this.getServizi();
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }

                this.overlay3 = false;
            });
        },
        eliminaServizioDef() {
            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "deleteservizi",
                    token: localStorage.getItem("user_token"),
                    id_servizi: this.selected_item.id_servizio,
                },
            };

            // Overlay di caricamento
            this.overlay = true;

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200) {
                        this.delete_dialog = false;
                        this.getServizi();
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Servizi eliminati correttamente."
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((e) => {
                    console.error(e);

                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );

                    // tolgo l'overlay
                    this.overlay = false;
                });
        },
        selezionaServizi(arg) {
            if (arg.pianificato != 1) {
                if (arg.selected == true) {
                    this.array_selezionati.push(arg);
                } else {
                    this.array_selezionati = this.array_selezionati.filter(e => e.id_servizio != arg.id_servizio)
                }
                console.log("servizi selezionati", this.array_selezionati);
            } else {
                if (arg.selected == true) {
                    this.array_apri_viaggi.push(arg);
                } else {
                    this.array_apri_viaggi = this.array_apri_viaggi.filter(e => e.id_servizio != arg.id_servizio)
                }
                console.log("servizi selezionati per apertura", this.array_apri_viaggi);
            }
        },
        eliminaGruppoViaggio() {
            this.overla3 = true;
            let arr = [];
            this.items_ottimizzati.forEach((e) => {
                arr.push(e.id_servizio);
            });
            const request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "deletegruppoviaggio",
                    tappe: arr.toString(),
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.overlay3 = false;
                    if (res.status === 200 || res.status === 204) {
                        this.$refs.SnackbarQV.print("success", `Dati salvati`);
                        this.dialog_ottimizzati = false;
                        this.servizi_gruppo_viaggio = false;
                        this.mode_pianificazione = false;
                        this.viaggio_sel = null;
                        this.dialog_elimina_viaggio = false;
                        this.conduttore_filter = null;
                        this.getServizi();
                    } else {
                        this.overlay3 = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                        );
                    }

                    this.errore_sel = res.data.logAttivita || null;
                    if (this.errore_sel.length != 0) this.dialog_error = true;
                    this.dialog_conferma_ott = false;
                })
                .catch((e) => {
                    this.overlay3 = false;
                    console.error(e);
                    if (this.errore_sel.length != 0) this.dialog_error = true;
                    this.dialog_conferma_ott = false;
                    // this.$refs.SnackbarQV.print(
                    //     "error",
                    //     "Errore di comunicazione col server"
                    // );
                });
        },
        getConfig() {
            const getconfig = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getconfig",
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", getconfig).then((res) => {
                this.overlay = false;
                if (res.status === 200 || res.status === 204) {
                    this.selected_item.localita_partenza =
                        res.data.result.localita_partenza;
                    this.selected_item.provincia_partenza =
                        res.data.result.provincia_partenza;
                    this.selected_item.indirizzo_partenza =
                        res.data.result.indirizzo_partenza;
                    this.selected_item.civico_partenza =
                        res.data.result.civico_partenza;
                    this.selected_item.cap_partenza =
                        res.data.result.cap_partenza;
                    this.selected_item.slot_attesa =
                        res.data.result.slot_attesa;

                    this.selected_item.tempo_setup_partenza =
                        res.data.result.tempo_setup_partenza;
                    this.selected_item.tempo_setup_arrivo =
                        res.data.result.tempo_setup_arrivo;
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
        },
        getSedi() {
            const getconfig = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getsedifiliali",
                    id_regione: null,
                    id_provincia: null,
                    id_comune: null,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", getconfig).then((res) => {
                this.overlay = false;
                if (res.status === 200 || res.status === 204) {
                    this.items_sedi = res.data.result;
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
        },
        getSediMagazzino() {
            const getconfig = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getsedifiliali",
                    id_regione: null,
                    id_provincia: null,
                    id_comune: null,
                    magazzino: 1,
                    fine_giornata: 0
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", getconfig).then((res) => {
                this.overlay = false;
                this.items_sedi_magazzino = [];
                if (res.status === 200) {
                    this.items_sedi_magazzino = res.data.result;
                }
            });
        },
        getRegioni() {
            const getconfig = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getregioni",
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", getconfig).then((res) => {
                this.overlay = false;
                if (res.status === 200 || res.status === 204) {
                    this.items_regioni = res.data.result;
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
        },
        getProvince() {
            this.overlay = true;
            const getconfig = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getprovince",
                    id_regione: this.regione_sel.toString(),
                },
            };
            this.$store.dispatch("api", getconfig).then((res) => {
                this.overlay = false;
                if (res.status === 200) {
                    this.items_province = res.data.result;
                    this.provincia_sel = res.data.result;
                    this.filtra();
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
        },
        getComuni(arg) {
            const getconfig = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getcomuni",
                    id_provincia: arg,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", getconfig).then((res) => {
                this.overlay = false;
                if (res.status === 200 || res.status === 204) {
                    this.items_comuni = res.data.result;
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`);
                }
            });
        },
        selectRow(item) {
            console.log("item click", item);
            this.selected_row = this.selected_row === item.id_servizio ? null : item.id_servizio;
            this.data_table_key = !this.data_table_key;
        },
        getConduttoriPerAreaECompetenze() {

            this.items_sedi_conduttore_vis = [];

            // trovo gli autisti per area competenza
            this.items_sedi_conduttore.forEach(t => {
                t.zone_di_competenza.forEach(c => {
                    if (c.predefinito == 1) {
                        this.items_ottimizzati.forEach(s => {
                            if (c.provincia == s.provincia_arrivo && s.id_tipo_abilitazioni != null) {
                                const ids = s.id_tipo_abilitazioni
                                    .split(',')
                                    .map(x => Number(x.trim()));

                                ids.push(...ids);

                                if (
                                    t.abilitazioni.some(ab => ids.includes(ab.id_tipo_abilitazione)) &&
                                    !this.items_sedi_conduttore_vis.some(item => item.id_conduttore == t.id_conduttore)
                                ) {
                                    this.items_sedi_conduttore_vis.push(t);
                                }
                            }
                        })
                    }

                })
            })
            const conduttori_ottimizzati = [...new Set(this.items_ottimizzati.map(obj => obj.id_conduttore))];
            this.items_sedi_conduttore_vis.forEach(i => {
                if (conduttori_ottimizzati.includes(i.id_conduttore)) {
                    i.selected = true;
                }
            })

        },
        conduttoriPianificaOttimizzati(arg) {
            console.log("clicco il pulsante", arg);

            this.btn_ottimizzazione = arg;
            if (arg == 3 || arg == 1) {
                this.dialog_conferma_ott = true;
                // this.ottimizzaGruppoViaggi();
                return;
            }

            if (arg == 4) {
                this.items_sedi_conduttore_vis = this.items_sedi_conduttore.filter(e => e.id_conduttore == this.items_ottimizzati[0].id_conduttore);
                this.items_sedi_conduttore_vis[0].selected = true;
            } else {
                this.getConduttoriPerAreaECompetenze();
            }

            this.mode_pianificazione = true;


            this.dialog_gestione_partenza = true;
        },
        // conduttoriPianificaOttimizzati(arg) {
        //     console.log("arg btn", arg);
        //     this.btn_ottimizzazione = arg;

        //     this.items_sedi_conduttore_vis = [];
        //     console.log("items_sedi_conduttore", this.items_sedi_conduttore);

        //     this.items_sedi_conduttore.forEach(t => {
        //         let trovato = false;
        //         t.zone_di_competenza.forEach(c => {
        //             this.items_ottimizzati.forEach(s => {
        //                 console.log("abilitazioni", s.id_tipo_abilitazioni);
        //                 if (s.id_tipo_abilitazioni) {
        //                     const ids = s.id_tipo_abilitazioni
        //                         .split(',')
        //                         .map(x => Number(x.trim()));
        //                     if (c.provincia == s.provincia_arrivo && ids.includes(t.abilitazioni[0].id_tipo_abilitazione)) {
        //                         trovato = true;
        //                     }
        //                 }

        //             })
        //         })

        //         if (trovato) {
        //             console.log("trovato entra");
        //             t.selected = true;
        //             this.items_sedi_conduttore_vis.push(t);
        //         }
        //     })

        //     this.dialog_gestione_partenza = true;
        //     this.mode_pianificazione = true;
        // },
        pianificaOttimizzati(arg) {
            this.dialog_gestione_partenza = false;
            let block = false;
            this.arr_remove = [];
            this.items_ottimizzati.forEach((e) => {
                delete e.parcheggi;

                // if (e.indirizzo_arrivo == null) {
                //     this.arr_remove.push(e.codice_ordine);


                // }
                // if (
                //     e.codice_servizio != "000" &&
                //     e.tempo_permanenza == "00:00"
                // ) {
                //     console.log("qui il tempo è vuoto", e);

                //     this.$refs.SnackbarQV.print(
                //         "orange",
                //         `Inserire tempo di permanenza per il servizio ${e.codice_servizio}.`
                //     );
                //     block = true;
                // }
                if (e.id_conduttore == null) {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Selezionare il conduttore per il servizio ${e.codice_servizio}.`
                    );
                    block = true;
                }
            });

            if (block == true) return;

            this.overlay2 = true;

            let arr_conduttori = [];

            this.items_sedi_conduttore_vis.forEach((c) => {
                if (c.selected) {
                    let obj_con = {
                        id_conduttore: c.id_conduttore,
                        id_conduttore_sede_partenza: c.default_partenza.id_conduttore_sede,
                        id_conduttore_sede_arrivo: c.default_arrivo.id_conduttore_sede,
                        orario_primo_appuntamento: c.ora_primo_arrivo,
                    };
                    arr_conduttori.push(obj_con);
                }
            });

            console.log("partenza_sel", this.partenza_sel);

            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "pianificazione",
                    conduttori: arr_conduttori,
                    servizi: this.items_ottimizzati.filter(e => e.indirizzo_arrivo != null),
                    data_viaggio: this.partenza_sel.data_inizio,
                    id_splitting_mode: this.azione_sel.id_distribuzione,
                    equiparazione: this.azione_sel.id_equiparazione,
                    id_funzione: this.azione_sel.id_azione,
                },
            };

            if (arg == 1) {
                request.richiesta.simulazione = 1;
            }

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.overlay2 = false;
                    if (res.status === 200) {
                        // this.dialog_ottimizzati = false;
                        this.items_ottimizzati = [];
                        this.items_ottimizzati_ori = [];
                        this.items_ottimizzati =
                            res.data.result != null ? res.data.result : [];
                        this.items_ottimizzati_ori =
                            res.data.result != null ? res.data.result : [];
                        if (this.items_ottimizzati.length != 0) {
                            this.servizi_gruppo_viaggio = true;
                            this.items_ottimizzati.forEach((e, index) => {
                                e.data_manuale = moment(e.ora_partenza).format(
                                    "yyyy-MM-DD HH:mm"
                                );
                                e.data_minima = e.data_minima != null ? moment(e.data_minima).format("yyyy-MM-DD") : null;
                                e.data_imballo = e.data_imballo != null ? moment(e.data_imballo).format("yyyy-MM-DD") : null;
                                e.numero_marker = index + 1;
                                if (
                                    this.id_conduttore_sel != null &&
                                    e.id_conduttore == null
                                ) {
                                    e.id_conduttore = this.id_conduttore_sel;
                                } else if (e.id_conduttore == null) {
                                    e.id_conduttore = this.servizi.filter(
                                        (s) => s.selected == true
                                    )[0].id_conduttore;
                                }


                                if (e.tempo_permanenza) {
                                    e.tempo_permanenza =
                                        e.tempo_permanenza.split(":")[0] +
                                        ":" +
                                        e.tempo_permanenza.split(":")[1];
                                    console.log(e.tempo_permanenza);
                                }
                            });

                            this.conduttore_filter = this.items_ottimizzati[0].id_gruppo_servizi != 0 ? this.items_ottimizzati[0].id_conduttore : null;

                            this.$refs.SnackbarQV.print(
                                "success",
                                `Pianificazione avvenuta.`
                            );
                            // DATA FILTRO RANGE OTT.
                            this.data_da_filter_ott = new Date();
                            this.data_a_filter_ott = new Date();
                            this.items_ottimizzati_ori.forEach(e => {
                                let data = new Date(e.ora_partenza);
                                if (data < this.data_da_filter_ott) {
                                    this.data_da_filter_ott = data;
                                }
                                if (data > this.data_a_filter_ott) {
                                    console.log("entra data max");
                                    this.data_a_filter_ott = data;
                                }
                            });
                            this.data_da_filter_ott = moment(this.data_da_filter_ott).format("yyyy-MM-DD");
                            this.data_a_filter_ott = moment(this.data_a_filter_ott).format("yyyy-MM-DD");
                            this.filtraServOttimizzati();
                        } else {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                `Nessun risultato disponibile.`
                            );
                        }
                        this.visualizza_mappa = true;
                    } else {
                        this.overlay2 = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            `Errore di comunicazione col server API GOOGLE, non è stato possibile aggiornare i dati.`
                        );
                        this.servizi.forEach((e) => {
                            if (e.selected) {
                                this.items_ottimizzati.push(e);
                            }
                        });
                    }

                    this.errore_sel = res.data.logAttivita || null;
                    if (this.errore_sel.length != 0) this.dialog_error = true;
                    this.dialog_conferma_ott = false;
                })
                .catch((e) => {
                    this.overlay2 = false;
                    console.error(e);
                    if (this.errore_sel.length != 0) this.dialog_error = true;
                    this.dialog_conferma_ott = false;
                    // this.$refs.SnackbarQV.print(
                    //     "error",
                    //     "Errore di comunicazione col server"
                    // );
                    this.loading = false;
                });
        },
        clickSede(item) {
            if (this.change_sede_pausa) {
                this.items_sedi.forEach((e) => {
                    delete e.selected;
                });
            }
            item.selected = true;
        },

        salvaTempoPermanenza(item){

            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "savetempopermanenza",
                    token: localStorage.getItem("user_token"),
                    id_servizio: item.id_servizio,
                    tempo_permanenza: item.tempo_permanenza
                },
            };

            // Overlay di caricamento
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    
                    if (res.status == 200) {

                        this.$refs.SnackbarQV.print(
                            "success",
                            "Tempo di percorrenza salvato correttamente."
                        );

                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((e) => {
                    // stampo l'errore
                    console.error(e);
                    // snackbar avvertimento
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    // tolgo l'overlay
                    this.overlay = false;
                });

        },
        
        changeSedePause(arg) {
            this.sede_pausa_sel = arg;
            this.change_sede_pausa = true;
            this.dialog_agg_tappa = true;
        },
        getServizi() {
            // this.array_selezionati = [];
            this.overlay_servizi = true;
            const getservizi = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getservizi",
                    id_servizio: null,
                },
            };

            this.$store
                .dispatch("api", getservizi)
                .then((res) => {
                    this.overlay_servizi = false;
                    this.overlay = false;
                    this.overlay2 = false;
                    this.servizi = [];
                    this.servizi_ori = [];
                    this.conduttore_filter = null;
                    if (res.status === 200 && res.data.result.length != 0) {
                        let arr_ids = []
                        res.data.result.forEach((e) => {
                            if (e.id_viaggio != 0) arr_ids.push(e.id_viaggio)
                            e.data_minima = e.data_minima != null ? moment(e.data_minima).format("DD/MM/YYYY") : "";
                            // e.ora_arrivo = e.ora_arrivo != null ? moment(e.ora_arrivo).format("DD/MM/YYYY HH:mm") : ""
                            // e.data_imballo = e.data_imballo == "0001-01-01T00:00:00" ? "" : moment(e.data_imballo).format("DD/MM/YYYY HH:mm")
                            e.localita_e_provincia =
                                e.localita_arrivo +
                                " (" +
                                e.provincia_arrivo +
                                ")";
                        });


                        this.servizi = res.data.result;
                        this.servizi_ori = res.data.result;
                        this.filtra();

                        if (this.array_selezionati.length > 0) {
                            this.servizi.forEach(s => {
                                s.selected = this.array_selezionati.some(e => e.id_servizio === s.id_servizio);
                            });
                        }
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                        );
                    }
                })
                .catch((e) => {
                    this.overlay_servizi = false;
                    this.overlay = false;
                    this.overlay2 = false;
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                });
        },
        getGruppoViaggi(arg) {

            let id_viaggio_tmp = "";
            if (this.array_apri_viaggi.length == 0) {
                this.overlay2 = true;
                console.log("arg get gruppo viaggi", arg);

                this.visualizza_mappa = true;
                this.from_viaggio_servizio = true;

                this.viaggio_sel = arg ? arg.id_gruppo_servizi : null;
                id_viaggio_tmp = arg ? arg.id_gruppo_servizi : this.items_ottimizzati[0].id_gruppo_servizi;
            } else {
                this.array_apri_viaggi.forEach((v) => {
                    id_viaggio_tmp = id_viaggio_tmp != "" ? id_viaggio_tmp + ", " + v.id_gruppo_servizi : v.id_gruppo_servizi;
                });
            }

            console.log(id_viaggio_tmp);

            const request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getgruppoviaggi",
                    id_viaggio: id_viaggio_tmp,
                },
            };
            this.overlay = true;
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.overlay = false;
                    this.overlay2 = false;
                    // this.servizi_viaggio = [];
                    this.items_ottimizzati = [];
                    this.items_ottimizzati_ori = [];
                    this.servizi_gruppo_viaggio = true;
                    if (res.status === 200 || res.status === 204) {
                        this.items_ottimizzati = res.data.result
                            ? res.data.result
                            : [];

                        if (this.items_ottimizzati.length != 0) {
                            // this.id_conduttore_sel =
                            //     this.items_ottimizzati[0].id_conduttore;
                            // this.conduttore_filter =
                            //     this.items_ottimizzati[0].id_conduttore;
                            this.items_ottimizzati.forEach((e, index) => {
                                // e.ora_manuale = moment(e.ora_partenza).format("HH:mm");
                                e.data_manuale = moment(e.ora_partenza).format(
                                    "yyyy-MM-DD HH:mm"
                                );
                                e.data_minima = e.data_minima != null ? moment(e.data_minima).format("yyyy-MM-DD") : null;
                                e.data_imballo = e.data_imballo != null ? moment(e.data_imballo).format("yyyy-MM-DD") : null;
                                e.numero_marker = index + 1;
                                if (e.tempo_permanenza) {
                                    e.tempo_permanenza =
                                        e.tempo_permanenza.split(":")[0] +
                                        ":" +
                                        e.tempo_permanenza.split(":")[1];
                                    console.log(e.tempo_permanenza);
                                }

                                this.items_ottimizzati_ori.push(e);
                            });
                            this.conduttore_filter = this.items_ottimizzati_ori[0].id_conduttore

                            // DATA FILTRO RANGE OTT.
                            this.data_da_filter_ott = new Date();
                            this.data_a_filter_ott = new Date();

                            this.items_ottimizzati_ori.forEach(e => {
                                let data = new Date(e.ora_partenza);
                                if (data < this.data_da_filter_ott) {
                                    this.data_da_filter_ott = data;
                                }
                                if (data > this.data_a_filter_ott) {
                                    console.log("entra data max");
                                    this.data_a_filter_ott = data;
                                }
                            });
                            this.data_da_filter_ott = moment(this.data_da_filter_ott).format("yyyy-MM-DD");
                            this.data_a_filter_ott = moment(this.data_a_filter_ott).format("yyyy-MM-DD");

                            this.array_apri_viaggi = [];
                            this.filtraServOttimizzati();
                            this.dialog_ottimizzati = true;
                        } else {
                            this.overlay = false;
                            this.$refs.SnackbarQV.print(
                                "orange",
                                `Dati non validi.`
                            );
                        }
                    } else {
                        this.overlay = false;
                        this.overlay2 = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                        );
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    this.overlay = false;
                    this.overlay2 = false;
                });
        },
        openViaggioConduttore() {
            const request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getgruppoviaggi",
                    id_viaggio: null,
                    id_tecnico: this.tecnico_sel,
                },
            };
            this.overlay = true;
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.overlay = false;
                    this.items_ottimizzati = [];
                    this.items_ottimizzati_ori = [];
                    this.servizi_gruppo_viaggio = true;
                    if (res.status === 200 && res.data.result.length) {
                        this.items_ottimizzati = res.data.result
                            ? res.data.result
                            : [];
                        this.items_ottimizzati_ori = res.data.result
                            ? res.data.result
                            : [];
                        this.id_conduttore_sel =
                            this.items_ottimizzati[0].id_conduttore;
                        this.conduttore_filter =
                            this.items_ottimizzati[0].id_conduttore;
                        this.items_ottimizzati.forEach((e, index) => {
                            // e.ora_manuale = moment(e.ora_partenza).format("HH:mm");
                            e.data_manuale = moment(e.ora_partenza).format(
                                "yyyy-MM-DD HH:mm"
                            );
                            e.data_minima = e.data_minima != null ? moment(e.data_minima).format("yyyy-MM-DD") : null;
                            e.data_imballo = e.data_imballo != null ? moment(e.data_imballo).format("yyyy-MM-DD") : null;
                            e.numero_marker = index + 1;
                            if (e.tempo_permanenza) {
                                e.tempo_permanenza =
                                    e.tempo_permanenza.split(":")[0] +
                                    ":" +
                                    e.tempo_permanenza.split(":")[1];
                                console.log(e.tempo_permanenza);
                            }
                        });
                        // DATA FILTRO RANGE OTT.
                        this.data_da_filter_ott = new Date();
                        this.data_a_filter_ott = new Date();
                        this.items_ottimizzati_ori.forEach(e => {
                            let data = new Date(e.ora_partenza);
                            if (data < this.data_da_filter_ott) {
                                this.data_da_filter_ott = data;
                            }
                            if (data > this.data_a_filter_ott) {
                                console.log("entra data max");
                                this.data_a_filter_ott = data;
                            }
                        });
                        this.data_da_filter_ott = moment(this.data_da_filter_ott).format("yyyy-MM-DD");
                        this.data_a_filter_ott = moment(this.data_a_filter_ott).format("yyyy-MM-DD");

                        this.dialog_ottimizzati = true;
                    } else {
                        this.overlay = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Non ci sono servizi pianificati per questo conduttore."
                        );
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$refs.SnackbarQV.print("error", "Errore server.");
                    this.overlay = false;
                });
        },
        changeConduttoreFilter() {
            if (this.conduttore_filter != null) {
                if (this.items_ottimizzati[0]?.id_gruppo_servizi != 0) {
                    console.log("entra getviaggi conduttore",);

                    this.getViaggiConduttore();
                } else {
                    this.filtraServOttimizzati()
                }
            }
        },
        getViaggiConduttore() {
            const request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getgruppoviaggi",
                    id_viaggio: null,
                    id_tecnico: this.conduttore_filter,
                },
            };
            this.overlay2 = true;
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.overlay2 = false;
                    this.items_ottimizzati = [];
                    this.items_ottimizzati_ori = [];
                    this.servizi_gruppo_viaggio = true;
                    if (res.status === 200 && res.data.result.length) {
                        this.items_ottimizzati = res.data.result
                            ? res.data.result
                            : [];
                        this.items_ottimizzati_ori = res.data.result
                            ? res.data.result
                            : [];
                        this.id_conduttore_sel =
                            this.items_ottimizzati[0].id_conduttore;
                        this.conduttore_filter =
                            this.items_ottimizzati[0].id_conduttore;
                        this.items_ottimizzati.forEach((e, index) => {
                            // e.ora_manuale = moment(e.ora_partenza).format("HH:mm");
                            e.data_manuale = moment(e.ora_partenza).format(
                                "yyyy-MM-DD HH:mm"
                            );
                            e.data_minima = e.data_minima != null ? moment(e.data_minima).format("yyyy-MM-DD") : null;
                            e.data_imballo = e.data_imballo != null ? moment(e.data_imballo).format("yyyy-MM-DD") : null;
                            e.numero_marker = index + 1;
                            if (e.tempo_permanenza) {
                                e.tempo_permanenza =
                                    e.tempo_permanenza.split(":")[0] +
                                    ":" +
                                    e.tempo_permanenza.split(":")[1];
                                console.log(e.tempo_permanenza);
                            }
                        });
                        // DATA FILTRO RANGE OTT.
                        this.data_da_filter_ott = new Date();
                        this.data_a_filter_ott = new Date();
                        this.items_ottimizzati_ori.forEach(e => {
                            let data = new Date(e.ora_partenza);
                            if (data < this.data_da_filter_ott) {
                                this.data_da_filter_ott = data;
                            }
                            if (data > this.data_a_filter_ott) {
                                console.log("entra data max");
                                this.data_a_filter_ott = data;
                            }
                        });
                        this.data_da_filter_ott = moment(this.data_da_filter_ott).format("yyyy-MM-DD");
                        this.data_a_filter_ott = moment(this.data_a_filter_ott).format("yyyy-MM-DD");

                        this.filtraServOttimizzati();

                        this.dialog_ottimizzati = true;
                    } else {
                        this.overlay = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Non ci sono servizi pianificati per questo conduttore."
                        );
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$refs.SnackbarQV.print("error", "Errore server.");
                    this.overlay2 = false;
                });
        },
        cambiaTecnicoAll() {
            this.dialog_change_tecnico = true;
            this.autisti.forEach((e) => {
                if (e.id_conduttore == this.conduttore_filter) {
                    console.log(
                        "e.id_conduttore, this.conduttore_filter",
                        e,
                        this.conduttore_filter
                    );
                    this.conduttore_da_cambiare = e;
                }
            });
        },
        confermaCambioTecnico() {
            this.items_ottimizzati.forEach((e) => {
                e.id_conduttore = this.new_conduttore;
            });
            this.conduttore_filter = this.new_conduttore;

            this.dialog_change_tecnico = false;
            this.new_conduttore = null;
            this.$refs.SnackbarQV.print("success", `Dati salvati.`);
        },
        openServiziSuggeriti() {
            if (
                (this.$refs.createDettaglio.selected_item.id_tipo_macchina ==
                    null ||
                    this.$refs.createDettaglio.selected_item.um_volume ==
                    null) &&
                this.dettagli_servizio.length == 0
            ) {
                this.$refs.SnackbarQV.print(
                    "orange",
                    `Dati opzioni servizio non completi.`
                );
                return;
            }

            this.dialog_servizi_suggeriti = true;
            this.loading = true;

            const getservizi = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "abbinamentipossibili",
                    data_viaggi: this.selected_item.data_inizio,
                    localita_partenza: this.selected_item.localita_partenza,
                    provincia_partenza: this.selected_item.provincia_partenza,
                    cap_partenza: this.selected_item.cap_partenza,
                    indirizzo_partenza: this.selected_item.indirizzo_partenza,
                    civico_partenza: this.selected_item.civico_partenza,
                    localita_arrivo: this.selected_item.localita_arrivo,
                    provincia_arrivo: this.selected_item.provincia_arrivo,
                    cap_arrivo: this.selected_item.cap_arrivo,
                    id_fascia_oraria: this.selected_item.id_fascia_oraria,
                    indirizzo_arrivo: this.selected_item.indirizzo_arrivo,
                    civico_arrivo: this.selected_item.civico_arrivo,
                    ora_inizio:
                        this.selected_item.ora_inizio == ""
                            ? null
                            : this.selected_item.ora_inizio,
                    id_tipo_servizio_dettaglio:
                        this.dettagli_servizio.length != 0
                            ? this.dettagli_servizio[0]
                                .id_tipo_servizio_dettaglio
                            : this.$refs.createDettaglio.selected_item
                                .id_tipo_servizio_dettaglio,
                    id_tipo_materiale:
                        this.dettagli_servizio.length != 0
                            ? this.dettagli_servizio[0].id_tipo_materiale
                            : this.$refs.createDettaglio.selected_item
                                .id_tipo_materiale,
                    id_tipo_macchina:
                        this.dettagli_servizio.length != 0
                            ? this.dettagli_servizio[0].id_tipo_macchina
                            : this.$refs.createDettaglio.selected_item
                                .id_tipo_macchina,
                    volume:
                        this.dettagli_servizio.length != 0
                            ? this.dettagli_servizio[0].volume
                            : this.$refs.createDettaglio.selected_item.volume,
                    um_volume:
                        this.dettagli_servizio.length != 0
                            ? this.dettagli_servizio[0].um_volume
                            : this.$refs.createDettaglio.selected_item
                                .um_volume,
                },
            };
            this.$store
                .dispatch("api", getservizi)
                .then((res) => {
                    this.loading = false;
                    if (res.status == 200) {
                        this.servizi_suggeriti = [];
                        this.servizi_suggeriti = res.data.result;
                        this.servizi_suggeriti.forEach((e) => {
                            e.ora_inizio_attivita = moment(
                                e.inizio_attivita
                            ).format("HH:mm");
                            e.ora_fine_attivita = moment(
                                e.fine_attivita
                            ).format("HH:mm");
                            e.inizio_attivita = moment(
                                e.inizio_attivita
                            ).format("DD/MM/YYYY");

                            e.fine_attivita = moment(e.fine_attivita).format(
                                "DD/MM/YYYY"
                            );

                            e.selezionato = false;
                        });

                        this.servizi_suggeriti.sort(
                            (a, b) => a.distanza_value - b.distanza_value
                        );
                    } else {
                        this.loading = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            `Nessun elemento trovato.`
                        );
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    this.loading = false;
                });
        },
        serviziSuggeritiFromPianificazione() {

            this.dialog_servizi_suggeriti = true;
            this.loading = true;

            const getservizi = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "abbinamentipossibili",
                    id_fascia_oraria:
                        this.servizio_associato_da_pianificare.id_fascia_oraria,
                    data_viaggi:
                        this.servizio_associato_da_pianificare.data_inizio,
                    localita_partenza:
                        this.servizio_associato_da_pianificare
                            .localita_partenza,
                    provincia_partenza:
                        this.servizio_associato_da_pianificare
                            .provincia_partenza,
                    cap_partenza:
                        this.servizio_associato_da_pianificare.cap_partenza,
                    indirizzo_partenza:
                        this.servizio_associato_da_pianificare
                            .indirizzo_partenza,
                    civico_partenza:
                        this.servizio_associato_da_pianificare.civico_partenza,
                    localita_arrivo:
                        this.servizio_associato_da_pianificare.localita_arrivo,
                    provincia_arrivo:
                        this.servizio_associato_da_pianificare.provincia_arrivo,
                    cap_arrivo:
                        this.servizio_associato_da_pianificare.cap_arrivo,
                    indirizzo_arrivo:
                        this.servizio_associato_da_pianificare.indirizzo_arrivo,
                    civico_arrivo:
                        this.servizio_associato_da_pianificare.civico_arrivo,
                    ora_inizio:
                        this.servizio_associato_da_pianificare.ora_inizio,
                    id_tipo_servizio_dettaglio:
                        this.servizio_pianificato_dettaglio_sel
                            .id_tipo_servizio_dettaglio,
                    id_tipo_materiale:
                        this.servizio_pianificato_dettaglio_sel
                            .id_tipo_materiale,
                    id_tipo_macchina:
                        this.servizio_pianificato_dettaglio_sel
                            .id_tipo_macchina,
                    volume: this.servizio_pianificato_dettaglio_sel.volume,
                    um_volume:
                        this.servizio_pianificato_dettaglio_sel.um_volume,
                },
            };
            this.$store
                .dispatch("api", getservizi)
                .then((res) => {
                    this.loading = false;
                    if (res.status == 200) {
                        this.servizi_suggeriti = [];
                        this.servizi_suggeriti = res.data.result;
                        this.servizi_suggeriti.forEach((e) => {
                            e.ora_inizio_attivita = moment(
                                e.inizio_attivita
                            ).format("HH:mm");
                            e.ora_fine_attivita = moment(
                                e.fine_attivita
                            ).format("HH:mm");
                            e.inizio_attivita = moment(
                                e.inizio_attivita
                            ).format("DD/MM/YYYY");

                            e.fine_attivita = moment(e.fine_attivita).format(
                                "DD/MM/YYYY"
                            );

                            e.selezionato = false;
                        });

                        this.servizi_suggeriti.sort(
                            (a, b) => a.distanza_value - b.distanza_value
                        );
                    } else {
                        this.loading = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            `Nessun elemento trovato.`
                        );
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    this.loading = false;
                });
        },
        moveUp(item) {
            this.ordine_cambiato = true;
            for (let p = 0; p < this.items_ottimizzati.length; p++) {
                this.items_ottimizzati[p].ordine = p;
            }

            // Registro l'indice del pulsante selezionato.
            let idx_sel = -1;

            for (let p = 0; p < this.items_ottimizzati.length; p++) {
                if (
                    (item.id_servizio >= 0 &&
                        this.items_ottimizzati[p].id_servizio ===
                        item.id_servizio) ||
                    (item.id_servizio <= 0 &&
                        this.items_ottimizzati[p].id_servizio ===
                        item.id_servizio)
                ) {
                    idx_sel = p;
                }
                if (
                    item.id_sede &&
                    this.items_ottimizzati[p].id_sede === item.id_sede
                ) {
                    idx_sel = p;
                }
                if (
                    item.id_temp &&
                    this.items_ottimizzati[p].id_temp === item.id_temp
                ) {
                    idx_sel = p;
                }
            }

            // Se è il caso, riordino.
            if (idx_sel > 0) {
                this.items_ottimizzati[idx_sel].ordine -= 1;
                this.items_ottimizzati[idx_sel - 1].ordine += 1;
                this.items_ottimizzati[idx_sel].spostato = 1;
                this.items_ottimizzati[idx_sel - 1].spostato = 1;
                console.log("move up", this.items_ottimizzati[idx_sel]);
                if (this.items_ottimizzati[idx_sel].ordine == 0) {
                    console.log("secondo servizio", this.items_ottimizzati[idx_sel]);

                    this.items_ottimizzati[idx_sel].ora_arrivo = moment(
                        this.items_ottimizzati[idx_sel - 1].ora_arrivo
                    ).format("yyyy-MM-DD HH:mm");

                    // modifico il servizio cliccato
                    this.items_ottimizzati[idx_sel].data_manuale = this.sottraiTempo(
                        this.items_ottimizzati[idx_sel].ora_arrivo,
                        "00:00",
                        this.items_ottimizzati[idx_sel].tempo_percorrenza
                    );


                    this.items_ottimizzati[idx_sel].ora_ripartenza =
                        this.sommaTempo(
                            this.items_ottimizzati[idx_sel].data_manuale,
                            this.items_ottimizzati[idx_sel]
                                .tempo_permanenza,
                            this.items_ottimizzati[idx_sel]
                                .tempo_percorrenza
                        );


                    // modifico quello sopra
                    this.items_ottimizzati[idx_sel - 1].data_manuale = moment(
                        this.items_ottimizzati[idx_sel].ora_ripartenza
                    ).format("yyyy-MM-DD HH:mm");

                    this.items_ottimizzati[idx_sel - 1].ora_arrivo = this.sommaTempo(
                        this.items_ottimizzati[idx_sel].ora_ripartenza,
                        "00:00",
                        this.items_ottimizzati[idx_sel - 1].tempo_percorrenza
                    );

                    this.items_ottimizzati[idx_sel - 1].ora_ripartenza = this.sommaTempo(
                        this.items_ottimizzati[idx_sel].ora_ripartenza,
                        this.items_ottimizzati[idx_sel - 1]
                            .tempo_permanenza,
                        this.items_ottimizzati[idx_sel - 1]
                            .tempo_percorrenza
                    );
                }

                if (
                    this.items_ottimizzati[idx_sel].codice_ordine ==
                    "FINE GIORNATA"
                ) {
                    // ora arrivo = ora arrivo del servizio prec. e calcolo la data_manuale(ora partenza)
                    this.items_ottimizzati[idx_sel - 1].data_manuale = moment(
                        this.items_ottimizzati[idx_sel + 1].data_manuale
                    ).format("yyyy-MM-DD HH:mm");
                    this.items_ottimizzati[idx_sel - 1].ora_arrivo = moment(
                        this.items_ottimizzati[idx_sel + 1].ora_arrivo
                    ).format("yyyy-MM-DD HH:mm");
                    this.items_ottimizzati[idx_sel - 1].ora_ripartenza =
                        this.sommaTempo(
                            this.items_ottimizzati[idx_sel + 1].data_manuale,
                            this.items_ottimizzati[idx_sel + 1]
                                .tempo_permanenza,
                            this.items_ottimizzati[idx_sel + 1]
                                .tempo_percorrenza
                        );
                    // Impostiamo i dati per l'oggetto precedente
                    let succ_data_manuale =
                        this.items_ottimizzati[idx_sel - 1].ora_ripartenza;
                    for (
                        let i = idx_sel + 1;
                        i < this.items_ottimizzati.length;
                        i++
                    ) {
                        // Imposta la data_manuale dell'oggetto corrente
                        this.items_ottimizzati[i].data_manuale =
                            moment(succ_data_manuale).format(
                                "yyyy-MM-DD HH:mm"
                            );

                        // Calcola ora_arrivo e ora_ripartenza per l'oggetto corrente
                        this.items_ottimizzati[i].ora_arrivo = this.sommaTempo(
                            this.items_ottimizzati[i].data_manuale,
                            "00:00",
                            this.items_ottimizzati[i].tempo_percorrenza
                        );
                        this.items_ottimizzati[i].ora_ripartenza =
                            this.sommaTempo(
                                this.items_ottimizzati[i].data_manuale,
                                this.items_ottimizzati[i].tempo_permanenza,
                                this.items_ottimizzati[i].tempo_percorrenza
                            );

                        // Aggiorna la variabile succ_data_manuale per il prossimo ciclo
                        succ_data_manuale = moment(
                            this.items_ottimizzati[i].ora_ripartenza
                        ).format("yyyy-MM-DD HH:mm");
                    }
                } else {
                    if (
                        this.items_ottimizzati[idx_sel - 1].codice_ordine ==
                        "FINE GIORNATA"
                    ) {
                        this.items_ottimizzati[idx_sel].data_manuale = moment(
                            this.items_ottimizzati[idx_sel - 2].ora_ripartenza
                        ).format("yyyy-MM-DD HH:mm");
                        // this.items_ottimizzati[idx_sel].ora_arrivo = moment(this.items_ottimizzati[idx_sel - 2].ora_arrivo).format("yyyy-MM-DD HH:mm");
                        // this.items_ottimizzati[idx_sel].ora_ripartenza = moment(this.items_ottimizzati[idx_sel - 2].ora_ripartenza).format("yyyy-MM-DD HH:mm");
                        this.items_ottimizzati[idx_sel].ora_arrivo =
                            this.sommaTempo(
                                this.items_ottimizzati[idx_sel - 2]
                                    .ora_ripartenza,
                                "00:00",
                                this.items_ottimizzati[idx_sel - 2]
                                    .tempo_percorrenza
                            );
                        this.items_ottimizzati[idx_sel].ora_ripartenza =
                            this.sommaTempo(
                                this.items_ottimizzati[idx_sel - 2]
                                    .ora_ripartenza,
                                this.items_ottimizzati[idx_sel - 2]
                                    .tempo_permanenza,
                                this.items_ottimizzati[idx_sel - 2]
                                    .tempo_percorrenza
                            );
                    } else if (this.items_ottimizzati[idx_sel].ordine != 0) {

                        // modifico il servizio cliccato
                        this.items_ottimizzati[idx_sel].data_manuale = moment(
                            this.items_ottimizzati[idx_sel - 2].ora_ripartenza
                        ).format("yyyy-MM-DD HH:mm");

                        this.items_ottimizzati[idx_sel].ora_arrivo =
                            this.sommaTempo(
                                this.items_ottimizzati[idx_sel].data_manuale,
                                "00:00",
                                this.items_ottimizzati[idx_sel].tempo_percorrenza
                            );
                        this.items_ottimizzati[idx_sel].ora_ripartenza =
                            this.sommaTempo(
                                this.items_ottimizzati[idx_sel].data_manuale,
                                this.items_ottimizzati[idx_sel]
                                    .tempo_permanenza,
                                this.items_ottimizzati[idx_sel]
                                    .tempo_percorrenza
                            );


                        // modifico quello sopra
                        this.items_ottimizzati[idx_sel - 1].data_manuale = moment(
                            this.items_ottimizzati[idx_sel].ora_ripartenza
                        ).format("yyyy-MM-DD HH:mm");

                        this.items_ottimizzati[idx_sel - 1].ora_arrivo = this.sommaTempo(
                            this.items_ottimizzati[idx_sel].ora_ripartenza,
                            "00:00",
                            this.items_ottimizzati[idx_sel - 1].tempo_percorrenza
                        );

                        this.items_ottimizzati[idx_sel - 1].ora_ripartenza = this.sommaTempo(
                            this.items_ottimizzati[idx_sel].ora_ripartenza,
                            this.items_ottimizzati[idx_sel - 1]
                                .tempo_permanenza,
                            this.items_ottimizzati[idx_sel - 1]
                                .tempo_percorrenza
                        );
                    }
                }

                this.items_ottimizzati.sort((a, b) => a.ordine - b.ordine);
            }
        },
        moveDown(item) {
            this.ordine_cambiato = true;
            // Assegno un ordine "sicuro" ai pulsanti.
            for (let p = 0; p < this.items_ottimizzati.length; p++) {
                this.items_ottimizzati[p].ordine = p;
            }

            // Registro l'indice del pulsante selezionato.
            let idx_sel = -1;

            for (let p = 0; p < this.items_ottimizzati.length; p++) {
                if (
                    (item.id_servizio >= 0 &&
                        this.items_ottimizzati[p].id_servizio ===
                        item.id_servizio) ||
                    (item.id_servizio <= 0 &&
                        this.items_ottimizzati[p].id_servizio ===
                        item.id_servizio)
                ) {
                    idx_sel = p;
                }
                if (
                    item.id_sede != null &&
                    this.items_ottimizzati[p].id_sede === item.id_sede
                ) {
                    idx_sel = p;
                }
                if (
                    item.id_temp != null &&
                    this.items_ottimizzati[p].id_temp === item.id_temp
                ) {
                    idx_sel = p;
                }
            }
            console.log("move down", this.items_ottimizzati[idx_sel]);

            // Se è il caso, riordino.
            if (idx_sel < this.items_ottimizzati.length - 1) {
                this.items_ottimizzati[idx_sel].ordine += 1;
                this.items_ottimizzati[idx_sel + 1].ordine -= 1;
                this.items_ottimizzati[idx_sel].spostato = 1;
                this.items_ottimizzati[idx_sel + 1].spostato = 1;

                if (this.items_ottimizzati[idx_sel].ordine == 1) {
                    console.log("primo servizio", this.items_ottimizzati[idx_sel]);
                    // modifico le date del servizio sotto
                    this.items_ottimizzati[idx_sel + 1].ora_arrivo = moment(this.items_ottimizzati[idx_sel].ora_arrivo).format("yyyy-MM-DD HH:mm");

                    this.items_ottimizzati[idx_sel + 1].data_manuale =
                        this.sottraiTempo(
                            this.items_ottimizzati[idx_sel + 1].ora_arrivo,
                            "00:00",
                            this.items_ottimizzati[idx_sel + 1].tempo_percorrenza
                        );


                    this.items_ottimizzati[idx_sel + 1].ora_ripartenza = this.sommaTempo(
                        this.items_ottimizzati[idx_sel].data_manuale,
                        this.items_ottimizzati[idx_sel + 1].tempo_permanenza,
                        this.items_ottimizzati[idx_sel + 1].tempo_percorrenza
                    );

                    // modifico le date del servizio cliccato
                    this.items_ottimizzati[idx_sel].data_manuale = moment(
                        this.items_ottimizzati[idx_sel + 1].ora_ripartenza
                    ).format("yyyy-MM-DD HH:mm");

                    this.items_ottimizzati[idx_sel].ora_arrivo = this.sommaTempo(
                        this.items_ottimizzati[idx_sel + 1].ora_ripartenza,
                        "00:00",
                        this.items_ottimizzati[idx_sel].tempo_percorrenza
                    );

                    this.items_ottimizzati[idx_sel].ora_ripartenza = this.sommaTempo(
                        this.items_ottimizzati[idx_sel].data_manuale,
                        this.items_ottimizzati[idx_sel].tempo_permanenza,
                        this.items_ottimizzati[idx_sel].tempo_percorrenza
                    );
                }

                if (
                    this.items_ottimizzati[idx_sel + 1].codice == "FINE VIAGGIO"
                )
                    return;

                if (
                    this.items_ottimizzati[idx_sel].codice_ordine ==
                    "FINE GIORNATA"
                ) {
                    this.items_ottimizzati[idx_sel + 1].data_manuale = moment(
                        this.items_ottimizzati[idx_sel - 1].ora_ripartenza
                    ).format("yyyy-MM-DD HH:mm");


                    this.items_ottimizzati[idx_sel + 1].ora_arrivo =
                        this.sommaTempo(
                            this.items_ottimizzati[idx_sel + 1].data_manuale,
                            "00:00",
                            this.items_ottimizzati[idx_sel + 1]
                                .tempo_percorrenza
                        );
                    this.items_ottimizzati[idx_sel + 1].ora_ripartenza =
                        this.sommaTempo(
                            this.items_ottimizzati[idx_sel + 1].data_manuale,
                            this.items_ottimizzati[idx_sel + 1]
                                .tempo_permanenza,
                            this.items_ottimizzati[idx_sel + 1]
                                .tempo_percorrenza
                        );
                } else {
                    if (
                        this.items_ottimizzati[idx_sel + 1].codice_ordine ==
                        "FINE GIORNATA"
                    ) {
                        // ora arrivo = ora arrivo del servizio prec. e calcolo la data_manuale(ora partenza)
                        this.items_ottimizzati[idx_sel].data_manuale = moment(
                            this.items_ottimizzati[idx_sel + 2].data_manuale
                        ).format("yyyy-MM-DD HH:mm");
                        this.items_ottimizzati[idx_sel].ora_arrivo = moment(
                            this.items_ottimizzati[idx_sel + 2].ora_arrivo
                        ).format("yyyy-MM-DD HH:mm");
                        // this.items_ottimizzati[idx_sel].ora_arrivo = this.sommaTempo(this.items_ottimizzati[idx_sel].data_manuale, "00:00", this.items_ottimizzati[idx_sel].tempo_percorrenza)
                        this.items_ottimizzati[idx_sel].ora_ripartenza =
                            this.sommaTempo(
                                this.items_ottimizzati[idx_sel].data_manuale,
                                this.items_ottimizzati[idx_sel]
                                    .tempo_permanenza,
                                this.items_ottimizzati[idx_sel]
                                    .tempo_percorrenza
                            );

                        // Aggiornamento della data_manuale per l'oggetto successivo
                        let prec_ora_ripartenza =
                            this.items_ottimizzati[idx_sel + 2].ora_ripartenza;
                        for (
                            let i = idx_sel + 2;
                            i < this.items_ottimizzati.length;
                            i++
                        ) {
                            // Imposta la data_manuale in base alla data_ripartenza dell'oggetto precedente
                            this.items_ottimizzati[i].data_manuale =
                                moment(prec_ora_ripartenza).format(
                                    "yyyy-MM-DD HH:mm"
                                );

                            // Calcola ora_arrivo e ora_ripartenza per l'oggetto corrente
                            this.items_ottimizzati[i].ora_arrivo =
                                this.sommaTempo(
                                    this.items_ottimizzati[i].data_manuale,
                                    "00:00",
                                    this.items_ottimizzati[i].tempo_percorrenza
                                );
                            this.items_ottimizzati[i].ora_ripartenza =
                                this.sommaTempo(
                                    this.items_ottimizzati[i].data_manuale,
                                    this.items_ottimizzati[i].tempo_permanenza,
                                    this.items_ottimizzati[i].tempo_percorrenza
                                );

                            // Aggiorna la variabile prec_ora_ripartenza per il prossimo ciclo
                            prec_ora_ripartenza =
                                this.items_ottimizzati[i].ora_ripartenza;
                        }
                    } else if (this.items_ottimizzati[idx_sel].ordine != 1) {

                        // modifico le date del servizio sotto
                        this.items_ottimizzati[idx_sel + 1].data_manuale =
                            moment(this.items_ottimizzati[idx_sel - 1].ora_ripartenza).format("yyyy-MM-DD HH:mm");

                        this.items_ottimizzati[idx_sel + 1].ora_arrivo =
                            this.sommaTempo(
                                this.items_ottimizzati[idx_sel - 1].ora_ripartenza,
                                "00:00",
                                this.items_ottimizzati[idx_sel + 1].tempo_percorrenza
                            );

                        this.items_ottimizzati[idx_sel + 1].ora_ripartenza = this.sommaTempo(
                            this.items_ottimizzati[idx_sel].data_manuale,
                            this.items_ottimizzati[idx_sel + 1].tempo_permanenza,
                            this.items_ottimizzati[idx_sel + 1].tempo_percorrenza
                        );

                        // modifico le date del servizio cliccato
                        this.items_ottimizzati[idx_sel].data_manuale = moment(
                            this.items_ottimizzati[idx_sel + 1].ora_ripartenza
                        ).format("yyyy-MM-DD HH:mm");

                        this.items_ottimizzati[idx_sel].ora_arrivo = this.sommaTempo(
                            this.items_ottimizzati[idx_sel + 1].ora_ripartenza,
                            "00:00",
                            this.items_ottimizzati[idx_sel].tempo_percorrenza
                        );

                        this.items_ottimizzati[idx_sel].ora_ripartenza = this.sommaTempo(
                            this.items_ottimizzati[idx_sel].data_manuale,
                            this.items_ottimizzati[idx_sel].tempo_permanenza,
                            this.items_ottimizzati[idx_sel].tempo_percorrenza
                        );


                    }
                }

                this.items_ottimizzati.sort((a, b) => a.ordine - b.ordine);
            }
        },
        sottraiTempo(data, ore_stringa = "00:00", minuti = 0) {
            // Converto la data string in un oggetto Date
            const data_iniziale = new Date(data);

            // Estrai ore e minuti dalla stringa "HH:mm"
            const [ore, minuti_str] = ore_stringa
                .split(":")
                .map((num) => parseInt(num, 10));

            // Sottraggo le ore e i minuti
            data_iniziale.setHours(data_iniziale.getHours() - ore);
            data_iniziale.setMinutes(
                data_iniziale.getMinutes() - minuti_str - minuti
            );

            // Formattazione della data nel formato "yyyy-MM-DD HH:mm"
            const formatData = (data) => {
                const year = data.getFullYear();
                const month = (data.getMonth() + 1).toString().padStart(2, "0");
                const day = data.getDate().toString().padStart(2, "0");
                const hours = data.getHours().toString().padStart(2, "0");
                const minutes = data.getMinutes().toString().padStart(2, "0");

                return `${year}-${month}-${day} ${hours}:${minutes}`;
            };

            return formatData(data_iniziale);
        },
        sommaTempo(data, ore_stringa = "00:00", minuti = 0) {

            // Converto la data string in un oggetto Date
            const data_iniziale = new Date(data);

            // Estrai ore e minuti dalla stringa "HH:mm"
            const [ore, minuti_str] = ore_stringa
                .split(":")
                .map((num) => parseInt(num, 10));

            // Sommo le ore e i minuti
            data_iniziale.setHours(data_iniziale.getHours() + ore);
            data_iniziale.setMinutes(
                data_iniziale.getMinutes() + minuti_str + minuti
            );


            // Formattazione della data nel formato "yyyy-MM-DDTHH:mm:ss"
            const formatData = (data) => {
                const year = data.getFullYear();
                const month = (data.getMonth() + 1).toString().padStart(2, "0");
                const day = data.getDate().toString().padStart(2, "0");
                const hours = data.getHours().toString().padStart(2, "0");
                const minutes = data.getMinutes().toString().padStart(2, "0");

                return `${year}-${month}-${day} ${hours}:${minutes}`;
            };

            return formatData(data_iniziale);
        },
        setRipianifica(id_servizio) {
            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "ripianificaservizi",
                    token: localStorage.getItem("user_token"),
                    id_servizi: id_servizio.toString(),
                },
            };

            // Overlay di caricamento
            this.overlay = true;

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200 || res.status == 204) {
                        this.getServizi();
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Servizio ripianificato correttamente."
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((e) => {
                    console.error(e);

                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    // tolgo l'overlay
                    this.overlay = false;
                });

            this.ripianifica_dialog = false;
        },
        getConduttoriSelect() {
            if (this.items_ottimizzati[0]?.id_gruppo_servizi != 0) {
                return this.autisti;
            } else {
                const unique_ids = new Set(this.items_ottimizzati_ori.map(item => item.id_conduttore));

                const arr = this.autisti.filter(a => unique_ids.has(a.id_conduttore));

                return arr;

            }
        },
        setRipianificaServiziMultipli() {
            let id_to_plan = "";
            let is_blocked = false;

            this.servizi
                .filter((c) => c.selected == true)
                .forEach((e) => {
                    if (e.des_stato != "Bloccato")
                        id_to_plan += e.id_servizio.toString() + ",";
                    else is_blocked = true;
                });
            id_to_plan = id_to_plan.slice(0, -1);

            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "ripianificaservizi",
                    token: localStorage.getItem("user_token"),
                    id_servizi: id_to_plan,
                },
            };

            // Overlay di caricamento
            this.overlay = true;
            if (id_to_plan.length > 0) {
                this.$store
                    .dispatch("api", request)
                    .then((res) => {
                        this.overlay = false;
                        if (res.status == 200 || res.status == 204) {
                            this.getServizi();
                            if (!is_blocked)
                                this.$refs.SnackbarQV.print(
                                    "success",
                                    "Servizi ripianificati correttamente."
                                );
                            else
                                this.$refs.SnackbarQV.print(
                                    "orange",
                                    "I servizi bloccati non sono stati pianificati."
                                );
                        } else {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                "Errore di comunicazione col server, non è stato possibile caricare i dati."
                            );
                        }
                    })
                    .catch((e) => {
                        console.error(e);

                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server"
                        );
                        // tolgo l'overlay
                        this.overlay = false;
                    });

                this.ripianifica_dialog = false;
            } else {
                if (is_blocked) {
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Impossibile pianificare i servizi bloccati."
                    );
                    this.overlay = false;
                    this.ripianifica_dialog = false;
                }
            }
        },

        async salvaServizio(ripianifica = false) {
            await this.getDettagliServizio();
            if (
                this.selected_item.ora_inizio != "" &&
                this.selected_item.id_fascia_oraria != ""
            ) {
                this.selected_item.ora_inizio = "";
                this.selected_item.id_fascia_oraria = "";
                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Selezionare solo un campo tra fascia orario e ora inizio."
                );
            }

            // this.selected_item.cellulare = this.selected_item.cellulare.toString();
            if (
                this.selected_item.data_inizio == null ||
                this.selected_item.data_inizio == ""
            )
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire la data di inizio del servizio."
                );
            if (
                this.selected_item.data_fine == null ||
                this.selected_item.data_fine == ""
            )
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire la data di fine del servizio."
                );
            if (this.selected_item.id_azienda == null)
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire la ragione sociale."
                );

            // se esiste il componente di creazione dettagli
            if (this.$refs.createDettaglio) {
                if (
                    this.$refs.createDettaglio.tot_dettagli_servizio.length == 0
                ) {
                    // salvo il dettaglio
                    this.dettaglio = this.$refs.createDettaglio.selected_item;
                    this.dettaglio.id_servizio = this.selected_item.id_servizio;
                    if (
                        this.dettaglio.id_tipo_servizio_dettaglio == null ||
                        this.dettaglio.id_tipo_servizio_dettaglio == ""
                    ) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire una descrizione servizio"
                        );
                    }

                    if (
                        this.dettaglio.id_tipo_macchina == null ||
                        this.dettaglio.id_tipo_macchina == ""
                    ) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire un tipo veicolo"
                        );
                    }
                    if (this.dettaglio.frequenza_ripetizione_ore < 0) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Frequenza ripetizione in ore necessaria per pianificare"
                        );
                    }
                    if (
                        this.dettaglio.volume == null ||
                        this.dettaglio.volume == ""
                    ) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire il volume"
                        );
                    }
                    if (
                        this.dettaglio.id_tipo_servizio_dettaglio != null &&
                        this.dettaglio.id_tipo_macchina != null &&
                        this.dettaglio.volume != null &&
                        this.dettaglio.frequenza_ripetizione_ore >= 0
                    ) {
                        // Se blocco fido azienda = 1 -> Stato servizio bloccato.
                        // Altrimenti stato servizio -> Aperto.
                        await this.getAziende();
                        let codice_stato =
                            this.azienda_detail.id_blocco_fido > 0 ? "B" : "A";
                        this.dettaglio.id_stato =
                            this.$refs.createDettaglio.items_stato.filter(
                                (s) => s.cod == codice_stato
                            ).length > 0
                                ? this.$refs.createDettaglio.items_stato.find(
                                    (s) => s.cod == codice_stato
                                ).id_tabella
                                : null;

                        // se il dettaglio e stato modificato lo inserisco nell'array
                        this.dettagli_servizio.push(this.dettaglio);
                    } else
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire un opzione valida"
                        );
                }
            }

            // reimposto la tab iniziale e la data della richiesta
            this.tab = 0;
            this.selected_item.data_richiesta = moment(Date.now()).format(
                "YYYY-MM-DD"
            );

            this.selected_item.errori = null;

            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "saveservizio",
                    token: localStorage.getItem("user_token"),
                    servizio: this.selected_item,
                    dettagli:
                        this.dettaglio == null
                            ? this.dettagli_servizio
                            : [this.dettaglio],
                },
            };

            // Overlay di caricamento
            this.overlay = true;
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.overlay = false;
                    this.dettaglio = null;
                    if (res.status == 200) {
                        // aggiorno la lista di servizi e stampo una
                        // snackbar di conferma

                        this.$refs.SnackbarQV.print(
                            "success",
                            "Servizio salvato correttamente."
                        );

                        if (ripianifica)
                            this.setRipianifica(this.selected_item.id_servizio);
                        else this.getServizi();
                    } else {
                        if (
                            this.selected_item.validita === 0 &&
                            res.status === 204
                        ) {
                            this.getServizi();
                            return this.$refs.SnackbarQV.print(
                                "success",
                                "Servizio eliminato correttamente."
                            );
                        }
                        // se ci sono problemi durante il salvataggio
                        // del servizio stampa il messaggio di errore
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((e) => {
                    // stampo l'errore
                    console.error(e);
                    // snackbar avvertimento
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    // tolgo l'overlay
                    this.overlay = false;
                });
            this.filtra();
            this.data_table = true;
            // chiudo il dialog di eliminazione
            this.delete_dialog = false;
        },
        // async salvaServizio(ripianifica = false) {
        //     await this.getDettagliServizio();
        //     if (
        //         this.selected_item.ora_inizio != "" &&
        //         this.selected_item.id_fascia_oraria != ""
        //     ) {
        //         this.selected_item.ora_inizio = "";
        //         this.selected_item.id_fascia_oraria = "";
        //         console.log("non puoi salvare", this.selected_item);
        //         return this.$refs.SnackbarQV.print(
        //             "orange",
        //             "Selezionare solo un campo tra fascia orario e ora inizio."
        //         );
        //     }

        //     // this.selected_item.cellulare = this.selected_item.cellulare.toString();
        //     if (
        //         this.selected_item.data_inizio == null ||
        //         this.selected_item.data_inizio == ""
        //     )
        //         this.$refs.SnackbarQV.print(
        //             "orange",
        //             "Inserire la data di inizio del servizio."
        //         );
        //     if (
        //         this.selected_item.data_fine == null ||
        //         this.selected_item.data_fine == ""
        //     )
        //         this.$refs.SnackbarQV.print(
        //             "orange",
        //             "Inserire la data di fine del servizio."
        //         );
        //     if (this.selected_item.id_azienda == null)
        //         this.$refs.SnackbarQV.print(
        //             "orange",
        //             "Inserire la ragione sociale."
        //         );

        //     // se esiste il componente di creazione dettagli
        //     if (this.$refs.createDettaglio) {
        //         if (
        //             this.$refs.createDettaglio.tot_dettagli_servizio.length == 0
        //         ) {
        //             // salvo il dettaglio
        //             this.dettaglio = this.$refs.createDettaglio.selected_item;
        //             this.dettaglio.id_servizio = this.selected_item.id_servizio;
        //             if (
        //                 this.dettaglio.id_tipo_servizio_dettaglio == null ||
        //                 this.dettaglio.id_tipo_servizio_dettaglio == ""
        //             ) {
        //                 return this.$refs.SnackbarQV.print(
        //                     "orange",
        //                     "Inserire una descrizione servizio"
        //                 );
        //             }

        //             if (
        //                 this.dettaglio.id_tipo_macchina == null ||
        //                 this.dettaglio.id_tipo_macchina == ""
        //             ) {
        //                 return this.$refs.SnackbarQV.print(
        //                     "orange",
        //                     "Inserire un tipo veicolo"
        //                 );
        //             }
        //             if (this.dettaglio.frequenza_ripetizione_ore < 0) {
        //                 return this.$refs.SnackbarQV.print(
        //                     "orange",
        //                     "Frequenza ripetizione in ore necessaria per pianificare"
        //                 );
        //             }
        //             if (
        //                 this.dettaglio.volume == null ||
        //                 this.dettaglio.volume == ""
        //             ) {
        //                 return this.$refs.SnackbarQV.print(
        //                     "orange",
        //                     "Inserire il volume"
        //                 );
        //             }
        //             if (
        //                 this.dettaglio.id_tipo_servizio_dettaglio != null &&
        //                 this.dettaglio.id_tipo_macchina != null &&
        //                 this.dettaglio.volume != null &&
        //                 this.dettaglio.frequenza_ripetizione_ore >= 0
        //             ) {
        //                 // Se blocco fido azienda = 1 -> Stato servizio bloccato.
        //                 // Altrimenti stato servizio -> Aperto.
        //                 await this.getAziende();
        //                 let codice_stato =
        //                     this.azienda_detail.id_blocco_fido > 0 ? "B" : "A";
        //                 this.dettaglio.id_stato =
        //                     this.$refs.createDettaglio.items_stato.filter(
        //                         (s) => s.cod == codice_stato
        //                     ).length > 0
        //                         ? this.$refs.createDettaglio.items_stato.find(
        //                             (s) => s.cod == codice_stato
        //                         ).id_tabella
        //                         : null;

        //                 // se il dettaglio e stato modificato lo inserisco nell'array
        //                 this.dettagli_servizio.push(this.dettaglio);
        //             } else
        //                 return this.$refs.SnackbarQV.print(
        //                     "orange",
        //                     "Inserire un opzione valida"
        //                 );
        //         }
        //     }

        //     // reimposto la tab iniziale e la data della richiesta
        //     this.tab = 0;
        //     this.selected_item.data_richiesta = moment(Date.now()).format(
        //         "YYYY-MM-DD"
        //     );
        //     // imposto i colori come stringa
        //     this.selected_item.colore_sfondo.hex
        //         ? (this.selected_item.colore_sfondo =
        //             this.selected_item.colore_sfondo.hex)
        //         : "";
        //     this.selected_item.colore_testo.hex
        //         ? (this.selected_item.colore_testo =
        //             this.selected_item.colore_testo.hex)
        //         : "";
        //     this.selected_item.errori = null;

        //     let request = {
        //         controller: "logistic",
        //         method: "POST",
        //         richiesta: {
        //             action: "saveservizio",
        //             token: localStorage.getItem("user_token"),
        //             servizio: this.selected_item,
        //             dettagli:
        //                 this.dettaglio == null
        //                     ? this.dettagli_servizio
        //                     : [this.dettaglio],
        //         },
        //     };

        //     // Overlay di caricamento
        //     this.overlay = true;
        //     this.$store
        //         .dispatch("api", request)
        //         .then((res) => {
        //             this.overlay = false;
        //             this.dettaglio = null;
        //             if (res.status == 200) {
        //                 // aggiorno la lista di servizi e stampo una
        //                 // snackbar di conferma

        //                 this.$refs.SnackbarQV.print(
        //                     "success",
        //                     "Servizio salvato correttamente."
        //                 );

        //                 if (ripianifica)
        //                     this.setRipianifica(this.selected_item.id_servizio);
        //                 else this.getServizi();
        //             } else {
        //                 if (
        //                     this.selected_item.validita === 0 &&
        //                     res.status === 204
        //                 ) {
        //                     this.getServizi();
        //                     return this.$refs.SnackbarQV.print(
        //                         "success",
        //                         "Servizio eliminato correttamente."
        //                     );
        //                 }
        //                 // se ci sono problemi durante il salvataggio
        //                 // del servizio stampa il messaggio di errore
        //                 this.$refs.SnackbarQV.print(
        //                     "orange",
        //                     "Errore di comunicazione col server, non è stato possibile caricare i dati."
        //                 );
        //             }
        //         })
        //         .catch((e) => {
        //             // stampo l'errore
        //             console.error(e);
        //             // snackbar avvertimento
        //             this.$refs.SnackbarQV.print(
        //                 "error",
        //                 "Errore di comunicazione col server"
        //             );
        //             // tolgo l'overlay
        //             this.overlay = false;
        //         });
        //     this.filtra();
        //     this.data_table = true;
        //     // chiudo il dialog di eliminazione
        //     this.delete_dialog = false;
        // },
        selezionaCodiceOrdine(arg) {
            console.log("arg", arg);
            this.codice_ordine_filter = arg.codice_ordine;
            this.filtra();

        },
        resetConduttoreFilter() {
            this.conduttore_filter = null;
            this.items_ottimizzati = this.items_ottimizzati_ori;
        },
        async salvaPianificazione() {
            if (this.servizio_pianificato_sel != null) {
                this.eliminaPianificaEAssocia();
                return;
            }
            console.log("this.selected_item", this.selected_item);
            console.log(
                "this.$refs.createEdit.selected_item",
                this.$refs.createEdit.selected_item
            );
            if (
                this.selected_item.ora_inizio != "" &&
                this.selected_item.id_fascia_oraria != ""
            ) {
                this.selected_item.ora_inizio = "";
                this.selected_item.id_fascia_oraria = "";

                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Selezionare solo un campo tra fascia orario e ora inizio."
                );
            }

            this.selected_item.cellulare =
                this.selected_item.cellulare.toString();

            if (this.selected_item.id_azienda == null)
                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire la ragione sociale."
                );

            if ("errori.distanza" in this.selected_item)
                if (!this.selected_item.distanza)
                    return this.$refs.SnackbarQV.print(
                        "orange",
                        this.selected_item.errori.distanza
                    );

            if ("errori.tempo_percorrenza" in this.selected_item)
                if (!this.selected_item.tempo_percorrenza)
                    return this.$refs.SnackbarQV.print(
                        "orange",
                        this.selected_item.errori.tempo_percorrenza
                    );
            if (
                !this.selected_item.localita_arrivo ||
                !this.selected_item.provincia_arrivo ||
                !this.selected_item.cap_arrivo
            )
                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire tutti i dati di destinazione"
                );
            // controllo che sia stata inserita la data
            if (
                !this.selected_item.data_inizio ||
                !this.selected_item.data_fine
            )
                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire la data di inizio e fine del servizio."
                );

            // se il servizio e stato creato adesso eseguo il prossimo if
            if (this.dettagli_servizio.length === 0) {
                // se esiste il componente di creazione dettagli
                if (this.$refs.createDettaglio) {
                    // salvo il dettaglio
                    this.dettaglio = this.$refs.createDettaglio.selected_item;
                    this.dettaglio.id_servizio = this.selected_item.id_servizio;
                    if (
                        this.dettaglio.id_tipo_servizio_dettaglio == null ||
                        this.dettaglio.id_tipo_servizio_dettaglio == ""
                    ) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire una descrizione servizio"
                        );
                    }
                    if (
                        this.dettaglio.id_tipo_macchina == null ||
                        this.dettaglio.id_tipo_macchina == ""
                    ) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire un tipo veicolo"
                        );
                    }
                    if (this.dettaglio.frequenza_ripetizione_ore < 0) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Frequenza ripetizione in ore necessaria per pianificare"
                        );
                    }
                    if (
                        this.dettaglio.volume == null ||
                        this.dettaglio.volume == ""
                    ) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire il volume"
                        );
                    }
                    if (
                        this.dettaglio.id_tipo_servizio_dettaglio != null &&
                        this.dettaglio.id_tipo_macchina != null &&
                        this.dettaglio.volume != null &&
                        this.dettaglio.frequenza_ripetizione_ore >= 0
                    ) {
                        // Se blocco fido azienda = 1 -> Stato servizio bloccato.
                        // Altrimenti stato servizio -> Aperto.
                        await this.getAziende();
                        let codice_stato =
                            this.azienda_detail.id_blocco_fido > 0 ? "B" : "A";

                        this.dettaglio.id_stato =
                            this.$refs.createDettaglio.items_stato.filter(
                                (s) => s.cod == codice_stato
                            ).length > 0
                                ? this.$refs.createDettaglio.items_stato.find(
                                    (s) => s.cod == codice_stato
                                ).id_tabella
                                : null;

                        // se il dettaglio e stato modificato lo inserisco nell'array
                        this.dettagli_servizio.push(this.dettaglio);
                    } else
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire un opzione valida"
                        );
                } else
                    return this.$refs.SnackbarQV.print(
                        "orange",
                        "Inserire un opzione valida"
                    );
            }

            this.selected_item.errori = null;
            // reimposto la tab iniziale e la data della richiesta
            this.tab = 0;
            this.selected_item.data_richiesta = moment(Date.now()).format(
                "YYYY-MM-DD"
            );

            // imposto i colori come stringa
            this.selected_item.colore_sfondo.hex
                ? (this.selected_item.colore_sfondo =
                    this.selected_item.colore_sfondo.hex)
                : "#1976D2";
            this.selected_item.colore_testo.hex
                ? (this.selected_item.colore_testo =
                    this.selected_item.colore_testo.hex)
                : "#000000";

            // Pianifica solo i servizi dettaglio che abbiano lo stato aperto.
            let cod_stato_aperto = this.$refs.createDettaglio.items_stato.find(
                (e) => e.cod == "A"
            );

            let servizi_aperti = [];
            if (cod_stato_aperto)
                servizi_aperti = this.dettagli_servizio.filter(
                    (e) => e.id_stato == cod_stato_aperto.id_tabella
                );

            if (servizi_aperti.length > 0) {
                // id dell associazione
                this.selected_item.id_servizio_associato = this.servizio_ass_sel
                    ? this.servizio_ass_sel
                    : null;
                console.log(
                    "controlla qui",
                    this.selected_item,
                    servizi_aperti
                );

                const pianificazione = {
                    controller: "logistic",
                    method: "POST",
                    richiesta: {
                        token: localStorage.getItem("user_token"),
                        action: "saveserviziopianifica",
                        servizio: this.selected_item,
                        dettagli: servizi_aperti,
                    },
                };

                this.overlay = true;
                this.data_table = true;
                this.$store.dispatch("api", pianificazione).then((res) => {
                    this.overlay = false;
                    if (res.status === 200) {
                        if (
                            servizi_aperti.length <
                            this.dettagli_servizio.length
                        )
                            this.$refs.SnackbarQV.print(
                                "orange",
                                "Servizio salvato. I servizi non aperti non sono stati pianificati."
                            );
                        else
                            this.$refs.SnackbarQV.print(
                                "success",
                                "Servizio salvato e pianificato correttamente."
                            );
                        this.servizio_ass_sel = null;
                        if (this.servizio_pianificato_sel != null) {
                            this.eliminaServizio();
                        } else {
                            this.getServizi();
                        }
                    } else {
                        // snackbar errore
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                });
            } else {
                this.$refs.SnackbarQV.print(
                    "error",
                    "Azienda fido bloccato: impossibile pianificare."
                );
            }
        },
        getCoordinate() {
            if (
                !this.partenza_sel.indirizzo_partenza ||
                !this.partenza_sel.localita_partenza ||
                !this.partenza_sel.provincia_partenza ||
                !this.partenza_sel.cap_partenza
            ) {
                this.$refs.SnackbarQV.print(
                    "orange",
                    `Inserisci tutti i campi.`
                );
                return;
            }
            const request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getcoordinate",
                    localita: this.partenza_sel.localita_partenza,
                    cap: this.partenza_sel.cap_partenza,
                    provincia: this.partenza_sel.provincia_partenza,
                    indirizzo: this.partenza_sel.indirizzo_partenza,
                    civico: 120,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", request).then((res) => {
                this.overlay = false;
                if (res.status === 200) {
                    console.log("getcoor", res);
                    this.partenza_sel.latitudine_partenza =
                        res.data.result.latitudine;
                    this.partenza_sel.longitudine_partenza =
                        res.data.result.longitudine;
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
        },
        filtra() {

            /* Preparo un array temporaneo in cui
             * collezionare i Servizi filtrati */
            let servizi_tmp = [];
            this.servizi_ori.forEach((v) => {
                servizi_tmp.push(v);
            });

            if (this.servizio_filter.length != 0) {
                let res = [];
                servizi_tmp.forEach((e) => {
                    this.servizio_filter.forEach((s) => {
                        const ids_competenza = s.ids_competenze
                            .split(',')
                            .map(x => Number(x.trim()));

                        if (ids_competenza.includes(Number(e.id_tipo_abilitazioni))) {
                            res.push(e)
                        }


                    });
                });

                res = res.filter(
                    (item, index, self) =>
                        index === self.findIndex(
                            (el) => Number(el.id_servizio) === Number(item.id_servizio)
                        )
                );
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
                console.log("res filtro tipo servizio", res);

            }

            if (this.richiesta_filter.length != 0) {
                let res = [];
                servizi_tmp.forEach((e) => {
                    this.richiesta_filter.forEach((r) => {
                        if (r.stato_documento == e.stato_documento) {
                            res.push(e);
                        }
                    });
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
            }

            if (this.sede_magazzino_filter.length != 0) {
                let res = [];
                servizi_tmp.forEach((e) => {
                    this.sede_magazzino_filter.forEach((r) => {
                        if (r.descrizione == e.sede_magazzino) {
                            res.push(e);
                        }
                    });
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
            }

            if (this.area_filter.length != 0) {
                this.regione_sel = [];
                this.provincia_sel = [];
                this.comune_sel = null;
                this.blocco_filtri = true;
                console.log("entra filtra area competenza", this.area_filter);

                console.log("servizi tmp", servizi_tmp);
                // Raccogli tutte le province dalle aree che corrispondono al filtro
                const province_sel = this.items_area_competenza
                    .filter(e => this.area_filter.some(a => a.id_zona_master === e.id_zona_master))
                    .flatMap(e => e.zona_dettagli);

                let res = [];
                // Filtra i servizi che hanno una località arrivo presente tra le province selezionate
                // res = servizi_tmp.filter(s =>
                // province_sel.some(p => p.comune.toUpperCase() == s.localita_arrivo?.toUpperCase())
                // );
                // Filtra per province
                res = servizi_tmp.filter(s =>
                    province_sel.some(p => p.id_provincia == s.id_provincia_arrivo)
                );

                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
                console.log("province sel", province_sel, servizi_tmp);
            }

            //Filtro per tecnico
            if (this.tecnico_sel != null) {
                let res = [];
                servizi_tmp.forEach((e) => {
                    if (e.id_conduttore == this.tecnico_sel) {
                        res.push(e);
                    }
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
            }

            //Filtro per regione
            if (this.regione_sel.length != 0) {
                let res = [];
                servizi_tmp.forEach((e) => {
                    this.regione_sel.forEach((p) => {
                        if (e.id_regione == p.id_regione) {
                            res.push(e);
                        }
                    });
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
            }

            if (this.area_filter.length == 0) {

                //Filtro per provincia
                if (this.provincia_sel.length != 0) {
                    let res = [];
                    servizi_tmp.forEach((e) => {
                        this.provincia_sel.forEach((p) => {
                            console.log("dentro i for", e, p);
                            if (e.provincia_arrivo == p.sigla) {
                                console.log("entra if filtro provincia", e, p);
                                res.push(e);
                            }
                        });
                    });
                    servizi_tmp = [];
                    res.forEach((e) => {
                        servizi_tmp.push(e);
                    });
                }

                //Filtro per comune
                if (this.comune_sel != null) {
                    let comune = "";
                    console.log("this.comune_sel");
                    this.items_comuni.forEach((e) => {
                        if (e.id_comune == this.comune_sel) {
                            console.log("match", e.id_comune, this.comune_sel);
                            comune = e.comune;
                        }
                    });
                    let res = [];
                    servizi_tmp.forEach((e) => {
                        if (
                            e.localita_arrivo.toUpperCase() == comune.toUpperCase()
                        ) {
                            res.push(e);
                        }
                    });
                    servizi_tmp = [];
                    res.forEach((e) => {
                        servizi_tmp.push(e);
                    });
                }
            }

            //Filtro per ragione sociale
            if (this.ragionesociale_filter != null) {
                console.log("codice filter", this.ragionesociale_filter);
                let res = [];
                servizi_tmp.forEach((e) => {
                    if (e.des_azienda == this.ragionesociale_filter) {
                        res.push(e);
                    }
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });

                console.log("servizi_tmp", servizi_tmp);
            }
            //Filtro per codice
            if (this.codice_filter != null) {
                console.log("codice filter", this.codice_filter);
                let res = [];
                servizi_tmp.forEach((e) => {
                    if (
                        e.codice.toUpperCase() ==
                        this.codice_filter.toUpperCase()
                    ) {
                        console.log("entraaaaaaaaaaaaa");
                        res.push(e);
                        console.log("res filter", res);
                    }
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });

                console.log("servizi_tmp", servizi_tmp);
            }

            //Filtro per codice
            if (this.codice_ordine_filter != null) {
                let res = [];
                servizi_tmp.forEach((e) => {
                    if (e.codice_ordine == this.codice_ordine_filter) {
                        res.push(e);
                    }
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });

            }

            if (this.data_minima_a_filter != null) {
                console.log("entra filtro dataminima??", this.data_minima_da_filter, this.data_minima_a_filter);

                // funzione di utilità: trasforma qualsiasi data riconosciuta in YYYY-MM-DD (ISO date string)
                const toISODate = (raw) => {
                    if (!raw && raw !== 0) return null;
                    const s = String(raw).trim();

                    // se è già in ISO  YYYY-MM-DD
                    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                        const m = moment(s, "YYYY-MM-DD", true);
                        return m.isValid() ? m.format("YYYY-MM-DD") : null;
                    }

                    // se contiene slash, assumiamo formato italiano DD/MM/YYYY (deterministico)
                    if (s.includes("/")) {
                        const m = moment(s, "DD/MM/YYYY", true);
                        return m.isValid() ? m.format("YYYY-MM-DD") : null;
                    }

                    // se contiene trattino ma non è ISO: prova DD-MM-YYYY
                    if (s.includes("-")) {
                        let m = moment(s, "DD-MM-YYYY", true);
                        if (m.isValid()) return m.format("YYYY-MM-DD");
                        // fallback: prova altri formati
                        m = moment(s, moment.ISO_8601, true);
                        if (m.isValid()) return m.format("YYYY-MM-DD");
                    }

                    // fallback generico: prova ISO e alcune varianti (non strict)
                    let m = moment(s, ["YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY", "MM/DD/YYYY"], true);
                    if (m.isValid()) return m.format("YYYY-MM-DD");

                    // se ancora non valido, prova non-strict (ultima risorsa)
                    m = moment(s);
                    if (m.isValid()) return m.format("YYYY-MM-DD");

                    // non parsabile
                    return null;
                };

                // Normalizziamo data_minima per servizi_tmp (senza modificare gli originali)
                const serviziNormalizzati = servizi_tmp.map(s => {
                    return {
                        __orig: s,
                        data_minima_iso: toISODate(s.data_minima)
                    };
                });

                // Calcolo data_inizio: se this.data_minima_da_filter esiste la normalizzo, altrimenti prendo il minimo tra tutti i servizi (usando i valori normalizzati)
                let data_inizio_iso = null;
                if (this.data_minima_da_filter != null) {
                    data_inizio_iso = toISODate(this.data_minima_da_filter);
                } else {
                    // prendi il minimo tra le data_minima_iso valide
                    const isoValid = (servizi_tmp || [])
                        .map(s => toISODate(s.data_minima))
                        .filter(x => x !== null);

                    if (isoValid.length > 0) {
                        data_inizio_iso = isoValid.reduce((min, cur) => (cur < min ? cur : min), isoValid[0]);
                    } else {
                        // fallback: nessuna data valida nei servizi
                        console.warn("Nessuna data valida trovata in this.servizi per calcolare data_inizio");
                        data_inizio_iso = null;
                    }
                }

                // Normalizziamo data_fine (la tua data_minima_a_filter)
                const data_fine_iso = toISODate(this.data_minima_a_filter);

                // Debug: mostra le date normalizzate
                console.log("data_inizio_iso:", data_inizio_iso, "data_fine_iso:", data_fine_iso, "serviziNormalizzati:", serviziNormalizzati);

                // Ora filtra: confrontiamo stringhe ISO (YYYY-MM-DD) che sono sicure per il confronto lessicografico
                const res = [];
                serviziNormalizzati.forEach(item => {
                    const iso = item.data_minima_iso;
                    if (!iso) {
                        console.warn("Salto elemento con data non parsabile:", item.__orig);
                        return;
                    }
                    if (!data_inizio_iso || !data_fine_iso) {
                        // se non abbiamo confini, decidi comportamento: qui includiamo solo se iso è definita
                        console.warn("Data inizio o fine non valida; salto confronto.");
                        return;
                    }

                    // confronto lessicografico sicuro perché YYYY-MM-DD
                    if (iso >= data_inizio_iso && iso <= data_fine_iso) {
                        res.push(item.__orig);
                    }
                });

                // aggiorna servizi_tmp con i risultati filtrati
                servizi_tmp = [...res];
                console.log("servizi filtrati per data minima", servizi_tmp);

            }



            // Ricostruisco i servizi visualizzati in base ai filtri aggiunti.
            this.servizi = [];
            if (this.solo_non_pianificati != 2) {
                this.servizi = servizi_tmp.filter(
                    (e) => e.pianificato == this.solo_non_pianificati
                );
            } else {
                this.servizi = Array.from(servizi_tmp);
            }
        },
        // filtraTipoServizio() {
        //     if (this.servizio_filter.length == 0) {
        //         this.servizi = Array.from(this.servizi_ori);
        //         this.filtra();
        //         return;
        //     }
        //     console.log("entra change filter", this.servizio_filter);

        //     /* Preparo un array temporaneo in cui
        //      * collezionare i Servizi filtrati */
        //     let servizi_tmp = [];
        //     this.servizi_ori.forEach((v) => {
        //         servizi_tmp.push(v);
        //     });

        //     if (this.servizio_filter != null) {
        //         let res = [];
        //         servizi_tmp.forEach((e) => {
        //             if (this.servizio_filter.length != 0) {
        //                 this.servizio_filter.forEach((s) => {
        //                     if (s == e.id_tipo_servizio_dettaglio) {
        //                         res.push(e);
        //                     }
        //                 });
        //             }
        //         });
        //         servizi_tmp = [];
        //         res.forEach((e) => {
        //             servizi_tmp.push(e);
        //         });
        //     }

        //     // Ricostruisco i servizi visualizzati in base ai filtri aggiunti.
        //     this.servizi = [];
        //     this.servizi = Array.from(servizi_tmp);
        //     this.filtra();
        // },
        // filtraAreaCompetenza() {
        //     this.regione_sel = null;
        //     this.provincia_sel = [];
        //     this.comune_sel = null;
        //     console.log("entra filtra area competenza", this.area_filter);

        //     let servizi_tmp = [];
        //     this.servizi_ori.forEach((v) => {
        //         servizi_tmp.push(v);
        //     });

        //     console.log("servizi tmp", servizi_tmp);


        //     if (this.area_filter.length !== 0) {
        //         // Raccogli tutte le province dalle aree che corrispondono al filtro
        //         const province_sel = this.items_area_competenza
        //             .filter(e => this.area_filter.some(a => a.id_zona_master === e.id_zona_master))
        //             .flatMap(e => e.zona_dettagli);

        //         // Filtra i servizi che hanno una località arrivo presente tra le province selezionate
        //         servizi_tmp = servizi_tmp.filter(s =>
        //             province_sel.some(p => p.comune.toUpperCase() == s.localita_arrivo?.toUpperCase())
        //         );
        //         console.log("province sel", province_sel, servizi_tmp);
        //     }


        //     // Ricostruisco i servizi visualizzati in base ai filtri aggiunti.
        //     this.servizi = [];
        //     this.servizi = Array.from(servizi_tmp);
        //     // this.filtra();
        // },
        filtraServOttimizzati() {
            /* Preparo un array temporaneo in cui
             * collezionare i Servizi filtrati */
            let servizi_tmp = [];
            this.items_ottimizzati_ori.forEach((v) => {
                servizi_tmp.push(v);
            });

            if (
                this.conduttore_filter != null && this.items_ottimizzati[0]?.id_gruppo_servizi == 0
            ) {
                console.log("entra dentro filtro conduttore", this.conduttore_filter);

                let res = [];
                servizi_tmp.forEach((e) => {
                    if (e.id_conduttore == this.conduttore_filter) {
                        res.push(e);
                    }
                });

                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
            }

            if (
                this.data_da_filter_ott != null &&
                this.data_a_filter_ott != null
            ) {
                console.log(
                    "entra filtro data??",
                    servizi_tmp,
                    this.data_a_filter_ott
                );

                let res = [];
                servizi_tmp.forEach((e) => {
                    // Verifica se e.data_ora_partenza rientra nell'intervallo di tempo
                    // Converto le date in oggetti moment senza formattarli
                    let data = moment(e.ora_partenza); // Data dell'evento
                    let data_inizio = moment(this.data_da_filter_ott); // Data inizio filtro
                    let data_fine = moment(this.data_a_filter_ott); // Data fine filtro

                    // Confronto le date direttamente senza formattarle come stringhe
                    if (
                        data.isSameOrAfter(data_inizio, "day") &&
                        data.isSameOrBefore(data_fine, "day")
                    ) {
                        res.push(e);
                    }
                });

                // A questo punto `res` contiene tutti gli elementi nell'intervallo di tempo
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
            }

            if (
                this.dataminima_da_filter != null &&
                this.dataminima_a_filter != null
            ) {
                console.log(
                    "entra filtro dataminima??",
                    servizi_tmp,
                    this.dataminima_da_filter
                );

                let res = [];
                servizi_tmp.forEach((e) => {
                    // Verifica se e.data_ora_partenza rientra nell'intervallo di tempo
                    // Converto le date in oggetti moment senza formattarli
                    let data = moment(e.data_minima); // Data dell'evento
                    let data_inizio = moment(this.dataminima_da_filter); // Data inizio filtro
                    let data_fine = moment(this.dataminima_a_filter); // Data fine filtro

                    // Confronto le date direttamente senza formattarle come stringhe
                    if (
                        data.isSameOrAfter(data_inizio, "day") &&
                        data.isSameOrBefore(data_fine, "day")
                    ) {
                        res.push(e);
                    }
                });

                // A questo punto `res` contiene tutti gli elementi nell'intervallo di tempo
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
            }

            // Ricostruisco i servizi visualizzati in base ai filtri aggiunti.
            this.items_ottimizzati = [];
            this.items_ottimizzati = Array.from(servizi_tmp);
        },
        resetFilterAggServizio() {
            this.codice_
        },
        resetFilterTecnico() {
            this.conduttore_filter = null;
            this.filtraServOttimizzati();
            this.items_ottimizzati = Array.from(this.items_ottimizzati_ori);
        },
        resetFilterServizio() {
            this.servizio_filter = [];
            this.servizi = Array.from(this.servizi_ori);
            this.filtra();
        },
        resetFilterArea() {
            this.blocco_filtri = false;
            this.area_filter = [];
            this.servizi = Array.from(this.servizi_ori);
            this.filtra();
        },
        resetFilterRichiesta() {
            this.richiesta_filter = [];
            this.servizi = Array.from(this.servizi_ori);
            this.filtra();
        },
        resetFilterSede() {
            this.sede_magazzino_filter = [];
            this.servizi = Array.from(this.servizi_ori);
            this.filtra();
        },
        getTipoServizi() {
            const gettiposerviziodettagli = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "gettiposerviziodettagli",
                    id_tipo_servizio: null,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", gettiposerviziodettagli).then((res) => {
                this.overlay = false;
                if (res.status === 200 && res.data.result.length != 0) {
                    this.items_dettagli_tipo = [];
                    res.data.result.forEach((e) => {
                        if (
                            e.puo_abbinare_servizi == 1
                        ) {
                            this.items_dettagli_tipo.push(e);
                        }
                    });
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
        },
        filtra2() {
            console.log("entra filtra", this.items_agg_servizio, this.codice_filter);

            /* Preparo un array temporaneo in cui
             * collezionare i Servizi filtrati */
            let servizi_tmp = [];
            this.items_agg_servizio.forEach((v) => {
                servizi_tmp.push(v);
            });

            //Filtro per tecnico
            if (this.tecnico_filter != null) {
                let res = [];
                servizi_tmp.forEach((e) => {
                    if (e.id_conduttore == this.tecnico_filter) {
                        res.push(e);
                    }
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
            }

            //Filtro per località
            // if (this.localita_filter != null) {
            //   let res = [];
            //   servizi_tmp.forEach((e) => {
            //     if (
            //       e.localita_arrivo == this.localita_filter) {
            //       res.push(e);
            //     }
            //   });
            //   servizi_tmp = [];
            //   res.forEach((e) => {
            //     servizi_tmp.push(e);
            //   });
            // }
            if (this.competenza_filter.length != 0) {
                console.log("competenza_filter ");

                let res = [];
                servizi_tmp.forEach((e) => {
                    this.competenza_filter.forEach((s) => {
                        const ids_competenza = s.ids_competenze
                            .split(',')
                            .map(x => Number(x.trim()));

                        if (ids_competenza.includes(Number(e.id_tipo_abilitazioni))) {
                            res.push(e)
                        }


                    });
                });

                res = res.filter(
                    (item, index, self) =>
                        index === self.findIndex(
                            (el) => Number(el.id_servizio) === Number(item.id_servizio)
                        )
                );
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
                console.log("res filtro tipo servizio", res);

            }

            // //Filtro per codice
            if (this.codice_filter != null) {
                console.log("entra filtro codice", this.codice_filter);

                let res = [];
                servizi_tmp.forEach((e) => {
                    if (
                        e.codice_ordine.toUpperCase() == this.codice_filter.toUpperCase()
                    ) {
                        console.log("trova codice");
                        res.push(e);
                    }
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });

            }

            // //Filtro per codice
            // if (this.codice_ordine_filter != null) {
            //   let res = [];
            //   servizi_tmp.forEach((e) => {
            //     if (
            //       e.codice_ordine.toUpperCase() == this.codice_ordine_filter.toUpperCase()
            //     ) {
            //       res.push(e);
            //     }
            //   });
            //   servizi_tmp = [];
            //   res.forEach((e) => {
            //     servizi_tmp.push(e);
            //   });

            // }

            // Ricostruisco i servizi visualizzati in base ai filtri aggiunti.

            servizi_tmp = servizi_tmp.filter((item, index, self) =>
                index === self.findIndex((t) => t.id_servizio === item.id_servizio)
            );
            console.log("servizi filtrati", servizi_tmp);

            this.items_agg_servizio_vis = [];
            this.items_agg_servizio_vis = Array.from(servizi_tmp);
        },
        // metodo che aggiorna l'id_pagamaento_default nelle opzioni dopo aver selezionato
        // l'id_azienda in generaleservizi
        aggiornaTipoPagamentoOpzioni() {
            this.id_pagamento_default =
                this.$refs.createEdit.selected_azienda.id_pagamento;

            if (this.$refs.createDettaglio) {
                this.$refs.createDettaglio.selected_item.id_pagamento =
                    this.id_pagamento_default;
            }
        },
        getStartAndEndOfWeek() {
            const today = new Date();
            const startOfWeek = new Date(today);
            const endOfWeek = new Date(today);

            // Imposta il giorno di inizio della settimana (lunedì)
            const dayOfWeek = today.getDay();
            const diffToMonday = (dayOfWeek + 6) % 7; // 0 per domenica, 1 per lunedì, ...
            startOfWeek.setDate(today.getDate() - diffToMonday);

            // Imposta il giorno di fine della settimana (domenica)
            const diffToSunday = 6 - dayOfWeek; // 0 per domenica
            endOfWeek.setDate(today.getDate() + diffToSunday);

            // Funzione per formattare la data
            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0"); // Aggiungi 1 e formatta a due cifre
                const day = String(date.getDate()).padStart(2, "0"); // Format a due cifre
                return `${year}-${month}-${day}`; // Formato yyyy-MM-dd
            };

            this.data_dal = formatDate(startOfWeek);
            this.data_al = formatDate(endOfWeek);
        },
        // ottimizzaViaggi(arg) {
        //     let blocco_sedi = false;
        //     this.items_sedi_conduttore_vis.forEach((cs) => {
        //         if (cs.default == null) {
        //             this.$refs.SnackbarQV.print(
        //                 "orange",
        //                 "Inserisci le sedi dei conduttore prima di continuare."
        //             );
        //             blocco_sedi = true;
        //         }
        //     });

        //     if (blocco_sedi) return;

        //     let arr = [];
        //     let arr_conduttori = [];
        //     let block = false;

        //     this.items_sedi_conduttore_vis.forEach((c) => {
        //         if (c.selected) {
        //             let obj_con = {
        //                 id_conduttore: c.id_conduttore,
        //                 id_conduttore_sede: c.default.id_conduttore_sede,
        //                 orario_primo_appuntamento: c.ora_primo_arrivo,
        //             };
        //             arr_conduttori.push(obj_con);
        //         }
        //     });

        //     if (this.send_all) {
        //         console.log(
        //             "mando tutto ma dopo aver cambiato almeno un condutroe"
        //         );

        //         this.items_ottimizzati.forEach((e) => {
        //             let obj = {
        //                 id_servizio: e.id_servizio ? e.id_servizio : null,
        //                 id_conduttore_sede: e.id_conduttore_sede,
        //                 id_sede: e.id_sede
        //                     ? e.id_sede
        //                     : e.id_azienda_sede
        //                         ? e.id_azienda_sede
        //                         : null,
        //                 tempo_permanenza: e.tempo_permanenza
        //                     ? e.tempo_permanenza
        //                     : null,
        //                 tempo_attesa: null,
        //                 inizio_attivita:
        //                     moment(e.data_manuale).format("yyyy-MM-DD") +
        //                     " " +
        //                     moment(e.data_manuale).format("HH:mm"),
        //                 ora_arrivo:
        //                     moment(e.ora_arrivo).format("yyyy-MM-DD") +
        //                     " " +
        //                     moment(e.ora_arrivo).format("HH:mm"),
        //                 spostato: e.spostato ? 1 : 0,
        //                 modificato: e.modificato == 1 ? 1 : 0,
        //             };
        //             arr.push(obj);
        //         });
        //     }
        //     if (!this.partenza_sel.data_inizio) {
        //         this.$refs.SnackbarQV.print(
        //             "orange",
        //             "Inserisci una data inizio prima di procedere."
        //         );
        //         return;
        //     }

        //     if (!this.send_all) {
        //         // se aggiungiamo delle tappe o delle pause
        //         this.items_ottimizzati.forEach((e, index) => {
        //             if (e.id_servizio == null && index == 0) {
        //                 block = true;
        //                 this.$refs.SnackbarQV.print(
        //                     "orange",
        //                     "Impossibile ottimizzare. Imposta un servizio come prima tappa."
        //                 );
        //                 return;
        //             }
        //             if (
        //                 (e.tempo_permanenza != null && e.id_servizio != null) ||
        //                 (e.id_sede != null && e.tempo_permanenza != null) ||
        //                 e.id_servizio == null ||
        //                 e.id_sede == null
        //             ) {
        //                 let obj = {
        //                     id_servizio: e.id_servizio ? e.id_servizio : null,
        //                     id_sede: e.id_sede
        //                         ? e.id_sede
        //                         : e.id_azienda_sede
        //                             ? e.id_azienda_sede
        //                             : null,
        //                     id_conduttore_sede: e.id_conduttore_sede,
        //                     tempo_permanenza: e.tempo_permanenza
        //                         ? e.tempo_permanenza
        //                         : null,
        //                     tempo_attesa: e.tempo_attesa
        //                         ? e.tempo_attesa
        //                         : null,
        //                     inizio_attivita:
        //                         moment(e.data_manuale).format("yyyy-MM-DD") +
        //                         " " +
        //                         moment(e.data_manuale).format("HH:mm"),
        //                     ora_arrivo:
        //                         moment(e.ora_arrivo).format("yyyy-MM-DD") +
        //                         " " +
        //                         moment(e.ora_arrivo).format("HH:mm"),
        //                     spostato: e.spostato ? 1 : 0,
        //                     modificato: e.modificato == 1 ? 1 : 0,
        //                 };
        //                 arr.push(obj);
        //             } else {
        //                 this.$refs.SnackbarQV.print(
        //                     "orange",
        //                     "Inserire tempi di permanenza."
        //                 );
        //                 block = true;
        //                 return;
        //             }
        //         });
        //     }
        //     console.log("arr ==>", arr);

        //     if (!block && arr.length != 0) {
        //         this.overlay = true;
        //         this.overlay2 = true;
        //         const richiesta = {
        //             controller: "logistic",
        //             method: "POST",
        //             richiesta: {
        //                 token: localStorage.getItem("user_token"),
        //                 action: "ottimizzaviaggiselezionati",
        //                 tappe: arr,
        //                 conduttori: arr_conduttori,
        //                 data_viaggio: this.partenza_sel.data_inizio,
        //                 ottimizzazione: arg == 2 ? 0 : arg == 1 ? 1 : 0,
        //                 ottimizzazione_manuale: arg == 2 ? 1 : 0,
        //                 id_splitting_mode: this.azione_sel.id_distribuzione,
        //                 equiparazione: this.azione_sel.id_equiparazione,
        //                 id_funzione: this.azione_sel.id_azione,
        //             },
        //         };

        //         this.$store
        //             .dispatch("api", richiesta)
        //             .then((res) => {
        //                 if (res.status == 200 && res.data.result.length != 0) {
        //                     this.ordine_cambiato = false;
        //                     this.items_ottimizzati = res.data.result
        //                         ? res.data.result
        //                         : [];
        //                     this.items_ottimizzati_ori = res.data.result
        //                         ? res.data.result
        //                         : [];
        //                     this.items_ottimizzati.forEach((e, index) => {
        //                         e.numero_marker = index + 1;
        //                         e.tempo_permanenza =
        //                             e.tempo_permanenza != "00:00"
        //                                 ? e.tempo_permanenza
        //                                 : this.items_slot_attesa[2];
        //                         e.ora_partenza =
        //                             e.ora_partenza == null
        //                                 ? moment(
        //                                     this.partenza_sel.data_inizio
        //                                 ).format("yyyy-MM-DD")
        //                                 : e.ora_partenza;
        //                         // e.ora_manuale = moment(e.ora_partenza).format("HH:mm");
        //                         e.data_manuale = moment(e.ora_partenza).format(
        //                             "yyyy-MM-DD HH:mm"
        //                         );
        //                         e.data_minima = e.data_minima != null ? moment(e.data_minima).format("yyyy-MM-DD") : null;
        //                         e.data_imballo = e.data_imballo != null ? moment(e.data_imballo).format("yyyy-MM-DD") : null;
        //                         e.ora_arrivo = moment(e.ora_arrivo).format(
        //                             "yyyy-MM-DD HH:mm"
        //                         );
        //                         if (e.id_servizio == 0) {
        //                             e.id_servizio = null;
        //                         }

        //                         // this.data_a_filter_ott = new Date();
        //                         // let data = new Date(e.ora_partenza);
        //                         // if (data > this.data_a_filter_ott) {
        //                         //   console.log("entra data max");
        //                         //   this.data_a_filter_ott = data;
        //                         // }

        //                         // this.data_a_filter_ott = moment(this.data_a_filter_ott).format("yyyy-MM-DD");
        //                     });
        //                     // this.data_da_filter_ott = moment(this.partenza_sel.data_inizio).format("yyyy-MM-DD")

        //                     this.data_da_filter_ott = new Date();
        //                     this.data_a_filter_ott = new Date();

        //                     this.data_a_filter_ott.setDate(
        //                         this.data_a_filter_ott.getDate() + 7
        //                     );

        //                     this.data_da_filter_ott = moment(
        //                         this.data_da_filter_ott
        //                     ).format("yyyy-MM-DD");
        //                     this.data_a_filter_ott = moment(
        //                         this.data_a_filter_ott
        //                     ).format("yyyy-MM-DD");

        //                     this.dialog_ottimizzati = true;
        //                     this.dialog_gestione_partenza = false;
        //                     this.$refs.SnackbarQV.print(
        //                         "success",
        //                         "Ottimizzazione avvenuta con successo."
        //                     );
        //                     this.overlay = false;
        //                     this.overlay2 = false;
        //                     this.filtraServOttimizzati();
        //                 } else {
        //                     this.overlay = false;
        //                     this.overlay2 = false;
        //                     this.$refs.SnackbarQV.print(
        //                         "orange",
        //                         "Impossibile elaborare i dati con le modifiche richieste."
        //                     );
        //                 }
        //             })
        //             .catch((e) => {
        //                 console.log("entra nel catch?");
        //                 this.overlay = false;
        //                 this.overlay2 = false;
        //                 this.$refs.SnackbarQV.print("error", "Errore: " + e);
        //             });
        //     }
        // },

        // Prima ottimizzazione 
        ottimizzaServiziSelezionati() {
            this.arr_remove = [];
            this.conduttore_filter = null;
            let blocco_sedi = false;
            this.items_sedi_conduttore_vis.forEach((cs) => {
                if (cs.default_partenza == null) {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Inserisci le sedi dei conduttore prima di continuare."
                    );
                    blocco_sedi = true;
                }
            });

            if (blocco_sedi) return;

            let arr = [];
            let arr_conduttori = [];

            this.items_sedi_conduttore_vis.forEach((c) => {
                if (c.selected) {
                    let obj_con = {
                        id_conduttore: c.id_conduttore,
                        id_conduttore_sede_partenza: c.default_partenza.id_conduttore_sede,
                        id_conduttore_sede_arrivo: c.default_arrivo.id_conduttore_sede,
                        orario_primo_appuntamento: c.ora_primo_arrivo,
                    };
                    arr_conduttori.push(obj_con);
                }

            });

            if (this.send_all) {
                this.servizi.forEach((e) => {
                    if (e.provincia_arrivo == "" || e.provincia_arrivo == null || e.localita_arrivo == "" || e.localita_arrivo == null) {
                        this.arr_remove.push(e.codice_ordine);
                        console.log("this.arr_remove", e);
                    }


                    if (e.pianificato == 0) {
                        let obj = {
                            id_servizio: e.id_servizio ? e.id_servizio : null,
                            id_conduttore_sede: e.id_conduttore_sede,
                            id_sede: e.id_sede
                                ? e.id_sede
                                : e.id_azienda_sede
                                    ? e.id_azienda_sede
                                    : null,
                            tempo_permanenza: e.tempo_permanenza
                                ? e.tempo_permanenza
                                : null,
                            tempo_attesa: null,
                            nuovo: e.nuovo,
                        };
                        arr.push(obj);
                    }
                });
            }

            if (!this.partenza_sel.data_inizio) {
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserisci una data inizio prima di procedere."
                );
                return;
            }

            if (!this.send_all) {
                this.dialog_gestione_partenza = false;
                this.array_selezionati.forEach((e) => {
                    if (e.provincia_arrivo == "" || e.provincia_arrivo == null || e.localita_arrivo == "" || e.localita_arrivo == null) {
                        this.arr_remove.push(e.codice_ordine);
                        console.log("this.arr_remove", e);
                    }

                    let obj = {
                        id_servizio: e.id_servizio ? e.id_servizio : null,
                        id_conduttore_sede: e.id_conduttore_sede,
                        id_sede: e.id_sede
                            ? e.id_sede
                            : e.id_azienda_sede
                                ? e.id_azienda_sede
                                : null,
                        tempo_permanenza: e.tempo_permanenza
                            ? e.tempo_permanenza
                            : null,
                        tempo_attesa: null,
                    };
                    console.log(e.tempo_permanenza);
                    arr.push(obj);
                });
            }
            if (arr.length != 0) {

                this.overlay = true;
                this.overlay2 = true;
                const richiesta = {
                    controller: "logistic",
                    method: "POST",
                    richiesta: {
                        token: localStorage.getItem("user_token"),
                        action: "ottimizzaviaggiselezionati",
                        tappe: arr,
                        conduttori: arr_conduttori,
                        data_viaggio: this.partenza_sel.data_inizio,
                        ottimizzazione: 1,
                        ottimizzazione_manuale: 0,
                        id_splitting_mode: this.azione_sel.id_distribuzione,
                        equiparazione: this.azione_sel.id_equiparazione,
                        id_funzione: this.azione_sel.id_azione,
                    },
                };

                this.$store
                    .dispatch("api", richiesta)
                    .then((res) => {
                        if (res.status == 200 && res.data.result.length != 0) {
                            this.ordine_cambiato = false;
                            this.items_ottimizzati = res.data.result
                                ? res.data.result
                                : [];
                            this.items_ottimizzati_ori = res.data.result
                                ? res.data.result
                                : [];

                            this.items_ottimizzati.forEach((e, index) => {
                                if (e.latitudine_arrivo == null || e.latitudine_partenza == null) {
                                    this.arr_remove.push(e.codice_ordine);
                                }
                                e.numero_marker = index + 1;
                                e.tempo_permanenza =
                                    e.tempo_permanenza != "00:00"
                                        ? e.tempo_permanenza
                                        : this.items_slot_attesa[2];
                                e.ora_partenza =
                                    e.ora_partenza == null
                                        ? moment(
                                            this.partenza_sel.data_inizio
                                        ).format("yyyy-MM-DD")
                                        : e.ora_partenza;
                                // e.ora_manuale = moment(e.ora_partenza).format("HH:mm");
                                e.data_manuale = moment(e.ora_partenza).format(
                                    "yyyy-MM-DD HH:mm"
                                );
                                e.data_minima = e.data_minima != null ? moment(e.data_minima).format("yyyy-MM-DD") : null;
                                e.data_imballo = e.data_imballo != null ? moment(e.data_imballo).format("yyyy-MM-DD") : null;
                                // e.ora_arrivo = moment(e.ora_arrivo).format(
                                //     "yyyy-MM-DD HH:mm"
                                // );

                                if (e.tempo_permanenza) {
                                    e.tempo_permanenza =
                                        e.tempo_permanenza.split(":")[0] +
                                        ":" +
                                        e.tempo_permanenza.split(":")[1];
                                    console.log(e.tempo_permanenza);
                                }
                                if (e.id_servizio == 0) {
                                    e.id_servizio = null;
                                }

                                // this.data_a_filter_ott = new Date();
                                // let data = new Date(e.ora_partenza);
                                // if (data > this.data_a_filter_ott) {
                                //   console.log("entra data max");
                                //   this.data_a_filter_ott = data;
                                // }

                                // this.data_a_filter_ott = moment(this.data_a_filter_ott).format("yyyy-MM-DD");
                            });


                            this.data_da_filter_ott = new Date();
                            this.data_a_filter_ott = new Date();
                            this.items_ottimizzati_ori.forEach(e => {
                                let data = new Date(e.ora_partenza);
                                if (data < this.data_da_filter_ott) {
                                    this.data_da_filter_ott = data;
                                }
                                if (data > this.data_a_filter_ott) {
                                    console.log("entra data max");
                                    this.data_a_filter_ott = data;
                                }
                            });
                            this.data_da_filter_ott = moment(this.data_da_filter_ott).format("yyyy-MM-DD");
                            this.data_a_filter_ott = moment(this.data_a_filter_ott).format("yyyy-MM-DD");

                            // this.data_a_filter_ott.setDate(
                            //     this.data_a_filter_ott.getDate() + 7
                            // );

                            // this.data_da_filter_ott = moment(
                            //     this.data_da_filter_ott
                            // ).format("yyyy-MM-DD");
                            // this.data_a_filter_ott = moment(
                            //     this.data_a_filter_ott
                            // ).format("yyyy-MM-DD");

                            // this.data_da_filter_ott = moment(this.partenza_sel.data_inizio).format("yyyy-MM-DD")

                            this.dialog_ottimizzati = true;
                            this.dialog_gestione_partenza = false;



                            this.$refs.SnackbarQV.print(
                                "success",
                                "Ottimizzazione avvenuta con successo."
                            );
                            this.overlay = false;
                            this.overlay2 = false;
                            this.filtraServOttimizzati();

                            if (this.arr_remove.length != 0) {
                                this.dialog_servizi_romossi = true;
                                console.log("this.arr_remove", this.arr_remove);

                            }
                        } else {
                            this.overlay = false;
                            this.overlay2 = false;
                            this.$refs.SnackbarQV.print(
                                "orange",
                                "Impossibile elaborare i dati con le modifiche richieste."
                            );
                        }

                        this.errore_sel = res.data.logAttivita || null;
                        if (this.errore_sel.length != 0) this.dialog_error = true;
                        this.dialog_conferma_ott = false;
                    })
                    .catch(() => {
                        this.overlay = false;
                        this.overlay2 = false;
                        // this.$refs.SnackbarQV.print("error", "Errore: " + e);
                        if (this.errore_sel.length != 0) this.dialog_error = true;
                        this.dialog_conferma_ott = false;

                    });
            } else {
                this.overlay = false;
                this.overlay2 = false;
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Non ci sono servizi da pianificare disponibili."
                );
                this.dialog_gestione_partenza = false;
            }
        },
        ottimizzaGruppoViaggi() {
            let arr = [];
            let block = false;
            let arr_conduttori = [];
            if (this.btn_ottimizzazione == 3) {
                let conduttore = this.items_sedi_conduttore.filter(e => e.id_conduttore == this.items_ottimizzati[0].id_conduttore)[0];
                let obj_con = {
                    id_conduttore: conduttore.id_conduttore,
                    id_conduttore_sede_partenza: conduttore.default_partenza.id_conduttore_sede,
                    id_conduttore_sede_arrivo: conduttore.default_arrivo.id_conduttore_sede,
                    orario_primo_appuntamento: conduttore.ora_primo_arrivo,
                };
                arr_conduttori.push(obj_con);
            } else {
                this.items_sedi_conduttore_vis.forEach((c) => {
                    if (c.selected) {
                        let obj_con = {
                            id_conduttore: c.id_conduttore,
                            id_conduttore_sede_partenza: c.default_partenza.id_conduttore_sede,
                            id_conduttore_sede_arrivo: c.default_arrivo.id_conduttore_sede,
                            orario_primo_appuntamento: c.ora_primo_arrivo,
                        };
                        arr_conduttori.push(obj_con);
                    }

                });
            }




            this.items_ottimizzati.forEach((e, index) => {
                if (e.id_servizio == null && index == 0) {
                    block = true;
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Impossibile ottimizzare. Imposta un servizio come prima tappa."
                    );
                    return;
                }
                if (
                    (e.tempo_permanenza != null && e.id_servizio != null) ||
                    (e.id_sede != null && e.tempo_permanenza != null) ||
                    e.id_servizio == null ||
                    e.id_sede == null
                ) {
                    let obj = {
                        id_servizio: e.id_servizio ? e.id_servizio : null,
                        id_sede: e.id_sede
                            ? e.id_sede
                            : e.id_azienda_sede
                                ? e.id_azienda_sede
                                : null,
                        tempo_permanenza: e.tempo_permanenza
                            ? e.tempo_permanenza
                            : null,
                        tempo_attesa: e.tempo_attesa ? e.tempo_attesa : null,
                        id_conduttore_sede: e.id_conduttore_sede,
                        inizio_attivita:
                            moment(e.data_manuale).format("yyyy-MM-DD") +
                            " " +
                            moment(e.data_manuale).format("HH:mm"),
                        ora_arrivo:
                            moment(e.ora_arrivo).format("yyyy-MM-DD") +
                            " " +
                            moment(e.ora_arrivo).format("HH:mm"),
                        spostato: e.spostato ? 1 : 0,
                        modificato: e.modificato == 1 ? 1 : 0,
                        nuovo: e.nuovo,
                    };
                    console.log(e.tempo_permanenza);
                    arr.push(obj);
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Inserire tempi di permanenza."
                    );
                    block = true;
                    return;
                }
            });

            if (!block && arr.length != 0) {
                this.overlay2 = true;
                this.overlay = true;
                const richiesta = {
                    controller: "logistic",
                    method: "POST",
                    richiesta: {
                        token: localStorage.getItem("user_token"),
                        action: "ottimizzaviaggiselezionati",
                        tappe: arr,
                        conduttori: arr_conduttori,
                        data_viaggio: this.items_ottimizzati[0].ora_partenza,
                        ottimizzazione: this.btn_ottimizzazione == 3 ? 0 : this.btn_ottimizzazione == 4 ? 1 : 0,
                        ottimizzazione_manuale: this.btn_ottimizzazione == 1 ? 1 : this.btn_ottimizzazione == 3 ? 0 : this.btn_ottimizzazione == 4 ? 0 : this.btn_ottimizzazione == 2 ? 1 : 0,
                        id_splitting_mode: this.azione_sel.id_distribuzione,
                        equiparazione: this.azione_sel.id_equiparazione,
                        id_funzione: this.azione_sel.id_azione,
                    },
                };

                this.$store
                    .dispatch("api", richiesta)
                    .then((res) => {
                        this.overlay2 = false;
                        this.overlay = false;
                        if (res.status == 200 && res.data.result.length != 0) {
                            this.ordine_cambiato = false;
                            this.items_ottimizzati = res.data.result;
                            this.items_ottimizzati_ori = res.data.result;
                            this.items_ottimizzati.forEach((e, index) => {

                                if (e.tempo_permanenza) {

                                    e.tempo_permanenza =
                                        e.tempo_permanenza.split(":")[0] +
                                        ":" +
                                        e.tempo_permanenza.split(":")[1];
                                    console.log(e.tempo_permanenza);
                                }

                                e.numero_marker = index + 1;
                                e.data_manuale = moment(e.ora_partenza).format(
                                    "yyyy-MM-DD HH:mm"
                                );
                                e.data_minima = e.data_minima != null ? moment(e.data_minima).format("yyyy-MM-DD") : null;
                                e.data_imballo = e.data_imballo != null ? moment(e.data_imballo).format("yyyy-MM-DD") : null;
                                e.ora_arrivo = moment(e.ora_arrivo).format(
                                    "yyyy-MM-DD HH:mm"
                                );
                            });
                            this.dialog_ottimizzati = true;
                            this.dialog_gestione_partenza = false;
                            this.$refs.SnackbarQV.print(
                                "success",
                                "Ottimizzazione avvenuta con successo."
                            );
                            this.filtraServOttimizzati();
                            this.errore_sel = res.data.logAttivita || null;
                            if (this.errore_sel.length != 0) this.dialog_error = true;
                            this.dialog_conferma_ott = false;
                        } else {
                            this.overlay = false;
                            this.overlay2 = false;
                            this.$refs.SnackbarQV.print(
                                "orange",
                                "Nessun dato presente, non è stato possibile caricare i dati."
                            );

                        }
                    })
                    .catch(() => {
                        this.overlay = false;
                        this.overlay2 = false;
                        if (this.errore_sel.length != 0) this.dialog_error = true;
                        this.dialog_conferma_ott = false;
                    });
            } else {
                this.overlay = false;
                this.overlay2 = false;
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Errore di comunicazione col server, non è stato possibile caricare i dati."
                );
            }
        },
        getSlotAttesa() {
            const richiesta = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getslotattesa",
                },
            };

            this.$store
                .dispatch("api", richiesta)
                .then((res) => {
                    if (res.status == 200) {
                        console.log("res attesa", res);
                        this.items_slot_attesa = res.data.result;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((e) => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print("error", "Errore: " + e);
                });
        },
        resetFiltriOtt() {
            this.dataminima_da_filter = null;
            this.dataminima_a_filter = null;
            this.data_a_filter_ott = null;
            this.data_da_filter_ott = null;
            this.filtraServOttimizzati();
        },
        resetFiltri() {
            this.regione_sel = [];
            this.provincia_sel = [];
            this.comune_sel = null;
            this.data_inizio_filter = null;
            this.codice_filter = null;
            this.data_minima_da_filter = null;
            this.data_minima_a_filter = null;
            this.codice_ordine_filter = null;
            this.solo_non_pianificati = 2;
            this.ragionesociale_filter = null;
            this.tecnico_sel = null;
            this.tecnico_filter = null;
            this.localita_filter = null;
            this.area_filter = [];
            this.servizio_filter = [];
            this.servizi = Array.from(this.servizi_ori);
        },
        indietro() {
            this.dialog_ottimizzati = false;
            this.mode_pianificazione = false;
            this.servizi_gruppo_viaggio = false;
            this.dialog_gestione_partenza = true;
            this.conduttore_filter = null;
            this.resetFiltriOtt();
            // this.data_da_filter_ott = moment().format("yyyy-MM-DD");
            // this.data_a_filter_ott = moment().format("yyyy-MM-DD");
            this.overlay = false;
            this.overlay2 = false;
        },
        goBack() {
            // torna alla home di quicklogistic
            this.$router.push("/home/quicklogistic");
        },
        getAllineaAnagrafiche() {
            const richiesta = {
                controller: "wsecogreen",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "syncanagrafiche",
                },
            };
            this.overlay = true;
            this.$store
                .dispatch("api", richiesta)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200 || res.status == 204) {
                        let record_aggiornati = res.data.record_aggiornati
                            ? res.data.record_aggiornati
                            : 0;
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Anagrafiche allineate: " + record_aggiornati
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((e) => {
                    this.$refs.SnackbarQV.print("error", "Errore: " + e);
                });
        },
        selezionaAssocia(arg) {
            this.servizi_suggeriti.forEach((e) => {
                if (arg.id_servizio == e.id_servizio) {
                    e.selezionato = !e.selezionato;
                } else {
                    e.selezionato = false;
                }
            });
            this.$forceUpdate();
        },
        stampaReport() {
            console.log("from_viaggio_servizio", this.from_viaggio_servizio);

            this.overlay = true;
            let request = {
                controller: "Report",
                method: "POST",
                richiesta: {
                    action: "getreportpdf",
                    token: localStorage.getItem("user_token"),
                    cod_report: "FQ - Servizi tecnico",
                    parametri: [
                        {
                            parametro: "@id_gruppo_servizi",
                            valore: this.from_viaggio_servizio == false ? 0 : this.items_ottimizzati[0].id_gruppo_servizi,
                        },
                        {
                            parametro: "@id_tecnico",
                            valore: this.from_viaggio_servizio == false ? this.tecnico_sel : 0,
                        },
                        {
                            parametro: "@data1",
                            valore: this.from_viaggio_servizio == false ? "'" + this.data_da_filter_ott + "'" : 0,
                        },
                        {
                            parametro: "@data2",
                            valore: this.from_viaggio_servizio == false ? "'" + this.data_a_filter_ott + "'" : 0,
                        },
                    ],
                },
            };
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (
                        "tipo_messaggio" in res.data &&
                        "query_messaggio" in res.data &&
                        res.data.tipo_messaggio == 1
                    ) {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            res.data.query_messaggio
                        );
                    }
                    const byteCharacters = atob(res.data.result);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], {
                        type: "application/pdf",
                    });
                    const blobUrl = URL.createObjectURL(blob);
                    this.selected_pdf = blobUrl;
                    this.pdf_dialog_ott = true;
                })
                .catch((err) => {
                    if (
                        "tipo_messaggio" in err.response.data &&
                        "query_messaggio" in err.response.data &&
                        err.response.data.tipo_messaggio == 2
                    ) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            err.response.data.query_messaggio
                        );
                    } else {
                        this.$refs.SnackbarQV.print("error", "Errore: " + err);
                    }
                });

            this.overlay = false;
        },
        showAllegato(item) {
            this.input_args = {
                id_utente: localStorage.id,
                id_riferimento: item.id_commessa,
                cod_riferimento: "commessa",
                pk_riferimento: "id_commessa",
            };
            this.window_frame_allegati_visible = true;
        },
        showNote(item) {
            this.nota_sel = item.note;
            this.dialog_note = true;
        },
    },
    created() {
        this.pageChange(1);
        this.getServizi();
        this.getAutisti();
        this.getConfig();
        this.getSedi();
        this.getSediMagazzino();
        this.getZone();
        this.getRegioni();
        this.getSlotAttesa();
        this.getStartAndEndOfWeek();
        this.getTipoServizi();
    },
    mounted() { },
};
</script>

<style scoped>
.table-container {
    margin-top: -25px;
    position: relative;
    /* height: 70vh; */
    overflow-y: hidden;
    overflow-x: hidden;
    white-space: nowrap;
}

/* Per Chrome, Edge, Safari */
.table-container::-webkit-scrollbar:horizontal {
    height: 12px;
    /* spessore */
}

.table-container::-webkit-scrollbar-thumb:horizontal {
    background: #4c75af;
    /* colore del cursore */
    border-radius: 6px;
}

.table-container::-webkit-scrollbar-track:horizontal {
    background: #e0e0e0;
    /* colore del binario */
}

/* Per Firefox */
.table-container {
    scrollbar-width: thin;
    /* dimensione */
    scrollbar-color: #4c75af #e0e0e0;
    /* thumb track */
}

.fixed-column-table {
    display: block;
    overflow-x: auto;
    max-width: 100%;
}

.fixed-column-table td.sticky-col {
    position: sticky;
    left: 0;
    background: linear-gradient(0deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0) 100%);
    backdrop-filter: blur(22px);
    -webkit-backdrop-filter: blur(22px);
    filter: brightness(0.95);
    /* Colore coerente con lo sfondo */
    z-index: 2;
}

.drag-ghost {
    opacity: 0.5;
    background: #bbdefb !important;
}

.drag-chosen {
    background: #90caf9 !important;
}

.riga-spostata {
    border: 2px solid red !important;
    background-color: #ffebee;
    /* leggero rosato per evidenza */
}

.selected-row {
    background-color: #1786d575 !important;
}
</style>
